(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("aps", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["aps"] = factory(require("react"), require("react-dom"));
	else
		root["aps"] = factory(root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_40__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 105);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var req = __webpack_require__(144);
req.keys().forEach(function (key) {
  var info = /^\.\/([a-z0-9\-]+)\.js$/i.exec(key);
  if (!info || !info[1] || info[1] == 'index') return;
  exports[info[1]] = req(key);
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(133);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(139)();
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var req = __webpack_require__(112);
req.keys().forEach(function (key) {
  var info = /^\.\/([a-z0-9\-]+)\/index\.js$/i.exec(key);
  if (!info) return;
  exports[info[1]] = req(key);
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(54)('wks');
var uid = __webpack_require__(43);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(9);
var ctx = __webpack_require__(35);
var hide = __webpack_require__(19);
var has = __webpack_require__(20);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(114);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(71);
var toPrimitive = __webpack_require__(50);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(26)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(42);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(73);
var defined = __webpack_require__(51);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(117);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(80);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _keys = __webpack_require__(30);

var _keys2 = _interopRequireDefault(_keys);

var _utils = __webpack_require__(24);

var _utils2 = _interopRequireDefault(_utils);

var _$config = __webpack_require__(62);

var _$config2 = _interopRequireDefault(_$config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function create(prefix) {

  function convert(name, addPrefix, literal) {
    if (!name) {
      return '';
    } else if (_utils2.default.isString(name) && name.includes(' ')) {
      return convert(name.split(' '), addPrefix);
    } else if (_utils2.default.isString(name) && name.includes(',')) {
      return convert(name.split(','), addPrefix);
    } else if (_utils2.default.isArray(name)) {
      return name.map(function (item) {
        return convert(item, addPrefix);
      }).join(' ').trim();
    } else if (_utils2.default.isObject(name)) {
      return convert((0, _keys2.default)(name).filter(function (key) {
        return name[key];
      }), addPrefix);
    } else if (_utils2.default.startWith(name, prefix)) {
      return name;
    } else {
      var trimedName = literal ? name : name.trim().replace(/([A-Z])/g, '-$1').toLowerCase();
      if (!trimedName) return '';
      return addPrefix ? prefix + '-' + trimedName : trimedName;
    }
  }

  function cname(name, literal) {
    if (literal === true || literal === false) {
      return convert(name, literal);
    } else {
      var convertNames = convert(name, true);
      if (literal) {
        convertNames += ' ' + convert(literal, false, true);
      }
      return convertNames;
    }
  }

  return cname;
}

var func = create(_$config2.default.name);
func.create = create;

exports.default = func;
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _for = __webpack_require__(148);

var _for2 = _interopRequireDefault(_for);

var _symbol = __webpack_require__(80);

var _symbol2 = _interopRequireDefault(_symbol);

var _ntils = __webpack_require__(45);

var _ntils2 = _interopRequireDefault(_ntils);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSFORM_MATRIX = /matrix\([\-\.\d]+, [\-\.\d]+, [\-\.\d]+, [\-\.\d]+, ([\-\.\d]+), ([\-\.\d]+)\)/;

//检查是否是一个 React 组件
_ntils2.default.isComponent = function (obj) {
  return obj instanceof _react2.default.Component;
};

//检查是否是 JSX 元素
_ntils2.default.isReactElement = function (obj) {
  if (!obj || !_ntils2.default.isObject(obj)) return false;
  if (typeof _symbol2.default === 'function' && _for2.default && (0, _for2.default)('react.element') == obj.$$typeof) {
    return true;
  }
  return '$$typeof' in obj && (obj.$$typeof.toString() == 'Symbol(react.element)' || obj.$$typeof.toString() === '60103');
};

_ntils2.default.getStyle = function (element) {
  return window.getComputedStyle ? window.getComputedStyle(element, null) : element.currentStyle;
};

_ntils2.default.getTransformOffset = function (element) {
  var offset = { left: 0, top: 0 };
  var transform = this.getStyle(element).transform;
  var offsetInfo = TRANSFORM_MATRIX.exec(transform);
  if (offsetInfo && offsetInfo.length > 2) {
    offset = {
      left: parseInt(offsetInfo[1]),
      top: parseInt(offsetInfo[2])
    };
  }
  var parentElement = element.parentElement;
  if (parentElement && parentElement != document.body) {
    var parentOffset = this.getTransformOffset(parentElement);
    offset.left += parentOffset.left;
    offset.top += parentOffset.top;
    offset.top -= parentElement.scrollTop;
    offset.left -= parentElement.scrollLeft;
  }
  return offset;
};

//获取一个元素的 offset
_ntils2.default.getPositionOffset = function (element, opts) {
  opts = (0, _assign2.default)({}, opts);
  if (element == document.body) {
    return { left: 0, top: 0, width: 0, height: 0 };
  }
  var offset = {
    left: parseInt(element.offsetLeft || 0),
    top: parseInt(element.offsetTop || 0)
  };
  if (opts.parent !== false && element.offsetParent) {
    var parentStyle = this.getStyle(element.offsetParent);
    offset.left += parseInt(parentStyle.borderLeftWidth || 0);
    offset.top += parseInt(parentStyle.borderTopWidth || 0);
    var parentOffset = this.getPositionOffset(element.offsetParent, opts);
    offset.left += parentOffset.left;
    offset.top += parentOffset.top;
  }
  (0, _assign2.default)(offset, {
    left: offset.left || 0,
    top: offset.top || 0,
    width: element.offsetWidth || 0,
    height: element.offsetHeight || 0
  });
  return offset;
};

_ntils2.default.getOffset = function (element, opts) {
  opts = (0, _assign2.default)({}, opts);
  var positionOffset = this.getPositionOffset(element, opts);
  if (opts.transform !== false) {
    var transformOffset = this.getTransformOffset(element, opts);
    positionOffset.left += transformOffset.left;
    positionOffset.top += transformOffset.top;
  }
  return positionOffset;
};

//获取窗口大小
_ntils2.default.getWindowSize = function () {
  var size = {};
  // 获取窗口宽度
  if (window.innerWidth) size.width = window.innerWidth;else if (document.body && document.body.clientWidth) size.width = document.body.clientWidth;
  // 获取窗口高度
  if (window.innerHeight) size.height = window.innerHeight;else if (document.body && document.body.clientHeight) size.height = document.body.clientHeight;
  // 通过深入 Document 内部对 body 进行检测，获取窗口大小
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    size.height = document.documentElement.clientHeight;
    size.width = document.documentElement.clientWidth;
  }
  return size;
};

_ntils2.default.isFixed = function (element) {
  if (!this.isElement(element)) return false;
  var style = this.getStyle(element);
  if (style.position == 'fixed') return true;
  if (element.parentNode) return this.isFixed(element.parentNode);
  return false;
};

//通过 type 查找 jsx 元素
_ntils2.default.findChildren = function (type, children) {
  var result = [];
  _react2.default.Children.forEach(children, function (child) {
    if (!child) return;
    if (!type || child.type == type) result.push(child);
  });
  return result;
};

//去重，元素是object的话通过key去重
_ntils2.default.filterDuplicate = function (list) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

  var out = [];
  var values = [];

  if (list && _ntils2.default.isArray(list) && list.length) {
    list.forEach(function (item) {
      if (out && out.length) {
        if (values.indexOf(typeof item === 'string' ? item : item[key]) === -1) {
          out.push(item);
        }
        values.push(typeof item === 'string' ? item : item[key]);
      } else {
        values.push(typeof item === 'string' ? item : item[key]);
        out.push(item);
      }
    });
  }
  return out;
};

/**
 * dom是否包含其他元素
 * 
 * @param {Element} container 容器
 * @param {Element} element        子元素
 * @return {Boolean} 是否包含
 */
_ntils2.default.inContainer = function (container, element) {
  if (!container || !element) return false;
  if (_ntils2.default.isComponent(container)) container = container.domNode;
  if (_ntils2.default.isString(container)) container = document.querySelector(container);
  if (_ntils2.default.isComponent(element)) element = element.domNode;
  if (_ntils2.default.isString(element)) element = document.querySelector(element);
  if (container.compareDocumentPosition) return container === element || !!(container.compareDocumentPosition(element) & 16);
  if (container.contains && element.nodeType === 1) {
    return container.contains(element) && container !== element;
  }
  while (element = element.parentNode) {
    if (element === container) return true;
  }return false;
};

_ntils2.default.arrayRange = function (size) {
  return Array.apply(null, Array(size)).map(function (_, i) {
    return i;
  });
};

exports.default = _ntils2.default;
module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(72);
var enumBugKeys = __webpack_require__(55);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(137), __esModule: true };

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(61);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(40);

var _console = __webpack_require__(85);

var console = _interopRequireWildcard(_console);

var _cname = __webpack_require__(23);

var _cname2 = _interopRequireDefault(_cname);

var _common = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComBase = function (_React$Component) {
  (0, _inherits3.default)(ComBase, _React$Component);

  function ComBase() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ComBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.console = console, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  ComBase.prototype.render = function render() {
    return _react2.default.createElement('span', { className: (0, _cname2.default)('state-hidden') });
  };

  ComBase.prototype.findDOMNode = function findDOMNode(ref) {
    return (0, _reactDom.findDOMNode)(ref);
  };

  ComBase.prototype.findChildren = function findChildren(type, children) {
    return _common.utils.findChildren(type, children || this.props.children);
  };

  (0, _createClass3.default)(ComBase, [{
    key: 'domNode',
    get: function get() {
      try {
        return this.findDOMNode(this);
      } catch (ex) {
        //eslint-disable-line
        return null;
      }
    }
  }]);
  return ComBase;
}(_react2.default.Component);

exports.default = ComBase;
module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; //组件样式


__webpack_require__(173);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Icon, _ComBase);

  function Icon() {
    (0, _classCallCheck3.default)(this, Icon);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        type = _props.type,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        spin = _props.spin;

    var classString = (0, _common.cname)((_cname = {
      icon: true,
      aniTransition: true,
      widget: true
    }, _cname['icon-' + type] = true, _cname.iconSpin = !!spin || type === 'loading', _cname), className);
    return _react2.default.createElement('i', (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: classString }));
  };

  return Icon;
}(_common.ComBase), _class.defaultProps = {
  spin: false
}, _class.propTypes = {
  /** 图标类型: 见下方图标示例 */
  type: _propTypes2.default.string.isRequired,
  /** 是否有旋转动画  */
  spin: _propTypes2.default.bool,
  /** 设置图标的样式，例如 `fontSize` 和 `color` */
  style: _propTypes2.default.object
}, _temp);
exports.default = Icon;
module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(176);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateEntity = function () {
  function DateEntity(value) {
    (0, _classCallCheck3.default)(this, DateEntity);

    if (value instanceof DateEntity) {
      return new DateEntity(value.value);
    } else if (_common.utils.isDate(value)) {
      this.value = new Date(value);
    } else if (_common.utils.isString(value) || _common.utils.isNumber(value)) {
      this.value = new Date(value);
    } else if (_common.utils.isObject(value)) {
      var _value$year = value.year,
          year = _value$year === undefined ? 1970 : _value$year,
          _value$month = value.month,
          month = _value$month === undefined ? 1 : _value$month,
          _value$date = value.date,
          date = _value$date === undefined ? 1 : _value$date,
          _value$hours = value.hours,
          hours = _value$hours === undefined ? 0 : _value$hours,
          _value$minutes = value.minutes,
          minutes = _value$minutes === undefined ? 0 : _value$minutes,
          _value$seconds = value.seconds,
          seconds = _value$seconds === undefined ? 0 : _value$seconds;

      this.value = new Date(year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds);
    } else {
      this.value = new Date();
    }
  }

  DateEntity.prototype.addDay = function addDay(num) {
    this.date += num;
    return this;
  };

  DateEntity.prototype.addMonth = function addMonth(num) {
    this.date = 1;
    this.month += num;
    return this;
  };

  DateEntity.prototype.addYear = function addYear(num) {
    this.year += num;
    return this;
  };

  DateEntity.prototype.format = function format(str) {
    str = str || 'yyyy-MM-dd hh:mm:ss';
    return _common.utils.formatDate(this.value, str);
  };

  DateEntity.prototype.toString = function toString(str) {
    return this.format(str);
  };

  (0, _createClass3.default)(DateEntity, [{
    key: 'year',
    get: function get() {
      return this.value.getFullYear();
    },
    set: function set(value) {
      this.value.setFullYear(value);
    }
  }, {
    key: 'month',
    get: function get() {
      return this.value.getMonth() + 1;
    },
    set: function set(value) {
      this.value.setMonth(value - 1);
    }
  }, {
    key: 'date',
    get: function get() {
      return this.value.getDate();
    },
    set: function set(value) {
      this.value.setDate(value);
    }
  }, {
    key: 'hours',
    get: function get() {
      return this.value.getHours();
    },
    set: function set(value) {
      this.value.setHours(value);
    }
  }, {
    key: 'minutes',
    get: function get() {
      return this.value.getMinutes();
    },
    set: function set(value) {
      this.value.setMinutes(value);
    }
  }, {
    key: 'seconds',
    get: function get() {
      return this.value.getSeconds();
    },
    set: function set(value) {
      this.value.setSeconds(value);
    }
  }, {
    key: 'milliseconds',
    get: function get() {
      return this.value.getMilliseconds();
    },
    set: function set(value) {
      this.value.setMilliseconds(value);
    }
  }, {
    key: 'day',
    get: function get() {
      return this.value.getDay();
    },
    set: function set(value) {
      this.value.setDay(value);
    }
  }]);
  return DateEntity;
}();

exports.default = DateEntity;
module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(41);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_40__;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(20);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

(function (ntils) {

  /**
   * 空函数
   */
  ntils.noop = function () { };

  /**
   * 验证一个对象是否为NULL
   * @method isNull
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isNull = function (obj) {
    return obj === null || typeof obj === "undefined";
  };

  /**
   * 除去字符串两端的空格
   * @method trim
   * @param  {String} str 源字符串
   * @return {String}     结果字符串
   * @static
   */
  ntils.trim = function (str) {
    if (this.isNull(str)) return str;
    if (str.trim) {
      return str.trim();
    } else {
      return str.replace(/(^[\\s]*)|([\\s]*$)/g, "");
    }
  };

  /**
   * 替换所有
   * @method replace
   * @param {String} str 源字符串
   * @param {String} str1 要替换的字符串
   * @param {String} str2 替换为的字符串
   * @static
   */
  ntils.replace = function (str, str1, str2) {
    if (this.isNull(str)) return str;
    return str.replace(new RegExp(str1, 'g'), str2);
  };

  /**
   * 从字符串开头匹配
   * @method startWith
   * @param {String} str1 源字符串
   * @param {String} str2 要匹配的字符串
   * @return {Boolean} 匹配结果
   * @static
   */
  ntils.startWith = function (str1, str2) {
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) === 0;
  };

  /**
   * 是否包含
   * @method contains
   * @param {String} str1 源字符串
   * @param {String} str2 检查包括字符串
   * @return {Boolean} 结果
   * @static
   */
  ntils.contains = function (str1, str2) {
    var self = this;
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) > -1;
  };

  /**
   * 从字符串结束匹配
   * @method endWidth
   * @param {String} str1 源字符串
   * @param {String} str2 匹配字符串
   * @return {Boolean} 匹配结果
   * @static
   */
  ntils.endWith = function (str1, str2) {
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) === (str1.length - str2.length);
  };

  /**
   * 是否包含属性
   * @method hasProperty
   * @param  {Object}  obj  对象
   * @param  {String}  name 属性名
   * @return {Boolean}      结果
   * @static
   */
  ntils.has = ntils.hasProperty = function (obj, name) {
    if (this.isNull(obj) || this.isNull(name)) return false;
    return (name in obj) || (obj.hasOwnProperty(name));
  };

  /**
   * 验证一个对象是否为Function
   * @method isFunction
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isFunction = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === "function";
  };

  /**
   * 验证一个对象是否为String
   * @method isString
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isString = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'string' || obj instanceof String;
  };

  /**
   * 验证一个对象是否为Number
   * @method isNumber
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isNumber = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'number' || obj instanceof Number;
  };

  /**
   * 验证一个对象是否为Boolean
   * @method isBoolean
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isBoolean = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'boolean' || obj instanceof Boolean;
  };

  /**
   * 验证一个对象是否为HTML Element
   * @method isElement
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isElement = function (obj) {
    if (this.isNull(obj)) return false;
    if (window.Element) {
      return obj instanceof Element;
    } else {
      return (obj.tagName && obj.nodeType && obj.nodeName && obj.attributes && obj.ownerDocument);
    }
  };

  /**
   * 验证一个对象是否为HTML Text Element
   * @method isText
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isText = function (obj) {
    if (this.isNull(obj)) return false;
    return obj instanceof Text;
  };

  /**
   * 验证一个对象是否为Object
   * @method isObject
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isObject = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === "object";
  };

  /**
   * 验证一个对象是否为Array或伪Array
   * @method isArray
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isArray = function (obj) {
    if (this.isNull(obj)) return false;
    var v1 = Object.prototype.toString.call(obj) === '[object Array]';
    var v2 = obj instanceof Array;
    var v3 = !this.isString(obj) && this.isNumber(obj.length) && this.isFunction(obj.splice);
    var v4 = !this.isString(obj) && this.isNumber(obj.length) && obj[0];
    return v1 || v2 || v3 || v4;
  };

  /**
   * 验证是不是一个日期对象
   * @method isDate
   * @param {Object} val   要检查的对象
   * @return {Boolean}           结果
   * @static
   */
  ntils.isDate = function (val) {
    if (this.isNull(val)) return false;
    return val instanceof Date;
  };

  /**
   * 验证是不是一个正则对象
   * @method isDate
   * @param {Object} val   要检查的对象
   * @return {Boolean}           结果
   * @static
   */
  ntils.isRegexp = function (val) {
    return val instanceof RegExp;
  };

  /**
   * 转换为数组
   * @method toArray
   * @param {Array|Object} array 伪数组
   * @return {Array} 转换结果数组
   * @static
   */
  ntils.toArray = function (array) {
    if (this.isNull(array)) return [];
    return Array.prototype.slice.call(array);
  };

  /**
   * 转为日期格式
   * @method toDate
   * @param {Number|String} val 日期字符串或整型数值
   * @return {Date} 日期对象
   * @static
   */
  ntils.toDate = function (val) {
    var self = this;
    if (self.isNumber(val))
      return new Date(val);
    else if (self.isString(val))
      return new Date(self.replace(self.replace(val, '-', '/'), 'T', ' '));
    else if (self.isDate(val))
      return val;
    else
      return null;
  };

  /**
   * 遍历一个对像或数组
   * @method each
   * @param  {Object or Array}   obj  要遍历的数组或对象
   * @param  {Function} fn            处理函数
   * @return {void}                   无返回值
   * @static
   */
  ntils.each = function (list, handler, scope) {
    if (this.isNull(list) || this.isNull(handler)) return;
    if (this.isArray(list)) {
      var listLength = list.length;
      for (var i = 0; i < listLength; i++) {
        var rs = handler.call(scope || list[i], i, list[i]);
        if (!this.isNull(rs)) return rs;
      }
    } else {
      for (var key in list) {
        var rs = handler.call(scope || list[key], key, list[key]);
        if (!this.isNull(rs)) return rs;
      }
    }
  };

  /**
   * 格式化日期
   * @method formatDate
   * @param {Date|String|Number} date 日期
   * @param {String} format 格式化字符串
   * @param {object} dict 反译字典
   * @return {String} 格式化结果
   * @static
   */
  ntils.formatDate = function (date, format, dict) {
    if (this.isNull(format) || this.isNull(date)) return date;
    date = this.toDate(date);
    dict = dict || {};
    var placeholder = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "w+": date.getDay(), //week
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var key in placeholder) {
      if (new RegExp("(" + key + ")").test(format)) {
        var value = placeholder[key];
        value = dict[value] || value;
        format = format.replace(RegExp.$1, RegExp.$1.length == 1
          ? value : ("00" + value).substr(("" + value).length));
      }
    }
    return format;
  };

  /**
   * 拷贝对象
   * @method copy
   * @param {Object} src 源对象
   * @param {Object} dst 目标对象
   * @static
   */
  ntils.copy = function (src, dst, igonres) {
    dst = dst || (this.isArray(src) ? [] : {});
    this.each(src, function (key) {
      if (igonres && igonres.indexOf(key) > -1) return;
      delete dst[key];
      if (Object.getOwnPropertyDescriptor) {
        try {
          Object.defineProperty(dst, key, Object.getOwnPropertyDescriptor(src, key));
        } catch (ex) {
          dst[key] = src[key];
        }
      } else {
        dst[key] = src[key];
      }
    })
    return dst;
  };

  /**
   * 深度克隆对象
   * @method clone
   * @param {Object} src 源对象
   * @return {Object} 新对象
   * @static
   */
  ntils.clone = function (src, igonres) {
    if (this.isNull(src) ||
      this.isString(src) ||
      this.isNumber(src) ||
      this.isBoolean(src) ||
      this.isDate(src)) {
      return src;
    }
    var objClone = src;
    try {
      objClone = new src.constructor();
    } catch (ex) { }
    this.each(src, function (key, value) {
      if (objClone[key] != value && !this.contains(igonres, key)) {
        if (this.isObject(value)) {
          objClone[key] = this.clone(value, igonres);
        } else {
          objClone[key] = value;
        }
      }
    }, this);
    ['toString', 'valueOf'].forEach(function (key) {
      if (this.contains(igonres, key)) return;
      this.defineFreezeProp(objClone, key, src[key]);
    }, this);
    return objClone;
  };

  /**
   * 合并对象
   * @method mix
   * @return 合并后的对象
   * @param {Object} dst 目标对象
   * @param {Object} src 源对象
   * @param {Array} igonres 忽略的属性名,
   * @param {Number} mode 模式
   */
  ntils.mix = function (dst, src, igonres, mode, igonreNull) {
    //根据模式来判断，默认是Obj to Obj的  
    if (mode) {
      switch (mode) {
        case 1: // proto to proto  
          return ntils.mix(dst.prototype, src.prototype, igonres, 0);
        case 2: // object to object and proto to proto  
          ntils.mix(dst.prototype, src.prototype, igonres, 0);
          break; // pass through  
        case 3: // proto to static  
          return ntils.mix(dst, src.prototype, igonres, 0);
        case 4: // static to proto  
          return ntils.mix(dst.prototype, src, igonres, 0);
        default: // object to object is what happens below  
      }
    }
    //---
    src = src || {};
    dst = dst || (this.isArray(src) ? [] : {});
    this.keys(src).forEach(function (key) {
      if (this.contains(igonres, key)) return;
      if (igonreNull && this.isNull(src[key])) return;
      if (this.isObject(src[key]) &&
        (src[key].constructor == Object ||
          src[key].constructor == Array ||
          src[key].constructor == null)) {
        dst[key] = ntils.mix(dst[key], src[key], igonres, 0, igonreNull);
      } else {
        dst[key] = src[key];
      }
    }, this);
    return dst;
  };

  /**
   * 定义不可遍历的属性
   **/
  ntils.defineFreezeProp = function (obj, name, value) {
    try {
      Object.defineProperty(obj, name, {
        value: value,
        enumerable: false,
        configurable: true, //能不能重写定义
        writable: false //能不能用「赋值」运算更改
      });
    } catch (err) {
      obj[name] = value;
    }
  };

  /**
   * 获取所有 key 
   */
  ntils.keys = function (obj) {
    if (Object.keys) return Object.keys(obj);
    var keys = [];
    this.each(obj, function (key) {
      keys.push(key);
    });
    return keys;
  };

  /**
   * 创建一个对象
   */
  ntils.create = function (proto, props) {
    if (Object.create) return Object.create(proto, props);
    var Cotr = function () { };
    Cotr.prototype = proto;
    var obj = new Cotr();
    if (props) this.copy(props, obj);
    return obj;
  };

  /**
   * 设置 proto
   * 在不支持 setPrototypeOf 也不支持 __proto__ 的浏览器
   * 中，会采用 copy 方式
   */
  ntils.setPrototypeOf = function (obj, proto) {
    if (Object.setPrototypeOf) {
      return Object.setPrototypeOf(obj, proto || this.create(null));
    } else {
      if (!('__proto__' in Object)) this.copy(proto, obj);
      obj.__proto__ = proto;
    }
  };

  /**
   * 获取 proto
   */
  ntils.getPrototypeOf = function (obj) {
    if (obj.__proto__) return obj.__proto__;
    if (Object.getPrototypeOf) return Object.getPrototypeOf(obj);
    if (obj.constructor) return obj.constructor.prototype;
  };

  /**
   * 是否深度相等
   */
  ntils.deepEqual = function (a, b) {
    if (a === b) return true;
    if (!this.isObject(a) || !this.isObject(b)) return false;
    var aKeys = this.keys(a);
    var bKeys = this.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    var allKeys = aKeys.concat(bKeys);
    var checkedMap = this.create(null);
    var result = true;
    this.each(allKeys, function (i, key) {
      if (checkedMap[key]) return;
      if (!this.deepEqual(a[key], b[key])) result = false;
      checkedMap[key] = true;
    }, this);
    return result;
  };

  /**
   * 从一个数值循环到别一个数
   * @param {number} fromNum 开始数值
   * @param {Number} toNum 结束数值
   * @param {Number} step 步长值
   * @param {function} handler 执行函数
   * @returns {void} 无返回
   */
  ntils.fromTo = function (fromNum, toNum, step, handler) {
    if (!handler) handler = [step, step = handler][0];
    step = Math.abs(step || 1);
    if (fromNum < toNum) {
      for (var i = fromNum; i <= toNum; i += step) handler(i);
    } else {
      for (var i = fromNum; i >= toNum; i -= step) handler(i);
    }
  };

  /**
   * 生成一个Guid
   * @method newGuid
   * @return {String} GUID字符串
   * @static
   */
  ntils.newGuid = function () {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  };

  /**
   * 对象变换
   **/
  ntils.map = function (list, fn) {
    var buffer = this.isArray(list) ? [] : {};
    this.each(list, function (name, value) {
      buffer[name] = fn(name, value);
    });
    return buffer;
  };

  /**
   * 通过路径设置属性值
   */
  ntils.setByPath = function (obj, path, value) {
    if (this.isNull(obj) || this.isNull(path) || path === '') {
      return;
    }
    if (!this.isArray(path)) {
      path = path.replace(/\[/, '.').replace(/\]/, '.').split('.');
    }
    this.each(path, function (index, name) {
      if (this.isNull(name) || name.length < 1) return;
      if (index === path.length - 1) {
        obj[name] = value;
      } else {
        obj[name] = obj[name] || {};
        obj = obj[name];
      }
    }, this);
  };

  /**
   * 通过路径获取属性值
   */
  ntils.getByPath = function (obj, path) {
    if (this.isNull(obj) || this.isNull(path) || path === '') {
      return obj;
    }
    if (!this.isArray(path)) {
      path = path.replace(/\[/, '.').replace(/\]/, '.').split('.');
    }
    this.each(path, function (index, name) {
      if (this.isNull(name) || name.length < 1) return;
      if (!this.isNull(obj)) obj = obj[name];
    }, this);
    return obj;
  };

  /**
   * 数组去重
   **/
  ntils.unique = function (array) {
    if (this.isNull(array)) return array;
    var newArray = [];
    this.each(array, function (i, value) {
      if (newArray.indexOf(value) > -1) return;
      newArray.push(value);
    });
    return newArray;
  };

  /**
   * 解析 function 的参数列表
   **/
  ntils.getFunctionArgumentNames = function (fn) {
    if (!fn) return [];
    var src = fn.toString();
    var parts = src.split(')')[0].split('=>')[0].split('(');
    return (parts[1] || parts[0]).split(',').map(function (name) {
      return name.trim();
    }).filter(function (name) {
      return name != 'function';
    });
  };

  /**
   * 缩短字符串
   */
  ntils.short = function (str, maxLength) {
    if (!str) return str;
    maxLength = maxLength || 40;
    var strLength = str.length;
    var trimLength = maxLength / 2;
    return strLength > maxLength ? str.substr(0, trimLength) + '...' + str.substr(strLength - trimLength) : str;
  };

  /**
   * 首字母大写
   */
  ntils.firstUpper = function (str) {
    if (this.isNull(str)) return;
    return str.substring(0, 1).toUpperCase() + str.substring(1);
  };

  /**
   * 编码正则字符串
   */
  ntils.escapeRegExp = function (str) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  /**
   * 解析字符串为 dom 
   * @param {string} str 字符串
   * @returns {HTMLNode} 解析后的 DOM 
   */
  ntils.parseDom = function (str) {
    this._PDD_ = this._PDD_ || document.createElement('div');
    this._PDD_.innerHTML = ntils.trim(str);
    var firstNode = this._PDD_.childNodes[0];
    //先 clone 一份再通过 innerHTML 清空
    //否则 IE9 下，清空时会导出返回的 DOM 没有子结点
    if (firstNode) firstNode = firstNode.cloneNode(true);
    this._PDD_.innerHTML = '';
    return firstNode;
  };

})(( false) ? (window.ntils = {}) : exports);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(154), __esModule: true };

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(32);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(33);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

__webpack_require__(205);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_ALLOWED_DIRECTION = ['bottom', 'top', 'right', 'left'];
var DEFAULT_ALLOWED_V_ALIGN = ['top', 'middle', 'bottom'];
var DEFAULT_ALLOWED_H_ALIGN = ['left', 'center', 'right'];

var Popover = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Popover, _ComBase);

  function Popover() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Popover.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        inside = _props.inside,
        dock = _props.dock,
        overlay = _props.overlay,
        follow = _props.follow;

    var names = (0, _common.cname)((_cname = {
      popover: true,
      aniTransition: true,
      widget: true,
      widgetShadow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      dock: !!dock,
      hasOverlay: overlay,
      follow: !!follow,
      fixed: !!this.state.fixed,
      stateHidden: !this.isVisable(),
      stateVisible: this.isVisable()
    }, _cname['dock-' + dock] = !!dock, _cname['direction-' + this.state.direction] = !!this.state.direction, _cname['align-' + this.state.align] = !!this.state.align, _cname.inside = inside, _cname), className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names }),
      _react2.default.createElement(_components.Overlay, { className: className + '-overlay',
        onClick: this.props.onOverlayClick,
        inside: inside && dock,
        visible: this.props.overlay && this.props.visible }),
      this.props.children,
      _react2.default.createElement(_components.Proxy, { target: document.defaultView,
        capture: true,
        onScroll: this.reflow.bind(this) })
    );
  };

  /**
   * 在属性有更新新时
   * @param {Object} nextProps 新的属性 map
   * @returns {void} 无返回
   */


  Popover.prototype.componentWillReceiveProps = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextProps) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _common.sleep)(0);

            case 2:
              this.applyFollow(nextProps.follow);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentWillReceiveProps(_x) {
      return _ref.apply(this, arguments);
    }

    return componentWillReceiveProps;
  }();

  /**
   * 在组件挂载时
   * @returns {void} 无返回
   */


  Popover.prototype.componentDidMount = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var _props2, inside, dock;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _props2 = this.props, inside = _props2.inside, dock = _props2.dock;

              if (!inside) {
                _common.shadow.add(this.domNode);
              }
              if (inside && dock) {
                this._overlay = this.domNode.querySelector('.' + (0, _common.cname)('overlay'));
                this.domNode.parentNode.appendChild(this._overlay);
              }
              _context2.next = 5;
              return (0, _common.sleep)(0);

            case 5:
              this.applyFollow(this.props.follow);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function componentDidMount() {
      return _ref2.apply(this, arguments);
    }

    return componentDidMount;
  }();

  Popover.prototype.reflow = function reflow() {
    if (!this.props.visible) return;
    this.applyFollow(this.props.follow);
  };

  Popover.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props3 = this.props,
        inside = _props3.inside,
        dock = _props3.dock;

    if (!inside) {
      _common.shadow.remove(this.domNode);
    }
    if (inside && dock && this._overlay) {
      this.domNode.appendChild(this._overlay);
    }
  };

  Popover.prototype.calcInside = function calcInside() {
    if (this.props.inside != 'auto') return;
    if (this.props.visible) {
      _common.shadow.add(this.domNode);
    } else {
      _common.shadow.remove(this.domNode);
    }
  };

  //应用跟随


  Popover.prototype.applyFollow = function applyFollow(target) {
    //检查是否挂载
    var panel = this.domNode;
    if (!panel) return;
    this.setState({ followApplyed: false });
    if (_common.utils.isFunction(target)) target = target();
    if (!target) return this.clearFollow(panel);
    this.calcInside();
    //确定坐标
    var targetOffset = void 0;
    if (this.props.onFollow) {
      targetOffset = this.props.onFollow(new _common.EventArgs(this, target));
    } else if (_common.utils.isString(target)) {
      return this.applyFollow(document.querySelector(target));
    } else if (_common.utils.isComponent(target)) {
      return this.applyFollow(this.findDOMNode(target));
    } else if (_common.utils.isElement(target)) {
      this.setState({ fixed: _common.utils.isFixed(target) });
      return this.applyFollow(_common.utils.getOffset(target));
    } else {
      targetOffset = target;
    }
    this.calcLocation(panel, targetOffset);
  };

  //清清跟随


  Popover.prototype.clearFollow = function clearFollow(panel) {
    panel.style.left = null;
    panel.style.top = null;
  };

  //兼容处理 offset


  Popover.prototype.compatibleOffset = function compatibleOffset(offset) {
    offset.left = offset.left || offset.x || 0;
    offset.top = offset.top || offset.y || 0;
    offset.width = offset.width || 0;
    offset.height = offset.height || 0;
    return offset;
  };

  //计算位置


  Popover.prototype.calcLocation = function calcLocation(panel, offset) {
    var targetOffset = this.compatibleOffset(offset);
    var panelOffset = this.compatibleOffset(_common.utils.getOffset(panel));
    var windowSize = _common.utils.getWindowSize();
    this.calcDirectionAndAlign({
      targetOffset: targetOffset,
      panelOffset: panelOffset,
      panel: panel,
      windowSize: windowSize
    });
  };

  //计算方向和对齐方式


  Popover.prototype.calcDirectionAndAlign = function calcDirectionAndAlign(opts) {
    //方向和对齐
    var direction = this.props.direction || this.calcDirection(opts);
    var align = this.props.align || this.calcAlign(direction, opts);
    //--
    this.setDirection(direction, opts);
    this.setAlign(direction, align, opts);
    //--
    this.setState({ followApplyed: true, direction: direction, align: align });
  };

  //自动确定 follow 方向


  Popover.prototype.calcDirection = function calcDirection(opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        windowSize = opts.windowSize;

    var allowedDirection = this.props.allowedDirection || DEFAULT_ALLOWED_DIRECTION;

    if (allowedDirection.includes('bottom') && windowSize.height - (targetOffset.top + targetOffset.height) > panelOffset.height) {
      return 'bottom';
    } else if (allowedDirection.includes('top') && targetOffset.top > panelOffset.height) {
      return 'top';
    } else if (allowedDirection.includes('right') && windowSize.width - (targetOffset.left + targetOffset.width) > panelOffset.width) {
      return 'right';
    } else if (allowedDirection.includes('left') && targetOffset.left > panelOffset.width) {
      return 'left';
    } else {
      return allowedDirection[0] || 'bottom';
    }
  };

  //自动计算对齐方式


  Popover.prototype.calcAlign = function calcAlign(direction, opts) {
    if (['top', 'bottom'].includes(direction)) {
      return this.calcHAlign(opts);
    } else {
      return this.calcVAlign(opts);
    }
  };

  //计算水平对齐


  Popover.prototype.calcHAlign = function calcHAlign(opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        windowSize = opts.windowSize;

    var allowedHAlign = this.props.allowedHAlign || DEFAULT_ALLOWED_H_ALIGN;
    if (allowedHAlign.includes('left') && windowSize.width - targetOffset.left > panelOffset.width) {
      return 'left';
    } else if (allowedHAlign.includes('right') && targetOffset.left + targetOffset.width > panelOffset.width) {
      return 'right';
    } else {
      return allowedHAlign[0] || 'left';
    }
  };

  //计算水平对齐


  Popover.prototype.calcVAlign = function calcVAlign(opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        windowSize = opts.windowSize;

    var allowedVAlign = this.props.allowedVAlign || DEFAULT_ALLOWED_V_ALIGN;
    if (allowedVAlign.includes('top') && windowSize.height - targetOffset.top > panelOffset.height) {
      return 'top';
    } else if (allowedVAlign.includes('bottom') && targetOffset.top + targetOffset.height > panelOffset.height) {
      return 'bottom';
    } else {
      return allowedVAlign[0] || 'top';
    }
  };

  //设定所在的方向


  Popover.prototype.setDirection = function setDirection(direction, opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        panel = opts.panel;

    switch (direction) {
      case 'top':
        {
          var top = targetOffset.top - panelOffset.height;
          panel.style.top = top + 'px';
          break;
        }
      case 'right':
        {
          var left = targetOffset.left + targetOffset.width;
          panel.style.left = left + 'px';
          break;
        }
      case 'bottom':
        {
          var _top = targetOffset.top + targetOffset.height;
          panel.style.top = _top + 'px';
          break;
        }
      case 'left':
        {
          var _left = targetOffset.left - panelOffset.width;
          panel.style.left = _left + 'px';
          break;
        }
      default:
        throw new _common.Error('Popover invalid direction "' + direction + '"');
    }
  };

  //设定对齐方式


  Popover.prototype.setAlign = function setAlign(direction, align, opts) {
    if (['top', 'bottom'].includes(direction)) {
      this.setHAlign(align, opts);
    } else {
      this.setVAlign(align, opts);
    }
  };

  //设置水平对齐


  Popover.prototype.setHAlign = function setHAlign(align, opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        panel = opts.panel;

    switch (align) {
      case 'left':
        {
          panel.style.left = targetOffset.left + 'px';
          break;
        }
      case 'center':
        {
          var left = targetOffset.left + targetOffset.width / 2 - panelOffset.width / 2;
          panel.style.left = left + 'px';
          break;
        }
      case 'right':
        {
          var _left2 = targetOffset.left + targetOffset.width - panelOffset.width;
          panel.style.left = _left2 + 'px';
          break;
        }
      default:
        throw new _common.Error('Popover invalid align "' + align + '"');
    }
  };

  //设置垂直对齐


  Popover.prototype.setVAlign = function setVAlign(align, opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        panel = opts.panel;

    switch (align) {
      case 'top':
        {
          panel.style.top = targetOffset.top + 'px';
          break;
        }
      case 'middle':
        {
          var top = targetOffset.top + targetOffset.height / 2 - panelOffset.height / 2;
          panel.style.top = top + 'px';
          break;
        }
      case 'bottom':
        {
          var _top2 = targetOffset.top + targetOffset.height - panelOffset.height;
          panel.style.top = _top2 + 'px';
          break;
        }
      default:
        throw new _common.Error('Popover invalid align "' + align + '"');
    }
  };

  //检查是否显示


  Popover.prototype.isVisable = function isVisable() {
    if (!this.props.follow || this.state.followApplyed) {
      return this.props.visible;
    } else {
      return false;
    }
  };

  return Popover;
}(_common.ComBase), _class.propTypes = {

  /** 弹层的类名 */
  className: _propTypes2.default.string,

  /**
   * 停靠位置
   */
  dock: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left', 'center']),

  /** 是否显示 */
  visible: _propTypes2.default.bool,

  /**
   * 单击事件
   */
  onClick: _propTypes2.default.func,

  /**
   * 遮罩单击事件
   */
  onOverlayClick: _propTypes2.default.func,

  /** 是否显示遮罩 */
  overlay: _propTypes2.default.bool,

  /** 
   * 跟随的元素，可以是 `组件, 元素, 选择器`，
   * 默认在不指定 `direction` 和 `align` 时将自动计算位置 
   **/
  follow: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.instanceOf(_react2.default.Component)]),

  /** 
   * follow 模式有效，用于指定固定的弹出方向
   **/
  direction: _propTypes2.default.oneOf(DEFAULT_ALLOWED_DIRECTION),

  /** 
   * 自动 follow 模式时，用于限对弹出方法，值为数组
   **/
  allowedDirection: _propTypes2.default.oneOf(DEFAULT_ALLOWED_DIRECTION),

  /** 
   * follow 模式有效，用于指定固定的弹出的对刘方式 
   **/
  align: _propTypes2.default.oneOf([].concat(DEFAULT_ALLOWED_H_ALIGN, DEFAULT_ALLOWED_V_ALIGN)),

  /**
   * 自动 follow 模式时，用于限定纵向对齐方式，值为数组，
   */
  allowedVAlign: _propTypes2.default.oneOf(DEFAULT_ALLOWED_V_ALIGN),

  /**
   * 动 follow 模式时，用于限定横向对齐方式，值为数组，
   */
  allowedHAlign: _propTypes2.default.oneOf(DEFAULT_ALLOWED_H_ALIGN)

}, _class.defaultProps = {}, _temp2);
exports.default = Popover;
module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_NAME = /^on/;

var Proxy = function (_ComBase) {
  (0, _inherits3.default)(Proxy, _ComBase);

  function Proxy() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Proxy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.oldValues = {}, _this.events = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Proxy.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        target = _props.target,
        capture = _props.capture,
        props = (0, _objectWithoutProperties3.default)(_props, ['target', 'capture']);

    target = target || document;
    target.$proxyStack = target.$proxyStack || [];
    _common.utils.each(props, function (name, value) {
      if (EVENT_NAME.test(name)) {
        var eventName = name.slice(2).toLowerCase();
        target.addEventListener(eventName, value, capture || false);
        _this2.events[name] = value;
      } else {
        _this2.oldValues[name] = target[name];
        target[name] = value;
      }
    });
    target.$proxyStack.push(this);
  };

  Proxy.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        target = _props2.target,
        capture = _props2.capture;

    target = target || document;
    target.$proxyStack = target.$proxyStack || [];
    var index = target.$proxyStack.indexOf(this);
    var nextItem = target.$proxyStack[index + 1];
    _common.utils.each(this.oldValues, function (name, value) {
      if (nextItem) {
        nextItem.oldValues[name] = value;
      } else {
        target[name] = value;
      }
    });
    _common.utils.each(this.events, function (name, handler) {
      if (EVENT_NAME.test(name)) {
        var eventName = name.slice(2).toLowerCase();
        target.removeEventListener(eventName, handler, capture || false);
      }
    });
    target.$proxyStack.splice(index, 1);
  };

  return Proxy;
}(_common.ComBase);

exports.default = Proxy;
module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(54)('keys');
var uid = __webpack_require__(43);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(37) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 56 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(51);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(15);
var dPs = __webpack_require__(121);
var enumBugKeys = __webpack_require__(55);
var IE_PROTO = __webpack_require__(53)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(49)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(78).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(11);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(9);
var LIBRARY = __webpack_require__(37);
var wksExt = __webpack_require__(59);
var defineProperty = __webpack_require__(16).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = {"name":"aps","env":"prod"}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

exports.getRootContainer = getRootContainer;
exports.add = add;
exports.remove = remove;
exports.render = render;
exports.unmount = unmount;

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(24);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRootContainer() {
  return document.body;
}

function add(element) {
  if (!element) return;
  var root = getRootContainer();
  if (element.parentNode == root) return;
  element.$parentNode = element.parentNode;
  return root.appendChild(element);
}

function remove(element) {
  if (!element) return;
  var root = getRootContainer();
  if (element.parentNode == root) {
    root.removeChild(element);
  }
  if (element.$parentNode) {
    element.$parentNode.appendChild(element);
  }
  element.$parentNode = null;
}

function render(vDom, parentNode) {
  if (!vDom) return;
  var root = getRootContainer();
  if (!parentNode) {
    parentNode = document.createElement('div');
    root.appendChild(parentNode);
  }
  if (_utils2.default.isString(parentNode)) {
    parentNode = document.querySelector(parentNode);
  }
  return new _promise2.default(function (resolve) {
    _reactDom2.default.render(vDom, parentNode, function () {
      this.$container = parentNode;
      resolve(this);
    });
  });
}

function unmount(instance) {
  if (!instance) return;
  var container = instance.$container;
  var domNode = instance.domNode;
  if (domNode.parentNode != container) {
    container.appendChild(domNode);
  }
  _reactDom2.default.unmountComponentAtNode(container);
  container.parentNode.removeChild(container);
}

exports.default = {
  render: render, unmount: unmount, add: add, remove: remove, getRootContainer: getRootContainer
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(41);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = transport;

var _utils = __webpack_require__(24);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//默认支的事件，后续补完整
var ALLOWED_REGEXPS = [/^data\-/, /^aria\-/, 'style', 'name', 'id', 'for', 'htmlFor', 'disabled', 'checked', 'value', 'placeholder', 'onClick', 'onContextMenu', 'onDoubleClick', 'onWheel', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onDrag', 'onDrop', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onCopy', 'onCut', 'onPaste', 'onChange', 'onInput', 'onSubmit', 'onFocus', 'onBlur', 'onScroll', 'defaultChecked', 'defaultValue', 'alt', 'href', 'target', 'src', 'type', 'readOnly', 'placeholder', 'accept'];

function transport(map) {
  var result = {};
  _utils2.default.each(map, function (name, value) {
    if (!ALLOWED_REGEXPS.some(function (regexp) {
      return regexp === name || regexp.test && regexp.test(name);
    })) {
      return;
    }
    result[name] = value;
  });
  return result;
}
module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _regenerator = __webpack_require__(32);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(33);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(178);

var _common = __webpack_require__(0);

var _dateUtil = __webpack_require__(179);

var _i18n = __webpack_require__(93);

var _i18n2 = _interopRequireDefault(_i18n);

var _Icon = __webpack_require__(31);

var _Icon2 = _interopRequireDefault(_Icon);

var _Grid = __webpack_require__(67);

var _Grid2 = _interopRequireDefault(_Grid);

var _dateEntity = __webpack_require__(34);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _Grid2.default.Row,
    Col = _Grid2.default.Col;


var METHOD_OF_TYPE = {
  date: 'renderMonth',
  year: 'renderYears',
  month: 'renderMonths',
  time: 'renderTime',
  datetime: 'renderMonth'
};

var Calendar = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Calendar, _ComBase);

  function Calendar() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { showValue: null, showType: null }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    this.propsToState(this.props);
  };

  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.propsToState(nextProps);
  };

  Calendar.prototype.propsToState = function propsToState(props) {
    var value = props.value,
        defaultValue = props.defaultValue,
        type = props.type,
        defaultType = props.defaultType;

    var showValue = new _dateEntity2.default(value || this.state.showValue || defaultValue);
    var showType = type || this.state.showType || defaultType;
    this.setState({ showValue: showValue, showType: showType });
  };

  Calendar.prototype.renderMonthWeeks = function renderMonthWeeks() {
    var weeks = _i18n2.default.current.weeks;

    var thList = weeks.map(function (item) {
      return _react2.default.createElement(
        'th',
        { key: item.value, className: (0, _common.cname)('disabled') },
        item.text
      );
    });
    return _react2.default.createElement(
      'tr',
      { className: (0, _common.cname)('calendarWeeks') },
      thList
    );
  };

  Calendar.prototype.isDisabled = function isDisabled(value) {
    var _props = this.props,
        min = _props.min,
        max = _props.max;

    if (!value) return false;
    var compareFormat = 'yyyy/MM/dd';
    value = new _dateEntity2.default(value).format(compareFormat);
    min = new _dateEntity2.default(min || 1).format(compareFormat);
    max = new _dateEntity2.default(max || Number.MAX_VALUE).format(compareFormat);
    return value < min || value > max;
  };

  Calendar.prototype.isHighlight = function isHighlight(value) {
    var _props$highlight = this.props.highlight,
        highlight = _props$highlight === undefined ? {} : _props$highlight;
    var begin = highlight.begin,
        end = highlight.end;

    if (!value || !begin || !end) return false;
    var compareFormat = 'yyyy/MM/dd';
    value = new _dateEntity2.default(value).format(compareFormat);
    begin = new _dateEntity2.default(begin).format(compareFormat);
    end = new _dateEntity2.default(end).format(compareFormat);
    return value >= begin && value <= end;
  };

  Calendar.prototype.renderMoathCell = function renderMoathCell(item, index) {
    var renderDate = this.props.renderDate;
    var date = item.date;

    var disabled = this.isDisabled(item.value);
    var highlight = this.isHighlight(item.value);
    var exceeding = !item.isCurrent;
    var compareFormat = 'yyyy/MM/dd';
    var stateActive = this.value.format(compareFormat) == item.format(compareFormat);
    var tdNames = (0, _common.cname)({ disabled: disabled, exceeding: exceeding, highlight: highlight, stateActive: stateActive });
    var onDayClick = disabled ? null : this.onDayClick.bind(this, item);
    return _react2.default.createElement(
      'td',
      { className: tdNames,
        onClick: onDayClick, key: index },
      renderDate ? renderDate(item) : date
    );
  };

  Calendar.prototype.renderMonthCells = function renderMonthCells(_ref) {
    var _this2 = this;

    var year = _ref.year,
        month = _ref.month;
    var weeks = _i18n2.default.current.weeks;

    var prevDates = (0, _dateUtil.getNearDates)(year, month, -1);
    var nextDates = (0, _dateUtil.getNearDates)(year, month, 1);
    var firstDay = (0, _dateUtil.getFirstDay)(year, month);
    var dates = (0, _dateUtil.getDates)(year, month);
    var leftPad = void 0;
    if (weeks[0].value == 0) {
      leftPad = prevDates.slice(prevDates.length - firstDay);
    } else {
      if (firstDay == 0) firstDay = 7;
      leftPad = prevDates.slice(prevDates.length - (firstDay - 1));
    }
    dates.unshift.apply(dates, leftPad);
    var rightPad = nextDates.slice(0, 42 - dates.length);
    dates.push.apply(dates, rightPad);
    var dateIndex = 0;
    var trList = [];
    _common.utils.fromTo(0, 5, function (line) {
      var tdList = weeks.map(function () {
        var date = dates[dateIndex];
        date.isCurrent = date.month === month;
        return _this2.renderMoathCell(date, dateIndex++);
      });
      trList.push(_react2.default.createElement(
        'tr',
        { key: line },
        tdList
      ));
    });
    return trList;
  };

  Calendar.prototype.renderMonth = function renderMonth(_ref2) {
    var year = _ref2.year,
        month = _ref2.month;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('calendarHead') },
        _react2.default.createElement(_Icon2.default, { onClick: this.prevMonth.bind(this),
          type: 'arrow-left', className: (0, _common.cname)('pull-left') }),
        _react2.default.createElement(
          'a',
          { onClick: this.switchShowType.bind(this, 'year') },
          this.showValue.format('yyyy')
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('calendarSeparater') },
          '/'
        ),
        _react2.default.createElement(
          'a',
          { onClick: this.switchShowType.bind(this, 'month') },
          this.showValue.format('MM')
        ),
        _react2.default.createElement(_Icon2.default, { onClick: this.nextMonth.bind(this),
          type: 'arrow-right', className: (0, _common.cname)('pull-right') })
      ),
      _react2.default.createElement(
        'table',
        null,
        _react2.default.createElement(
          'thead',
          null,
          this.renderMonthWeeks()
        ),
        _react2.default.createElement(
          'tbody',
          null,
          this.renderMonthCells({ year: year, month: month })
        )
      ),
      this.renderFoot()
    );
  };

  Calendar.prototype.renderFoot = function renderFoot() {
    if (this.props.footVisible === false) return;
    var locales = _i18n2.default.current;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('calendarFoot') },
      this.renderTimeAndOk(),
      _react2.default.createElement(
        'a',
        { className: (0, _common.cname)({ pullLeft: this.showType === 'datetime' }),
          onClick: this.onTodayClick.bind(this) },
        locales.today
      )
    );
  };

  Calendar.prototype.renderTimeAndOk = function renderTimeAndOk() {
    if (this.showType !== 'datetime') return;
    var locales = _i18n2.default.current;
    return [_react2.default.createElement(
      'a',
      { key: 'time', className: (0, _common.cname)('time'),
        onClick: this.switchShowType.bind(this, 'time') },
      this.showValue.format('hh:mm:ss')
    ), _react2.default.createElement(
      'a',
      { key: 'ok', className: (0, _common.cname)('pull-right'),
        onClick: this.onOkClick.bind(this) },
      locales.ok
    )];
  };

  Calendar.prototype.renderYears = function renderYears(_ref3) {
    var _this3 = this;

    var year = _ref3.year;

    var beginYear = year - 5;
    var endYear = year + 6;
    var years = [];
    _common.utils.fromTo(beginYear, endYear, function (year) {
      var names = (0, _common.cname)({
        stateActive: year == _this3.value.year
      });
      years.push(_react2.default.createElement(
        'li',
        { key: year,
          className: names,
          onClick: _this3.onYearClick.bind(_this3, { year: year }) },
        year
      ));
    });
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('calendarHead') },
        _react2.default.createElement(_Icon2.default, { onClick: this.nextYears.bind(this, -12),
          type: 'arrow-left', className: (0, _common.cname)('pull-left') }),
        _react2.default.createElement(
          'a',
          null,
          beginYear
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('calendarSeparater') },
          '-'
        ),
        _react2.default.createElement(
          'a',
          null,
          endYear
        ),
        _react2.default.createElement(_Icon2.default, { onClick: this.nextYears.bind(this, 12),
          type: 'arrow-right', className: (0, _common.cname)('pull-right') })
      ),
      _react2.default.createElement(
        'ul',
        { className: (0, _common.cname)('calendarYears') },
        years
      )
    );
  };

  Calendar.prototype.renderMonths = function renderMonths(_ref4) {
    var _this4 = this;

    var year = _ref4.year;

    var months = [];
    _common.utils.fromTo(1, 12, function (month) {
      var disabled = _this4.isDisabled({ year: year, month: month });
      var names = (0, _common.cname)({
        stateActive: !disabled && month == _this4.value.month,
        highlight: _this4.isHighlight({ year: year, month: month }),
        disabled: disabled
      });
      months.push(_react2.default.createElement(
        'li',
        { key: month,
          className: names,
          onClick: !disabled ? _this4.onMonthClick.bind(_this4, { year: year, month: month }) : undefined },
        month
      ));
    });
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('calendarHead') },
        _react2.default.createElement(_Icon2.default, { onClick: this.nextYears.bind(this, -1),
          type: 'arrow-left', className: (0, _common.cname)('pull-left') }),
        _react2.default.createElement(
          'a',
          null,
          year
        ),
        _react2.default.createElement(_Icon2.default, { onClick: this.nextYears.bind(this, 1),
          type: 'arrow-right', className: (0, _common.cname)('pull-right') })
      ),
      _react2.default.createElement(
        'ul',
        { className: (0, _common.cname)('calendarMonths') },
        months
      )
    );
  };

  Calendar.prototype.onTimeClick = function onTimeClick(name, value) {
    this.showValue[name] = value;
    this.setState({ showValue: new _dateEntity2.default(this.showValue) });
    this.onChange(this.showValue, event);
  };

  Calendar.prototype.createNumList = function createNumList(from, to, name) {
    var _this5 = this;

    var items = [];
    var value = this.showValue[name];
    _common.utils.fromTo(from, to, function (num) {
      var itemNames = (0, _common.cname)({
        aniTransition: true,
        stateActive: value == num
      });
      items.push(_react2.default.createElement(
        'li',
        { className: itemNames,
          onClick: _this5.onTimeClick.bind(_this5, name, num),
          key: num },
        num
      ));
    });
    return _react2.default.createElement(
      'ul',
      { className: (0, _common.cname)({ aniTransition: true }),
        style: { marginTop: -28 * (value - 3) } },
      items
    );
  };

  Calendar.prototype.onTimeWhell = function onTimeWhell(name, event) {
    var range = {
      hours: { min: 0, max: 23 },
      minutes: { min: 0, max: 59 },
      seconds: { min: 0, max: 59 }
    }[name];
    var value = this.showValue[name];
    value += parseInt(event.deltaY / 4);
    if (value < range.min) value = range.min;
    if (value > range.max) value = range.max;
    this.showValue[name] = value;
    this.setState({ showValue: new _dateEntity2.default(this.showValue) });
    this.onChange(this.showValue, event);
  };

  Calendar.prototype.onTimeOkClick = function onTimeOkClick(event) {
    var entity = new _dateEntity2.default(this.showValue);
    this.setState(entity);
    var type = this.props.type || this.props.defaultType;
    if (type !== 'time') {
      return this.switchShowType(type);
    }
    this.onChange(entity, event, true);
  };

  Calendar.prototype.renderTime = function renderTime() {
    var locales = _i18n2.default.current;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('timePanel') },
      _react2.default.createElement(
        _Grid2.default,
        { fluid: true, cellPadding: 10 },
        _react2.default.createElement(
          Row,
          { className: (0, _common.cname)('timeHead') },
          _react2.default.createElement(
            Col,
            { span: 8 },
            locales.hours
          ),
          _react2.default.createElement(
            Col,
            { span: 8 },
            locales.minutes
          ),
          _react2.default.createElement(
            Col,
            { span: 8 },
            locales.seconds
          )
        ),
        _react2.default.createElement(
          Row,
          { cellPadding: 0, className: (0, _common.cname)('timeBody') },
          _react2.default.createElement(
            Col,
            { span: 8, className: (0, _common.cname)('col col-h'),
              onWheel: this.onTimeWhell.bind(this, 'hours') },
            this.createNumList(0, 23, 'hours')
          ),
          _react2.default.createElement(
            Col,
            { span: 8, className: (0, _common.cname)('col col-m'),
              onWheel: this.onTimeWhell.bind(this, 'minutes') },
            this.createNumList(0, 59, 'minutes')
          ),
          _react2.default.createElement(
            Col,
            { span: 8, className: (0, _common.cname)('col col-s'),
              onWheel: this.onTimeWhell.bind(this, 'seconds') },
            this.createNumList(0, 59, 'seconds')
          )
        )
      ),
      _react2.default.createElement('div', { className: (0, _common.cname)('timeRule') }),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('calendarFoot') },
        _react2.default.createElement(
          'a',
          { onClick: this.onTimeOkClick.bind(this) },
          locales.ok
        )
      )
    );
  };

  Calendar.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        visible = _props2.visible,
        shadow = _props2.shadow,
        otherProps = (0, _objectWithoutProperties3.default)(_props2, ['className', 'visible', 'shadow']);

    var names = (0, _common.cname)({
      widget: true,
      widgetShadow: shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      calendar: true,
      stateHidden: visible === false,
      stateVisible: visible !== false
    }, className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), { className: names }),
      this.renderMethod(this.showValue)
    );
  };

  Calendar.prototype.onSwitch = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
      var onSwitch;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onSwitch = this.props.onSwitch;

              if (_common.utils.isFunction(onSwitch)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              _context.next = 5;
              return (0, _common.sleep)(0);

            case 5:
              onSwitch(event);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function onSwitch(_x) {
      return _ref5.apply(this, arguments);
    }

    return onSwitch;
  }();

  Calendar.prototype.nextMonth = function nextMonth(event) {
    var showValue = this.showValue.addMonth(1);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  Calendar.prototype.prevMonth = function prevMonth(event) {
    var showValue = this.showValue.addMonth(-1);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  Calendar.prototype.nextYears = function nextYears(num, event) {
    var showValue = this.showValue.addYear(num);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  Calendar.prototype.prevYears = function prevYears(num, event) {
    var showValue = this.showValue.addYear(-num);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  Calendar.prototype.onTodayClick = function onTodayClick(event) {
    var now = new _dateEntity2.default();
    this.onDayClick(now, event);
  };

  Calendar.prototype.onChange = function onChange(value, event, close) {
    var _props3 = this.props,
        onChange = _props3.onChange,
        defaultType = _props3.defaultType;

    if (!_common.utils.isFunction(onChange)) return;
    var detail = void 0;
    if (defaultType === 'year') {
      detail = new _dateEntity2.default(new _dateEntity2.default(value).format('yyyy/01/01'));
    } else if (defaultType === 'mouth') {
      detail = new _dateEntity2.default(new _dateEntity2.default(value).format('yyyy/MM/01'));
    } else if (defaultType === 'date') {
      detail = new _dateEntity2.default(new _dateEntity2.default(value).format('yyyy/MM/dd'));
    } else {
      detail = new _dateEntity2.default(value);
    }
    onChange(new _common.EventArgs(this, detail), close);
  };

  Calendar.prototype.onDayClick = function onDayClick(entity, event, close) {
    entity.hours = this.showValue.hours;
    entity.minutes = this.showValue.minutes;
    entity.seconds = this.showValue.seconds;
    this.setState(entity);
    //this.forceUpdate();
    this.onChange(entity, event, close);
    var onDayClick = this.props.onDayClick;

    if (!_common.utils.isFunction(onDayClick)) return;
    onDayClick(new _common.EventArgs(this, new _dateEntity2.default(entity)), close);
  };

  Calendar.prototype.onOkClick = function onOkClick(event) {
    var now = new _dateEntity2.default(this.showValue);
    this.onDayClick(now, event, true);
  };

  Calendar.prototype.switchShowType = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(showType) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _common.sleep)(0);

            case 2:
              this.setState({ showType: showType });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function switchShowType(_x2) {
      return _ref6.apply(this, arguments);
    }

    return switchShowType;
  }();

  Calendar.prototype.onYearClick = function onYearClick(_ref7, event) {
    var year = _ref7.year;

    var showValue = this.showValue;
    showValue.year = year;
    this.setState({ showValue: showValue });
    var type = this.props.type || this.props.defaultType;
    if (type !== 'year') {
      return this.switchShowType(type);
    }
    this.onChange(showValue, event);
  };

  Calendar.prototype.onMonthClick = function onMonthClick(_ref8, event) {
    var year = _ref8.year,
        month = _ref8.month;

    var showValue = this.showValue;
    showValue.year = year;
    showValue.month = month;
    this.setState({ showValue: showValue });
    var type = this.props.type || this.props.defaultType;
    if (type !== 'month') {
      return this.switchShowType(type);
    }
    this.onChange(showValue, event);
  };

  (0, _createClass3.default)(Calendar, [{
    key: 'value',
    get: function get() {
      return new _dateEntity2.default(this.props.value || this.state.showValue);
    }
  }, {
    key: 'showValue',
    get: function get() {
      if (!this.state.showValue) {
        this.state.showValue = new _dateEntity2.default();
      }
      return this.state.showValue;
    }
  }, {
    key: 'showType',
    get: function get() {
      var _props4 = this.props,
          type = _props4.type,
          defaultType = _props4.defaultType;

      return type || this.state.showType || defaultType || 'date';
    }
  }, {
    key: 'renderMethod',
    get: function get() {
      var name = METHOD_OF_TYPE[this.showType];
      return this[name];
    }
  }]);
  return Calendar;
}(_common.ComBase), _class.i18n = _i18n2.default, _class.propTypes = {

  /** 显示类型 */
  type: _propTypes2.default.oneOf(['date', 'datetime', 'year', 'month', 'time']),

  /** 默认显示类型 */
  defaultType: _propTypes2.default.oneOf(['date', 'datetime', 'year', 'month', 'time']),

  /** 值 */
  value: _propTypes2.default.oneOfType([_propTypes2.default.date, _propTypes2.default.string, _propTypes2.default.number]),

  /** 选中的值发生改变时 */
  onChange: _propTypes2.default.func,

  /** 
   * 是日期单击时 
   * (不推荐使用，day 通常用来表示一周的第几天，这里用于了 date，后续会重命名)
   **/
  onDayClick: _propTypes2.default.func,

  /** 自定义「日」渲染函数 */
  renderDate: _propTypes2.default.func,

  /** 是否可见 */
  visible: _propTypes2.default.bool,

  /** 组件脚部是否显示 */
  footVisible: _propTypes2.default.bool

}, _temp2);
exports.default = Calendar;
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _row = __webpack_require__(180);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(94);

var _col2 = _interopRequireDefault(_col);

__webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Grid = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Grid, _ComBase);

  function Grid() {
    (0, _classCallCheck3.default)(this, Grid);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Grid.prototype.wrapChildren = function wrapChildren(children) {
    var _props = this.props,
        cellPadding = _props.cellPadding,
        rowSpacing = _props.rowSpacing,
        colPadding = _props.colPadding;

    if (_common.utils.isNull(cellPadding) && _common.utils.isNull(rowSpacing) && _common.utils.isNull(colPadding)) {
      return children;
    }
    if (cellPadding && !_common.utils.isNumber(cellPadding)) cellPadding = 0;
    if (colPadding && !_common.utils.isNumber(colPadding)) colPadding = 0;
    if (rowSpacing && !_common.utils.isNumber(rowSpacing)) rowSpacing = 0;
    var rows = this.findChildren(_row2.default);
    return rows.map(function (row, index) {
      return _react2.default.cloneElement(row, {
        key: index,
        spacing: _common.utils.isNull(row.props.spacing) ? rowSpacing : row.props.spacing,
        cellPadding: _common.utils.isNull(row.props.cellPadding) ? cellPadding : row.props.cellPadding,
        colPadding: _common.utils.isNull(row.props.colPadding) ? colPadding : row.props.colPadding
      });
    });
  };

  Grid.prototype.render = function render() {
    var _props2 = this.props,
        fluid = _props2.fluid,
        visible = _props2.visible,
        className = _props2.className,
        children = _props2.children,
        othesProps = (0, _objectWithoutProperties3.default)(_props2, ['fluid', 'visible', 'className', 'children']);

    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      grid: true,
      gridFluid: !!fluid,
      stateHidden: visible === false,
      stateVisible: visible === true
    }, className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(othesProps), { className: names }),
      this.wrapChildren(children)
    );
  };

  return Grid;
}(_common.ComBase), _class.Row = _row2.default, _class.Col = _col2.default, _class.propTypes = {

  /** 指定 Grid 中每个 cell 的填充 */
  cellPadding: _propTypes2.default.number,

  /** 指定 Grid 中每个 row 间的间距 */
  rowSpacing: _propTypes2.default.number,

  /** 指定 Grid 中每个 col 的填充 */
  colPadding: _propTypes2.default.number,

  /** 是否自动根所屏幕响应容器宽度 */
  fluid: _propTypes2.default.bool
}, _class.defaultProps = {}, _temp);
exports.default = Grid;
module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(206);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Input, _ComBase);

  function Input() {
    (0, _classCallCheck3.default)(this, Input);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Input.prototype.handleKeyDown = function handleKeyDown(event) {
    var _props = this.props,
        onPressEnter = _props.onPressEnter,
        onKeyDown = _props.onKeyDown;

    if (event.keyCode === _common.KeyCode.ENTER && onPressEnter) {
      onPressEnter(new _common.EventArgs(this, null, event));
    }
    if (onKeyDown) {
      onKeyDown(new _common.EventArgs(this, event.keyCode, event));
    }
  };

  Input.prototype.renderInputWithIcon = function renderInputWithIcon(input) {
    var _props2 = this.props,
        prefix = _props2.prefix,
        suffix = _props2.suffix;

    if (!prefix && !suffix) return input;

    var preEle = prefix ? _react2.default.createElement(
      'span',
      { className: (0, _common.cname)({ prefix: true }) },
      prefix
    ) : null;

    var sufEle = suffix ? _react2.default.createElement(
      'span',
      { className: (0, _common.cname)({ suffix: true }) },
      suffix
    ) : null;

    return _react2.default.createElement(
      'span',
      { className: (0, _common.cname)('inputWrapper') },
      preEle,
      input,
      sufEle
    );
  };

  Input.prototype.render = function render() {
    var _cname;

    var _props3 = this.props,
        type = _props3.type,
        size = _props3.size,
        className = _props3.className,
        readOnly = _props3.readOnly,
        value = _props3.value,
        defaultValue = _props3.defaultValue,
        multiple = _props3.multiple,
        rows = _props3.rows,
        maxLength = _props3.maxLength,
        other = (0, _objectWithoutProperties3.default)(_props3, ['type', 'size', 'className', 'readOnly', 'value', 'defaultValue', 'multiple', 'rows', 'maxLength']);


    var cls = (0, _common.cname)((_cname = {
      aniTransition: true,
      widget: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      input: true,
      inputMultiple: multiple
    }, _cname['size-' + size] = !multiple, _cname), className);

    return this.renderInputWithIcon(multiple ? _react2.default.createElement('textarea', (0, _extends3.default)({}, (0, _common.transportProps)(other), {
      className: cls,
      rows: rows,
      readOnly: readOnly,
      value: value,
      defaultValue: defaultValue,
      onKeyDown: this.handleKeyDown.bind(this),
      maxLength: maxLength
    })) : _react2.default.createElement('input', (0, _extends3.default)({}, (0, _common.transportProps)(other), {
      type: type,
      className: cls,
      readOnly: readOnly,
      value: value,
      defaultValue: defaultValue,
      onKeyDown: this.handleKeyDown.bind(this),
      maxLength: maxLength
    })));
  };

  return Input;
}(_common.ComBase), _class.propTypes = {
  /** 类型，意义和原生input一样 */
  type: _propTypes2.default.oneOf(['text', 'number', 'password']),
  /** 受控值 */
  value: _propTypes2.default.any,
  /** 默认值 */
  defaultValue: _propTypes2.default.any,
  /** 大小 */
  size: _propTypes2.default.oneOf(['hero', 'large', 'medium', 'small']),
  /** 是否只读 */
  readOnly: _propTypes2.default.bool,
  /** 输入回车时的回调 */
  onPressEnter: _propTypes2.default.func,
  /** 前缀图标 */
  prefix: _propTypes2.default.element,
  /** 后缀图标 */
  suffix: _propTypes2.default.element,
  /** 多行模式 */
  multiple: _propTypes2.default.bool,
  /** 多行模式可见行数 */
  rows: _propTypes2.default.number,
  /** 是否禁用 */
  disabled: _propTypes2.default.bool
}, _class.defaultProps = {
  type: 'text',
  size: 'medium',
  readOnly: false,
  multiple: false,
  disabled: false
}, _temp);
exports.default = Input;
module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

var rules = {
  required: /.+/,
  email: /[a-z0-9\-\_\.]+\@[a-z0-9\-\_\.]+/,
  number: function number(num) {
    return !isNaN(num);
  },
  len: function len(min, max) {
    return function (str) {
      return str && str.length >= min && str.length <= max;
    };
  },
  range: function range(min, max) {
    return function (num) {
      return num >= min && num <= max;
    };
  }
};

function validate(value, rule) {
  if (!rule) return true;
  if (_common.utils.isFunction(rule.test)) {
    return rule.test(value);
  } else if (_common.utils.isFunction(rule)) {
    return validate(value, { test: rule });
  } else if (_common.utils.isString(rule) && rule.includes('(')) {
    var ruleFunc = new Function('rules', 'return rules.' + rule)(rules);
    return validate(value, ruleFunc);
  } else if (_common.utils.isString(rule)) {
    return validate(value, rules[rule]);
  } else if (_common.utils.isArray(rule)) {
    return !rule.some(function (item) {
      return !validate(value, item);
    });
  } else {
    return true;
  }
}

validate.rules = rules;

exports.default = validate;
module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    alert: '提示',
    confirm: '确认',
    ok: '确定',
    cancel: '取消'
  },
  en: {
    alert: 'Alert',
    confirm: 'Confirm',
    ok: 'Ok',
    cancel: 'Cancel'
  }
});
module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(26)(function () {
  return Object.defineProperty(__webpack_require__(49)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(20);
var toIObject = __webpack_require__(21);
var arrayIndexOf = __webpack_require__(110)(false);
var IE_PROTO = __webpack_require__(53)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(36);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(52);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(119)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(76)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(37);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(77);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(39);
var $iterCreate = __webpack_require__(120);
var setToStringTag = __webpack_require__(44);
var getPrototypeOf = __webpack_require__(122);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(19);


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var global = __webpack_require__(10);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(39);
var TO_STRING_TAG = __webpack_require__(11)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(126), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(77);
var META = __webpack_require__(127).KEY;
var $fails = __webpack_require__(26);
var shared = __webpack_require__(54);
var setToStringTag = __webpack_require__(44);
var uid = __webpack_require__(43);
var wks = __webpack_require__(11);
var wksExt = __webpack_require__(59);
var wksDefine = __webpack_require__(60);
var enumKeys = __webpack_require__(128);
var isArray = __webpack_require__(129);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(17);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(50);
var createDesc = __webpack_require__(42);
var _create = __webpack_require__(58);
var gOPNExt = __webpack_require__(130);
var $GOPD = __webpack_require__(83);
var $DP = __webpack_require__(16);
var $keys = __webpack_require__(27);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(82).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(38).f = $propertyIsEnumerable;
  __webpack_require__(56).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(37)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(19)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(72);
var hiddenKeys = __webpack_require__(55).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(38);
var createDesc = __webpack_require__(42);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(50);
var has = __webpack_require__(20);
var IE8_DOM_DEFINE = __webpack_require__(71);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {



/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.log = log;
exports.info = info;
exports.warn = warn;
exports.error = error;

var _$config = __webpack_require__(62);

var _$config2 = _interopRequireDefault(_$config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_PROD = _$config2.default.env != 'dev';

/**
 * 打印 log
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function log() {
  var _console;

  if (IS_PROD) return;
  return (_console = console).log.apply(_console, arguments); //eslint-disable-line
}

/**
 * 打印 info 
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function info() {
  var _console2;

  if (IS_PROD) return;
  return (_console2 = console).info.apply(_console2, arguments); //eslint-disable-line
}

/**
 * 打印 warn 
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function warn() {
  var _console3;

  if (IS_PROD) return;
  return (_console3 = console).warn.apply(_console3, arguments); //eslint-disable-line
}

/**
 * 打印 error 
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function error() {
  var _console4;

  if (IS_PROD) return;
  return (_console4 = console).error.apply(_console4, arguments); //eslint-disable-line
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _$config = __webpack_require__(62);

var _$config2 = _interopRequireDefault(_$config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TheError = function (_Error) {
  (0, _inherits3.default)(TheError, _Error);

  function TheError(message) {
    (0, _classCallCheck3.default)(this, TheError);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, _Error.call.apply(_Error, [this, '[' + _$config2.default.name + ']: ' + message].concat(args)));
  }

  return TheError;
}(Error);

exports.default = TheError;
module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Error = __webpack_require__(86);

var _Error2 = _interopRequireDefault(_Error);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventArgs = function EventArgs(sender, detail, map) {
  var _this = this;

  (0, _classCallCheck3.default)(this, EventArgs);

  if (!sender) throw new _Error2.default('EventArgs constructor Parameter missing');
  _common.utils.each(map, function (name, value) {
    if (name in _this) return;
    if (_common.utils.isFunction(value)) {
      value = value.bind(map);
    }
    _this[name] = value;
  });
  this.sender = (0, _assign2.default)({}, sender);
  this.detail = detail;
  this.value = detail;
  this.sender.value = detail;
  if (!this.target) this.target = this.sender;
};

exports.default = EventArgs;
module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(36);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(15);
var aFunction = __webpack_require__(41);
var SPECIES = __webpack_require__(11)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var invoke = __webpack_require__(161);
var html = __webpack_require__(78);
var cel = __webpack_require__(49);
var global = __webpack_require__(10);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(36)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(64);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    format: {
      year: 'yyyy',
      month: 'yyyy-MM',
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      time: 'hh:mm:ss'
    },
    weeks: [{ text: '一', value: 1 }, { text: '二', value: 2 }, { text: '三', value: 3 }, { text: '四', value: 4 }, { text: '五', value: 5 }, { text: '六', value: 6 }, { text: '日', value: 0 }],
    today: '今天',
    ok: '确定',
    time: '时间',
    hours: '时',
    minutes: '分',
    seconds: '秒'
  },
  en: {
    format: {
      year: 'yyyy',
      month: 'yyyy-MM',
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      time: 'hh:mm:ss'
    },
    weeks: [{ text: 'Sun', value: 0 }, { text: 'Mon', value: 1 }, { text: 'Tue', value: 2 }, { text: 'Wed', value: 3 }, { text: 'Thu', value: 4 }, { text: 'Fri', value: 5 }, { text: 'Sat', value: 6 }],
    today: 'Now',
    ok: 'Ok',
    time: 'Time',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  }
});
module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        visible = _props.visible,
        padding = _props.padding,
        children = _props.children,
        style = _props.style,
        span = _props.span,
        _props$xs = _props.xs,
        xs = _props$xs === undefined ? span : _props$xs,
        _props$sm = _props.sm,
        sm = _props$sm === undefined ? span : _props$sm,
        _props$md = _props.md,
        md = _props$md === undefined ? span : _props$md,
        _props$lg = _props.lg,
        lg = _props$lg === undefined ? span : _props$lg,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'visible', 'padding', 'children', 'style', 'span', 'xs', 'sm', 'md', 'lg']);

    var names = (0, _common.cname)((_cname = {
      aniTransition: true,
      gridCol: true
    }, _cname['gridColXs-' + xs] = !!xs, _cname['gridColSm-' + sm] = !!sm, _cname['gridColMd-' + md] = !!md, _cname['gridColLg-' + lg] = !!lg, _cname.stateHidden = visible === false, _cname.stateVisible = visible === true, _cname), className);
    var element = _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), {
        style: style,
        className: names }),
      children
    );
    if (!_common.utils.isNull(padding)) {
      element = _react2.default.cloneElement(element, {
        style: (0, _extends3.default)({ padding: padding }, style)
      });
    }
    return element;
  };

  return Alert;
}(_common.ComBase), _class.propTypes = {

  /** 指定当前 col 的填充 */
  padding: _propTypes2.default.number,

  /** 超小屏幕(<768)时的宽度（1~24） */
  xs: _propTypes2.default.number,

  /** 小屏幕(768-992)时的宽度（1~24） */
  sm: _propTypes2.default.number,

  /** 中屏幕(992-1200)时的宽度（1~24） */
  md: _propTypes2.default.number,

  /** 大屏幕(>=1200)时的宽度（1~24） */
  lg: _propTypes2.default.number,

  /** 所有屏幕下的宽度（1~24） */
  span: _propTypes2.default.number,

  /** 类名 */
  className: _propTypes2.default.string,

  /** 可见性 */
  visible: _propTypes2.default.bool,

  /** 样式 */
  style: _propTypes2.default.object
}, _class.defaultProps = {}, _temp);
exports.default = Alert;
module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _ntils = __webpack_require__(45);

var _ntils2 = _interopRequireDefault(_ntils);

var _Item = __webpack_require__(194);

var _Item2 = _interopRequireDefault(_Item);

__webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreePicker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TreePicker, _Component);

  function TreePicker(props) {
    (0, _classCallCheck3.default)(this, TreePicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.onChange = function () {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          checkStrictly = _this$props.checkStrictly,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

      var result = [],
          treeData = _ntils2.default.clone(_this.dataSource, ['father']);
      _this.reduce(_this.dataSource, null, function (item) {
        if (item.selected) result.push(item);
      }, function (father) {
        if (!multiple || father.root || checkStrictly) return;
        //关联模式下，子节点全选，则仅保留父节点
        var childrenAllChecked = father.children.every(function (item) {
          return item.selected;
        });
        if (!childrenAllChecked) return;
        var childValues = father.children.map(function (item) {
          return item.value;
        });
        result = result.filter(function (item) {
          return childValues.indexOf(item.value) == -1;
        });
      });
      if (multiple && !checkStrictly) {
        treeData = treeData.filter(function (item) {
          return item.selected || item.childHasSelected;
        });
        _this.reduce(treeData, null, null, function (father) {
          father.children = father.children.filter(function (item) {
            return item.selected || item.childHasSelected;
          });
          if (father.selected) delete father.children;
        });
      }
      if (result.length == 0) {
        return onChange(multiple ? [] : '', multiple ? [] : {});
      }
      result = multiple ? result : result[0];
      var value = result.value || result.map(function (item) {
        return item.value;
      });
      onChange(value, _ntils2.default.clone(result, ['children']), _ntils2.default.clone(treeData, ['father']));
    };

    _this.reduceSingleSelected = function (value) {
      _this.reduce(_this.dataSource, null, function (item) {
        item.selected = item.value == value;
      });
    };

    _this.reduceMultipleSelected = function (values, selected) {
      if (!Array.isArray(values)) values = [values];
      var checkStrictly = _this.props.checkStrictly;

      _this.reduce(_this.dataSource, null, function (item) {
        var matched = values.indexOf(item.value) > -1;
        if (matched) item.selected = selected;
        if (checkStrictly) return;
        var childMustSelected = item.father.childMustSelected;

        if (typeof childMustSelected == 'boolean') {
          item.selected = childMustSelected;
        }
        if (!item.children || !item.children.length) return;
        item.childMustSelected = matched ? selected : childMustSelected;
      }, function (father) {
        if (checkStrictly || father.root) return;
        delete father.childMustSelected;
        var childrenAllSelected = father.children.every(function (item) {
          return item.selected;
        });
        father.selected = childrenAllSelected;
        father.childHasSelected = father.children.some(function (item) {
          return item.selected || item.childHasSelected;
        });
      });
    };

    _this.setSelected = function (values, selected) {
      if (typeof values == 'undefined') return;
      var multiple = _this.props.multiple;

      if (multiple) {
        _this.reduceMultipleSelected(values, selected);
      } else {
        _this.reduceSingleSelected(values);
      }
      _this.setActiveMenuState(_this.onChange);
    };

    _this.handleClickItem = function (value, isLeaf) {
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          leafOnly = _this$props2.leafOnly;

      _this.setActive(value);
      if (multiple) return;
      if (!leafOnly || leafOnly && isLeaf) return _this.setSelected(value, true);
    };

    _this.handleMouseOver = function (value) {
      var multiple = _this.props.multiple;

      if (multiple) return;
      _this.setActive(value);
    };

    _this.renderMenu = function (list, index) {
      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          leafOnly = _this$props3.leafOnly;

      if (!Array.isArray(list) || !list.length) return null;
      return _react2.default.createElement(
        'ul',
        { key: index, className: (0, _common.cname)('option-list') },
        list.map(function (item) {
          var childHasSelected = item.childHasSelected,
              selected = item.selected;

          return _react2.default.createElement(_Item2.default, (0, _extends3.default)({ key: item.value
          }, item, {
            indeterminate: !selected && childHasSelected,
            checked: selected,
            leafOnly: leafOnly,
            multiple: multiple,
            onMouseOver: _this.handleMouseOver.bind(_this, item.value),
            onSelect: _this.setSelected,
            onClick: _this.handleClickItem.bind(_this, item.value, item.isLeaf)
          }));
        })
      );
    };

    var _props$options = props.options,
        options = _props$options === undefined ? [] : _props$options;

    _this.dataSource = _ntils2.default.clone(options);
    _this.state = { menu: [] };
    return _this;
  }

  TreePicker.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        defaultValue = _props.defaultValue,
        options = _props.options,
        value = _props.value,
        multiple = _props.multiple;

    this.dataSource = _ntils2.default.clone(options);
    value = value || defaultValue || (multiple ? [] : '');
    this.setActive(Array.isArray(value) ? value[0] : value);
    this.setSelected(value, true);
  };

  TreePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value,
        multiple = nextProps.multiple;

    if (typeof value == 'undefined') return;
    if (multiple && (0, _stringify2.default)(value) === (0, _stringify2.default)(this.props.value)) return;
    if (!multiple && value === this.props.value) return;
    this.setSelected(value, true);
  };

  TreePicker.prototype.reduce = function reduce() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dataSource;
    var fatherData = arguments[1];

    var _this2 = this;

    var downReducer = arguments[2];
    var upReducer = arguments[3];

    if (!Array.isArray(list)) list = [];
    fatherData = fatherData || { root: true, children: list };
    list.forEach(function (item, index) {
      item.pos = (fatherData.pos ? fatherData.pos + '-' : '') + index;
      item.father = fatherData;
      downReducer && downReducer(item);
      if (!item.children || item.children.length == 0) return item.isLeaf = true;
      _this2.reduce(item.children, item, downReducer, upReducer);
    });
    upReducer && upReducer(fatherData);
  };

  // 设置菜单项的激活状态


  TreePicker.prototype.setActive = function setActive(value) {
    this.reduce(this.dataSource, null, function (item) {
      item.active = item.value == value;
    }, function (father) {
      if (!father.root) father.active = father.active || father.children.some(function (item) {
        return item.active;
      });
    });
    this.setActiveMenuState();
  };

  // 设置选中状态


  TreePicker.prototype.setActiveMenuState = function setActiveMenuState() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    var item = _ntils2.default.clone(this.dataSource, ['father']),
        menu = [item];
    while (item) {
      var activeItem = item.filter(function (item) {
        return item.active;
      })[0];
      item = activeItem && activeItem.children;
      if (item) menu.push(activeItem.children);
    }
    menu = JSON.parse((0, _stringify2.default)(menu));
    this.setState({ menu: menu }, callback);
  };

  TreePicker.prototype.render = function render() {
    var options = this.props.options;
    var menu = this.state.menu;

    if (!Array.isArray(options) || !options.length) return null;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('option-list-wrapper') },
      menu.map(this.renderMenu)
    );
  };

  return TreePicker;
}(_react.Component), _class.propTypes = {
  /** 当前值 */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  /** 默认值 */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  /** 数据源 */
  dataSource: _propTypes2.default.array.isRequired,
  /** 选中值变化时 */
  onChange: _propTypes2.default.func,
  /** 只能选择叶子节点 */
  leafOnly: _propTypes2.default.bool,
  /** 多选模式 */
  multiple: _propTypes2.default.bool,
  /** 严格选择，父子节点选中不关联 */
  checkStrictly: _propTypes2.default.bool
  //expandTriggerType: PropTypes.oneOf(['click', 'hover'])  //To Do
}, _class.defaultProps = {
  checkStrictly: false,
  multiple: false,
  leafOnly: false
  //expandTriggerType: 'click'
}, _temp);
exports.default = TreePicker;
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports) {

exports.SelectSize = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(217);

var _common = __webpack_require__(0);

var _validate = __webpack_require__(69);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = function (_ComBase) {
  (0, _inherits3.default)(FormItem, _ComBase);

  function FormItem() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FormItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { invalid: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  FormItem.prototype.wrapChildren = function wrapChildren(children, parentKey) {
    var _this2 = this;

    if (!children || !_common.utils.isObject(children)) return children;
    parentKey = parentKey || 'root';
    var _props = this.props,
        value = _props.value,
        onChange = _props.onChange,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['value', 'onChange']);

    var foundChildren = this.findChildren(null, children);
    return foundChildren.map(function (child, index) {
      var _React$cloneElement;

      if (!child || !child.type || _common.utils.isString(child.type)) return child;
      var selfKey = parentKey + '.' + index;
      var childProps = child.props || {};
      if (child.type == FormItem) {
        return _react2.default.cloneElement(child, { key: selfKey });
      }

      var _Object$assign = (0, _assign2.default)({}, otherProps, child.type),
          _Object$assign$valueP = _Object$assign.valuePropName,
          valuePropName = _Object$assign$valueP === undefined ? 'value' : _Object$assign$valueP,
          _Object$assign$valueP2 = _Object$assign.valuePath,
          valuePath = _Object$assign$valueP2 === undefined ? 'target.value' : _Object$assign$valueP2,
          _Object$assign$change = _Object$assign.changePropName,
          changePropName = _Object$assign$change === undefined ? 'onChange' : _Object$assign$change;

      var selfValue = valuePropName in childProps ? childProps[valuePropName] : value;
      return _react2.default.cloneElement(child, (_React$cloneElement = {
        key: selfKey,
        children: _this2.wrapChildren(childProps.children, selfKey)
      }, _React$cloneElement[valuePropName] = selfValue, _React$cloneElement[changePropName] = function (event) {
        if (event.stopPropagation) event.stopPropagation();
        if (childProps[changePropName]) {
          childProps[changePropName](event);
        }
        var value = _common.utils.getByPath(event, valuePath);
        var invalid = !(0, _validate2.default)(value, _this2.props.rule);
        _this2.setState({ invalid: invalid });
        if (onChange) onChange(new _common.EventArgs(_this2, {
          value: value, invalid: invalid
        }, event));
      }, _React$cloneElement));
    });
  };

  FormItem.prototype.renderLabel = function renderLabel() {
    if (this.props.label === false) return;
    return _react2.default.createElement(
      'label',
      { className: (0, _common.cname)('formItemLabel') },
      this.props.label
    );
  };

  FormItem.prototype.renderControl = function renderControl() {
    var controls = this.wrapChildren(this.props.children);
    if (this.props.label === false) return controls;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('formItemControl') },
      controls
    );
  };

  FormItem.prototype.render = function render() {
    var names = (0, _common.cname)({
      widget: true,
      formItem: true,
      aniTransition: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false,
      formItemNoLabel: this.props.label === false,
      formItemInvalid: !_common.utils.isNull(this.props.invalid) ? this.props.invalid : this.state.invalid
    }, this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names }),
      this.renderLabel(),
      this.renderControl()
    );
  };

  return FormItem;
}(_common.ComBase);

exports.default = FormItem;
module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Menu, _ComBase);

  function Menu() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      selectedKeys: _this.props.selectedKeys || _this.props.defaultSelectedKeys || []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Menu.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var props = {};
    if ('selectedKeys' in nextProps) {
      props.selectedKeys = nextProps.selectedKeys || [];
    }
    this.setState(props);
  };

  Menu.prototype.onSelect = function onSelect(e) {
    var key = e.detail.key;
    var selectMode = this.props.selectMode;

    var selectedKeys = this.state.selectedKeys;
    if (selectMode === 'multiple') {
      selectedKeys = selectedKeys.concat([key]);
    } else {
      selectedKeys = [key];
    }
    if (!('selectedKeys' in this.props)) {
      this.setState({
        selectedKeys: selectedKeys
      });
    }
    e.detail.selectedKeys = selectedKeys;
    this.props.onSelect(e);
  };

  Menu.prototype.onDeselect = function onDeselect(e) {
    var key = e.detail.key;

    var selectedKeys = this.state.selectedKeys;
    var index = selectedKeys.indexOf(key);
    index !== -1 && selectedKeys.splice(index, 1);
    if (!('selectedKeys' in this.props)) {
      this.setState({
        selectedKeys: selectedKeys
      });
    }
    e.detail.selectedKeys = selectedKeys;
    this.props.onDeselect(e);
  };

  Menu.prototype.renderMenuItem = function renderMenuItem(child) {
    var selectedKeys = this.state.selectedKeys;

    var isSelected = !child.props.disabled && selectedKeys.indexOf(child.key) > -1;
    var _props = this.props,
        selectMode = _props.selectMode,
        onClick = _props.onClick,
        mode = _props.mode;

    var newProps = {
      itemKey: child.key,
      disabled: child.props.disabled,
      selected: isSelected,
      mode: mode,
      selectMode: selectMode,
      selectedKeys: selectedKeys,
      onClick: onClick,
      onSelect: this.onSelect.bind(this),
      onDeselect: this.onDeselect.bind(this),
      onTitleClick: child.props.onTitleClick
    };
    return _react2.default.cloneElement(child, newProps);
  };

  Menu.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        className = _props2.className,
        style = _props2.style,
        children = _props2.children;


    var cls = (0, _common.cname)((_cname = {
      widget: true,
      widgetShadow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      menu: true
    }, _cname['menu-' + this.props.mode] = !!this.props.mode, _cname), className);

    return _react2.default.createElement(
      'ul',
      {
        style: style,
        className: cls
      },
      _react2.default.Children.map(children, this.renderMenuItem.bind(this))
    );
  };

  return Menu;
}(_common.ComBase), _class.propTypes = {
  /**
   * 展示模式
   */
  mode: _propTypes2.default.oneOf(['vertical', 'horizontal', 'inline']),
  /**
   * 选择模式
   */
  selectMode: _propTypes2.default.oneOf(['single', 'multiple']),
  /**
   * 当前选中的菜单项
   */
  selectedKeys: _propTypes2.default.array,
  /**
   * 默认选中的菜单项
   */
  defaultSelectedKeys: _propTypes2.default.array,
  /**
   * 点击菜单项时的回调
   */
  onClick: _propTypes2.default.func,
  /**
   * 选中菜单项时的回调
   */
  onSelect: _propTypes2.default.func,
  /**
   * 取消选中菜单项的回调
   */
  onDeselect: _propTypes2.default.func
}, _class.defaultProps = {
  mode: 'vertical',
  selectMode: 'single',
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onDeselect: function onDeselect() {}
}, _temp2);
exports.default = Menu;
module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

__webpack_require__(242);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(243);

var _option = __webpack_require__(244);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Select, _ComBase);

  function Select(props) {
    (0, _classCallCheck3.default)(this, Select);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var dataSource = _this.getDataSource();
    var defaultValue = _this.getDefaultValueSplit(props, dataSource);
    _this.state = {
      selectFocused: false,
      selectOpened: false,
      dataSource: dataSource,
      filterDataSource: dataSource, // 通过value过滤之后的下拉数据列表
      searchInput: '',
      value: defaultValue,
      selectedOptions: _this.getOptionsByValue(dataSource, defaultValue)
    };
    return _this;
  }

  Select.prototype.componentDidMount = function componentDidMount() {
    this.updateNodeWidth();
  };

  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dataSource = this.getDataSource(nextProps);
    var value = this.state.value;

    if (nextProps) {
      var newState = void 0;
      var propsIsChange = false;
      if (!_common.utils.isNull(nextProps.value) && nextProps.value !== value) {
        newState = newState || {};
        newState.value = nextProps.value;
        value = nextProps.value;
        propsIsChange = true;
      }
      if (dataSource && dataSource !== this.state.dataSource) {
        newState = newState || {};
        newState.dataSource = dataSource;
        propsIsChange = true;
      }

      if (propsIsChange) {
        if (dataSource && dataSource.length) {
          newState.filterDataSource = this.getFilterDataSource(dataSource);
          newState.selectedOptions = this.getOptionsByValue(dataSource, value);
        } else {
          newState.selectedOptions = { value: value, label: value };
        }
      }
      if (newState) {
        this.setState(newState);
      }
    }
  };

  // 下拉结果是否可被搜索，否则展示全部


  // 根据输入筛选下拉


  // 只有在多选模式下才可以启用全选


  Select.prototype.render = function render() {
    var _cname,
        _this2 = this;

    var dataSource = this.getDataSource();
    var value = this.props.showSearch && this.state.searchInput || this.state.value;
    var showText = this.getShowText(value, dataSource);
    var _props = this.props,
        visible = _props.visible,
        className = _props.className,
        size = _props.size,
        disabled = _props.disabled,
        mode = _props.mode,
        hasArrow = _props.hasArrow,
        allowClear = _props.allowClear,
        showSearch = _props.showSearch,
        resultRender = _props.resultRender,
        placeholder = _props.placeholder;
    var _state = this.state,
        selectFocused = _state.selectFocused,
        selectOpened = _state.selectOpened,
        selectedOptions = _state.selectedOptions;

    var showInput = showSearch || mode === _constants.SelectMode.COMBOBOX;
    var names = (0, _common.cname)((_cname = {
      widget: true,
      select: true
    }, _cname['size-' + size] = size, _cname.selectFocused = selectFocused, _cname.selectOpened = selectOpened, _cname.stateHidden = this.props.hasOwnProperty('visible') && !visible, _cname.stateDisabled = !!disabled, _cname), className);
    var barNames = (0, _common.cname)({
      selection: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      selectedClose: true,
      hasClearButton: allowClear
    });
    var selectedValueNode = !showSearch && resultRender ? resultRender(_common.utils.isArray(selectedOptions) ? selectedOptions : [selectedOptions]) : this.getSelectedValueNode(mode, selectedOptions);
    selectedValueNode = selectedValueNode || value;

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names,
        style: this.props.style }),
      _react2.default.createElement(
        'div',
        {
          ref: function ref(selection) {
            _this2.selection = selection;
          },
          className: barNames,
          onClick: this.onClickSelection },
        showInput ? _react2.default.createElement(_components.Input, { type: 'text',
          className: (0, _common.cname)('select-search'),
          size: size,
          value: showText || '',
          placeholder: placeholder,
          autofocus: 'autofocus',
          onChange: this.onInputChange }) : !_common.utils.isNull(value) ? _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('selected-value') },
          selectedValueNode
        ) : _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('selected-value selection-placeholder') },
          placeholder
        ),
        hasArrow ? _react2.default.createElement(_components.Icon, { type: 'arrow-down',
          className: (0, _common.cname)('select-arrow ani-transition') }) : null,
        allowClear ? _react2.default.createElement(_components.Icon, { type: 'wrong',
          className: (0, _common.cname)({
            clearButton: true,
            aniTransition: true
          }),
          onClick: this.onClickClearHandler }) : null
      ),
      this.getPopoverWrapper(),
      _react2.default.createElement(_components.Proxy, { target: document, onClick: this.onBlurFromDomHandler }),
      _react2.default.createElement(_components.Proxy, { target: window, onResize: this.updateNodeWidth })
    );
  };

  return Select;
}(_common.ComBase), _class.defaultProps = {
  size: 'medium',
  hasArrow: true,
  allowClear: false,
  mode: 'normal',
  showTagMenu: false,
  dropdownAutoHide: false,
  showSearch: false,
  showTitle: false,
  hasSelectAll: false,
  heightLimit: false
}, _class.propTypes = {
  /** 组件大小 */
  size: _propTypes2.default.oneOf(['hero', 'large', 'medium', 'small']),
  /** 是否显示箭头 */
  hasArrow: _propTypes2.default.bool,
  /** 是否显示清除按钮 */
  allowClear: _propTypes2.default.bool,
  /** 模式，默认单选 */
  mode: _propTypes2.default.oneOf(['normal', 'combobox', 'multiple']),
  /** 默认值，多选模式支持 `string[]` 或者 `string`（多个值用‘,’分隔） */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  /** 当前值，多选模式的话是 `Array` 类型 */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  /** 下拉数据，也可以通过 `children` 的方式设置 */
  dataSource: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string,
    disabled: _propTypes2.default.bool
  })),
  /** 下拉列表是否以 `tag` 模式显示（浮动显示） */
  showTagMenu: _propTypes2.default.bool,
  /** 选择 `option` 之后是否自动关闭 `dropdown`，仅对多选生效 */
  dropdownAutoHide: _propTypes2.default.bool,
  /** 是否显示搜索框，显示的话支持搜索 */
  showSearch: _propTypes2.default.bool,
  /** 是否显示原生 `title`，显示内容同 `label` */
  showTitle: _propTypes2.default.bool,
  /** 是否显示全选 */
  hasSelectAll: _propTypes2.default.bool,
  /** 自定义显示内容的函数，必须 `return` 一个 `component`，传参：`[{ label, value }]` */
  resultRender: _propTypes2.default.func,
  /** 下拉面板新增自定义渲染内容，注意和 `dropdownRender` 区别, `(dataSource) => element` */
  extendRender: _propTypes2.default.func,
  /** 自定义下拉面板内容，注意和 `extendRender` 区别，`(dataSource, selectedOptions) => ReactElement` */
  dropdownRender: _propTypes2.default.func,
  /** 是否限制当前值的高度，如果限制的话会左右滚动 */
  heightLimit: _propTypes2.default.bool,
  /** 选中 `option`，或 `input` 的 `value` 变化（combobox 模式下）时，调用此函数，`(eventArgs, options) => void` */
  onChange: _propTypes2.default.func,
  /** 搜索模式下 `input` 内容有更新的时候回调，`(eventArgs, options) => void` */
  onSearch: _propTypes2.default.func,
  /** 被选中时调用，参数为选中项的 value (或 key) 值，`(eventArgs, options) => void` */
  onSelect: _propTypes2.default.func,
  /** 取消选中时调用，参数为选中项的 value (或 key) 值，仅在 `multiple` 或 `tags` 模式下生效，`(eventArgs) => void` */
  onDeselect: _propTypes2.default.func,
  /** 输入框的 `placeholder`，仅限 `search` 模式和 `combobox` 模式 */
  placeholder: _propTypes2.default.string
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getDefaultValueSplit = function (props, dataSource) {
    var value = _this3.getDefaultValue(props, dataSource);
    if (props.mode === _constants.SelectMode.MULTIPLE) {
      // 多选
      var values = [];
      if (_common.utils.isArray(value)) {
        value.forEach(function (item) {
          values.push(typeof item === 'string' ? item : item.value);
        });
      } else if (typeof value === 'string') {
        values = value.split(',');
      } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value.value) {
        values.push(value.value);
      }
      return values;
    } else {
      // 单选, value取值按照 `state.value > props.value > props.defaultValue > dataSource[0].value` 的优先级
      return value;
    }
  };

  this.getDefaultValue = function (props, dataSource) {
    var placeholder = _this3.props.placeholder;
    //value取值按照 `state.value > props.value > props.defaultValue > dataSource[0].value` 的优先级

    if (!_common.utils.isNull(props.value)) {
      return props.value;
    }
    if (!_common.utils.isNull(props.defaultValue)) {
      return props.defaultValue;
    }
    if (!placeholder && dataSource && dataSource.length > 0) {
      return dataSource[0].value || '';
    }
  };

  this.getDataSource = function (props) {
    props = props || _this3.props;
    var data = [];
    var _props2 = props,
        dataSource = _props2.dataSource;

    var options = _this3.findChildren(_option2.default, props.children);
    if (dataSource) {
      dataSource.forEach(function (item, index) {
        if (item.hasOwnProperty('text')) {
          // 兼容text属性，转化成label
          item.label = item.text;
        }
        data.push({
          value: !_common.utils.isNull(item.value) ? item.value : item || '',
          label: !_common.utils.isNull(item.label) ? item.label : item.value || item || '',
          disabled: !!item.disabled,
          id: index
        });
      });
      data = _common.utils.filterDuplicate(data, 'value');
    } else if (options && options.length) {
      options.forEach(function (item, index) {
        data.push({
          value: !_common.utils.isNull(item.props.value) ? item.props.value : item.props.children || '',
          label: !_common.utils.isNull(item.props.children) ? item.props.children : item.props.label || item.props.text || '',
          disabled: !!item.props.disabled,
          id: index
        });
      });
      data = _common.utils.filterDuplicate(data, 'value');
    }
    return data;
  };

  this.onBlurFromDomHandler = function (e) {
    if (!_this3.popover) return;
    if (!_common.utils.inContainer(_this3.domNode, e.target) && !_common.utils.inContainer(_this3.popover.domNode, e.target)) {
      _this3.setState({
        selectOpened: false,
        selectFocused: false,
        searchInput: ''
      });
    }
  };

  this.onClickSelection = function () {
    if (_this3.props.disabled) return;
    var showSearch = _this3.isFilterable();
    _this3.setState({
      selectOpened: showSearch || !_this3.state.selectOpened,
      selectFocused: true,
      showSearchInput: showSearch,
      filterDataSource: _this3.getFilterDataSource(_this3.state.dataSource)
    });
    return true;
  };

  this.onSelectOption = function (param) {
    var _props3 = _this3.props,
        onChange = _props3.onChange,
        onSelect = _props3.onSelect,
        mode = _props3.mode,
        showSearch = _props3.showSearch,
        dropdownAutoHide = _props3.dropdownAutoHide;

    var selectedValue = !_common.utils.isNull(_this3.props.value) ? _this3.props.value : param.value;
    var dataSource = _this3.state.dataSource;

    var stateValue = {};
    var value = _this3.valueFactory(dataSource, selectedValue);
    stateValue.selectFocused = false;
    stateValue.selectOpened = mode === _constants.SelectMode.MULTIPLE ? !dropdownAutoHide : false;
    stateValue.value = value;
    stateValue.selectedOptions = _this3.getOptionsByValue(dataSource, value);
    if (showSearch) {
      stateValue.searchInput = '';
      stateValue.filterDataSource = _this3.getFilterDataSource(dataSource, undefined);
      stateValue.showSearchInput = false;
    }
    _this3.setState(stateValue, function () {
      if (mode === _constants.SelectMode.COMBOBOX) {
        var searchInput = _this3.getShowText(value, dataSource);
        _this3.setState({ searchInput: searchInput });
      }
    });
    var currentValue = _this3.valueFactory(dataSource, param.value);
    onChange && onChange(new _common.EventArgs(_this3, currentValue), _this3.getOptionsByValue(dataSource, currentValue));
    onSelect && onSelect(new _common.EventArgs(_this3, currentValue), _this3.getOptionsByValue(dataSource, currentValue));
  };

  this.onSelectAllOption = function () {
    var onChange = _this3.props.onChange;
    var dataSource = _this3.state.dataSource;

    var stateValue = {};
    var selectedValue = dataSource.filter(function (item) {
      return !item.disabled;
    }).map(function (item) {
      return item.value;
    });
    var value = _this3.valueFactory(dataSource, selectedValue);
    stateValue.value = value;
    stateValue.selectedOptions = _this3.getOptionsByValue(dataSource, value);
    _this3.setState(stateValue);
    onChange && onChange(new _common.EventArgs(_this3, value), _this3.getOptionsByValue(dataSource, value));
  };

  this.updateNodeWidth = function () {
    _this3.setState({
      nodeWidth: _this3.domNode.offsetWidth
    });
  };

  this.onDeleteSelectedItem = function (val) {
    var _props4 = _this3.props,
        onChange = _props4.onChange,
        onDeselect = _props4.onDeselect,
        disabled = _props4.disabled,
        mode = _props4.mode;

    if (disabled) return false;
    var dataSource = _this3.state.dataSource;
    var value = !_common.utils.isNull(_this3.props.value) ? _this3.valueFactory(dataSource, _this3.props.value) : _this3.valueFactory(dataSource, val);
    _this3.setState({
      value: value,
      selectedOptions: _this3.getOptionsByValue(dataSource, value)
    });
    onChange && onChange(new _common.EventArgs(_this3, _this3.valueFactory(dataSource, val)), _this3.getOptionsByValue(dataSource, _this3.valueFactory(dataSource, val)));
    if (mode === _constants.SelectMode.MULTIPLE || mode === _constants.SelectMode.TAGS) {
      onDeselect && onDeselect(new _common.EventArgs(_this3, _this3.valueFactory(dataSource, val)));
    }
    return true;
  };

  this.valueFactory = function (dataSource, selectedValue) {
    var outValue = '';
    var mode = _this3.props.mode;
    var value = _this3.state.value;


    if (dataSource && dataSource.length) {
      if (mode === _constants.SelectMode.MULTIPLE) {
        outValue = value ? value.concat([]) : [];
        if (outValue && outValue.length && outValue.indexOf(selectedValue) > -1) {
          //删除
          outValue.splice(outValue.indexOf(selectedValue), 1);
        } else {
          outValue = _common.utils.filterDuplicate(outValue.concat(selectedValue));
        }
      } else {
        outValue = selectedValue;
      }
    }
    return outValue;
  };

  this.getPopoverWrapper = function () {
    var _cname2;

    var _props5 = _this3.props,
        size = _props5.size,
        showTagMenu = _props5.showTagMenu,
        extendRender = _props5.extendRender,
        dropdownRender = _props5.dropdownRender,
        showTitle = _props5.showTitle,
        _props5$allowedDirect = _props5.allowedDirection,
        allowedDirection = _props5$allowedDirect === undefined ? ['bottom', 'top'] : _props5$allowedDirect;
    var _state2 = _this3.state,
        value = _state2.value,
        selectedOptions = _state2.selectedOptions;
    var _state3 = _this3.state,
        selectOpened = _state3.selectOpened,
        nodeWidth = _state3.nodeWidth,
        filterDataSource = _state3.filterDataSource;

    var dropdownNames = (0, _common.cname)((_cname2 = {
      selectDropdown: true
    }, _cname2['dropdown-size-' + size] = size, _cname2));
    var dropdownMenuNames = (0, _common.cname)({
      selectDropdownMenu: true,
      stateHidden: !selectOpened,
      tagMenu: showTagMenu
    });
    var isVisible = selectOpened && filterDataSource.length;
    if (isVisible && nodeWidth <= 0) {
      setTimeout(function () {
        return _this3.updateNodeWidth();
      }, 0);
    }
    return _react2.default.createElement(
      _components.Popover,
      {
        ref: function ref(_ref) {
          return _this3.popover = _ref;
        },
        follow: _this3.selection,
        overlay: false,
        allowedDirection: allowedDirection,
        visible: isVisible,
        style: { width: nodeWidth },
        className: (0, _common.cname)([dropdownNames], 'dropdown') },
      dropdownRender ? dropdownRender(_this3.getDataSource(), selectedOptions) : _react2.default.createElement(
        'div',
        { className: dropdownMenuNames },
        _this3.getOptionHeader(),
        _react2.default.createElement(
          'ul',
          null,
          filterDataSource && filterDataSource.map(function (item, index) {
            var optSelected = _common.utils.isArray(value) ? value.indexOf(item.value) > -1 : value === item.value;
            return _react2.default.createElement(
              _option2.default,
              { id: item.id,
                disabled: item.disabled,
                selected: optSelected,
                tagMenu: showTagMenu,
                value: item.value,
                label: item.label,
                key: index,
                size: size,
                showTitle: showTitle,
                onSelect: _this3.onSelectOption },
              item.label
            );
          })
        ),
        extendRender && extendRender(filterDataSource)
      )
    );
  };

  this.getSelectedValueNode = function (mode, valueAndLabel) {
    var heightLimit = _this3.props.heightLimit;


    var names = (0, _common.cname)({
      heightLimit: heightLimit,
      selectedValueListWrapper: true
    });
    return mode === _constants.SelectMode.MULTIPLE && _common.utils.isArray(valueAndLabel) ? _react2.default.createElement(
      'div',
      { className: (0, _common.cname)(names) },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('selected-value-list') },
        valueAndLabel.map(function (item, index) {
          return _react2.default.createElement(
            'span',
            { key: index, className: (0, _common.cname)('selected-value-item') },
            _react2.default.createElement(
              'span',
              { className: (0, _common.cname)('selected-value-label') },
              item.label
            ),
            _react2.default.createElement(_components.Icon, { type: 'close',
              className: (0, _common.cname)('selected-close'),
              onClick: function onClick() {
                return _this3.onDeleteSelectedItem(item.value);
              }
            })
          );
        })
      )
    ) : valueAndLabel.label;
  };

  this.onInputChange = function (e) {
    e.stopPropagation();
    var value = e.target.value;
    var _props6 = _this3.props,
        showSearch = _props6.showSearch,
        mode = _props6.mode,
        onChange = _props6.onChange,
        onSearch = _props6.onSearch;

    var filterDataSource = _this3.getFilterDataSource(_this3.state.dataSource, value || '');

    _this3.setState({
      filterDataSource: filterDataSource,
      searchInput: value
    });

    if (mode === _constants.SelectMode.COMBOBOX) {
      onChange && onChange(new _common.EventArgs(_this3, value));
    } else if (showSearch) {
      onSearch && onSearch(new _common.EventArgs(_this3, value));
    }
  };

  this.getShowText = function (value, dataSource) {
    // 根据 value 获取 label
    dataSource = dataSource || _this3.state.dataSource;

    if (_this3.state.selectOpened) {
      return _this3.state.searchInput;
    } else {
      var f = dataSource.filter(function (item) {
        return item.value === value;
      });
      if (f && f.length > 0) {
        return f[0].label;
      } else {
        return value;
      }
    }
  };

  this.onClickClearHandler = function () {
    var dataSource = _this3.getDataSource(_this3.props);
    var onChange = _this3.props.onChange;

    var clearedValue = undefined;
    var selectedValue = !_common.utils.isNull(_this3.props.value) ? _this3.props.value : clearedValue;
    _this3.setState({
      value: selectedValue,
      selectedOptions: _this3.getOptionsByValue(dataSource, selectedValue)
    });
    onChange && onChange(new _common.EventArgs(_this3, clearedValue), []);
  };

  this.isFilterable = function () {
    var _props7 = _this3.props,
        mode = _props7.mode,
        showSearch = _props7.showSearch;

    return mode === _constants.SelectMode.COMBOBOX || !!showSearch;
  };

  this.getFilterDataSource = function (dataSource, filterValue) {
    var opts = [];
    var inputText = _common.utils.isNull(filterValue) ? _this3.state.searchInput : filterValue;
    var isFilterable = _this3.isFilterable();

    if (isFilterable && inputText) {
      if (dataSource && dataSource.length) {
        dataSource.forEach(function (item) {
          if (item.label.indexOf(inputText) > -1) {
            opts.push(item);
          }
        });
      }
    } else {
      opts = dataSource;
    }
    return opts;
  };

  this.getSelectAllValidate = function () {
    var _props8 = _this3.props,
        mode = _props8.mode,
        hasSelectAll = _props8.hasSelectAll;

    return !!hasSelectAll && mode === _constants.SelectMode.MULTIPLE;
  };

  this.checkSelectAllValue = function () {
    var _state4 = _this3.state,
        value = _state4.value,
        dataSource = _state4.dataSource;

    var checked = true;
    dataSource.forEach(function (item) {
      if (checked && !item.disabled) {
        checked = value.indexOf(item.value) == -1 ? false : true;
      }
    });
    return checked;
  };

  this.getOptionHeader = function () {
    var show = _this3.getSelectAllValidate();
    var node = null;

    if (show) {
      var selectedAll = _this3.checkSelectAllValue();
      var names = (0, _common.cname)({
        optionHeader: true,
        selected: selectedAll
      });
      node = _react2.default.createElement(
        'div',
        { className: names,
          onClick: function onClick() {
            !selectedAll && _this3.onSelectAllOption();
          } },
        '\u9009\u62E9\u5168\u90E8'
      );
    }
    return node;
  };

  this.getOptionsByValue = function (dataSource, value) {
    var opts = [];
    if (dataSource && dataSource.length) {
      if (_common.utils.isArray(value)) {
        value.forEach(function (vItem) {
          dataSource.forEach(function (item) {
            if (item.value === vItem) {
              opts.push(item);
            }
          });
        });
      } else {
        dataSource.forEach(function (item) {
          if (item.value === value) {
            opts = item;
          }
        });
      }
    }
    return opts;
  };
}, _temp);


Select.Option = _option2.default;
exports.default = Select;
module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var React = _interopRequireWildcard(_react);

var _components = __webpack_require__(7);

var _common = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Search, _ComBase);

  function Search() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange(e);
      }
    }, _this.handleClear = function (e) {
      e.preventDefault();

      var handleClear = _this.props.handleClear;
      if (handleClear) {
        handleClear(e);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Search.prototype.render = function render() {
    var _props = this.props,
        placeholder = _props.placeholder,
        value = _props.value,
        prefixCls = _props.prefixCls;

    var icon = value && value.length > 0 ? React.createElement(
      'a',
      { href: '#', className: prefixCls + '-action', onClick: this.handleClear },
      React.createElement(_components.Icon, { type: 'cross-circle' })
    ) : React.createElement(
      'span',
      { className: prefixCls + '-action' },
      React.createElement(_components.Icon, { type: 'search' })
    );

    return React.createElement(
      'div',
      null,
      React.createElement(_components.Input, {
        placeholder: placeholder,
        className: prefixCls,
        value: value,
        ref: 'input',
        onChange: this.handleChange
      }),
      icon
    );
  };

  return Search;
}(_common.ComBase), _class.defaultProps = {
  placeholder: ''
}, _temp2);
exports.default = Search;
module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

var _regenerator = __webpack_require__(32);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(33);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _i18n = __webpack_require__(70);

var _i18n2 = _interopRequireDefault(_i18n);

var _ntils = __webpack_require__(45);

var _ntils2 = _interopRequireDefault(_ntils);

__webpack_require__(298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_DELAY = 25;
var DISTORY_DELAY = 500;

var Alert = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { visible: false, time: -1 }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Alert.prototype.render = function render() {
    return _react2.default.createElement(
      _components.Dialog,
      (0, _extends3.default)({}, this.props, {
        className: (0, _common.cname)('notificationAlert', this.props.className),
        visible: this.state.visible }),
      this.renderContent()
    );
  };

  Alert.prototype.renderContent = function renderContent() {
    var content = this.props.content;

    return _ntils2.default.isFunction(content) ? content(this.state) : content;
  };

  Alert.prototype.countDown = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(time) {
      var onClose;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onClose = this.props.onClose;

              if (!(time <= 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', onClose ? onClose() : null);

            case 3:
              this.setState({ time: time });
              _context.next = 6;
              return (0, _common.sleep)(1000);

            case 6:
              this.countDown(--time);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function countDown(_x) {
      return _ref.apply(this, arguments);
    }

    return countDown;
  }();

  Alert.prototype.componentDidMount = function componentDidMount() {
    var duration = this.props.duration;

    if (duration > 0) this.countDown(duration);
  };

  Alert.prototype.show = function show() {
    this.setState({ visible: true });
  };

  Alert.prototype.close = function close() {
    this.setState({ visible: false });
  };

  return Alert;
}(_common.ComBase);

exports.default = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(content, opts) {
    var _this2 = this;

    var _cname, type, titleCls, iconMap;

    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:

            opts = opts || (0, _create2.default)(null);
            if (opts.title !== false) opts.title = opts.title || _i18n2.default.current.alert;
            if (opts.buttons !== false) opts.buttons = opts.buttons || [{
              text: _i18n2.default.current.ok,
              type: 'primary'
            }];
            opts.content = content || '';
            if (opts.type) {
              type = opts.type;
              titleCls = (0, _common.cname)((_cname = {
                'type-alert-title-wrapper': true
              }, _cname[type] = !!type, _cname));
              iconMap = {
                info: 'info',
                error: 'wrong',
                success: 'right',
                warning: 'bang'
              };


              opts.title = _react2.default.createElement(
                'span',
                { className: titleCls },
                _react2.default.createElement(_components.Icon, { type: iconMap[opts.type], className: (0, _common.cname)('alert-icon') }),
                _react2.default.createElement(
                  'span',
                  { className: (0, _common.cname)('alert-title') },
                  opts.title
                )
              );
              opts.content = _react2.default.createElement(
                'p',
                { className: (0, _common.cname)('type-alert-content') },
                opts.content
              );
            }
            return _context5.abrupt('return', new _promise2.default(function () {
              var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(resolve) {
                var alertInstance, closeAndDistory;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        alertInstance = void 0;
                        //关闭并且销毁

                        closeAndDistory = function () {
                          var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(btnIndex) {
                            return _regenerator2.default.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    resolve(btnIndex);
                                    alertInstance.close();
                                    _context2.next = 4;
                                    return (0, _common.sleep)(DISTORY_DELAY);

                                  case 4:
                                    (0, _common.unmount)(alertInstance);

                                  case 5:
                                  case 'end':
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, _this2);
                          }));

                          return function closeAndDistory(_x5) {
                            return _ref4.apply(this, arguments);
                          };
                        }();

                        opts.onClose = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                          return _regenerator2.default.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  return _context3.abrupt('return', closeAndDistory(-1));

                                case 1:
                                case 'end':
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, _this2);
                        }));
                        opts.onButtonClick = function (event) {
                          return closeAndDistory(event.detail);
                        };
                        _context4.next = 6;
                        return (0, _common.render)(_react2.default.createElement(Alert, opts));

                      case 6:
                        alertInstance = _context4.sent;
                        _context4.next = 9;
                        return (0, _common.sleep)(SHOW_DELAY);

                      case 9:
                        alertInstance.show();

                      case 10:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this2);
              }));

              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 6:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  function alert(_x2, _x3) {
    return _ref2.apply(this, arguments);
  }

  return alert;
}();

module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(32);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(33);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

__webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_DELAY = 25;
var SHOW_DURATION = 1500;
var COLLECT_DELAY = 300;
var HIDE_MIN_INTERVAL = 600;

//toast 框
var Toast = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Toast, _ComBase);

  function Toast() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { visible: false, collect: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Toast.prototype.render = function render() {
    var _cname, _cname2;

    var names = (0, _common.cname)((_cname = {
      toast: true,
      aniTransition: true,
      widget: true,
      widgetShadow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      stateHidden: !this.state.visible,
      stateVisible: this.state.visible,
      stateCollect: this.state.collect
    }, _cname['align-' + (this.props.align || 'right')] = true, _cname), this.props.className);

    var _props = this.props,
        content = _props.content,
        type = _props.type,
        closable = _props.closable;

    var detail = '';
    var title = '';
    if (typeof content == 'string') {
      title = content;
    } else {
      title = content.title;
      detail = content.detail;
    }

    var contentCls = (0, _common.cname)((_cname2 = {
      'toast-content-wrapper': true
    }, _cname2[type] = !!type, _cname2));

    var iconMap = {
      info: 'info',
      error: 'wrong',
      success: 'right',
      warning: 'bang'
    };

    var contentDom = _react2.default.createElement(
      'div',
      { className: contentCls },
      type != 'info' && _react2.default.createElement(_components.Icon, { type: iconMap[type], className: (0, _common.cname)('toast-icon') }),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('content') },
        _react2.default.createElement(
          'p',
          { className: (0, _common.cname)('title') },
          title
        ),
        detail && _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('detail') },
          detail
        )
      )
    );

    return _react2.default.createElement(
      'div',
      { className: names },
      closable && _react2.default.createElement(_components.Icon, { type: 'close', onClick: this.hide.bind(this) }),
      contentDom
    );
  };

  Toast.prototype.show = function show() {
    this.setState({ visible: true });
  };

  Toast.prototype.hide = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.setState({ visible: false });
              _context.next = 3;
              return (0, _common.sleep)(COLLECT_DELAY);

            case 3:
              this.setState({ collect: true });
              if (this.props.onHide) {
                this.props.onHide(new _common.EventArgs(this, {
                  item: this,
                  dataItem: this.props.dataItem
                }));
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function hide() {
      return _ref.apply(this, arguments);
    }

    return hide;
  }();

  Toast.prototype.componentDidMount = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _common.sleep)(SHOW_DELAY);

            case 2:
              this.show();

              if (!(this.props.duration > 0)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 6;
              return (0, _common.sleep)(this.props.duration);

            case 6:
              this.hide();

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function componentDidMount() {
      return _ref2.apply(this, arguments);
    }

    return componentDidMount;
  }();

  return Toast;
}(_common.ComBase), _class.defaultProps = {
  type: 'info',
  closable: false
}, _temp2);


var stack = void 0; //显示栈单例
var prevTime = 0;
var prevDuration = 0;

//toast 显示栈

var Stack = function (_ComBase2) {
  (0, _inherits3.default)(Stack, _ComBase2);

  function Stack() {
    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, Stack);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ComBase2.call.apply(_ComBase2, [this].concat(args))), _this2), _this2.state = { items: [] }, _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  Stack.prototype.render = function render() {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('toast-stack') },
      this.state.items.map(function (item) {
        return _react2.default.createElement(
          Toast,
          (0, _extends3.default)({ key: item.key
          }, item, {
            dataItem: item,
            onHide: _this3.onHide.bind(_this3, item) }),
          item.content
        );
      })
    );
  };

  Stack.prototype.onHide = function onHide(item) {
    item.removed = true;
  };

  Stack.prototype.add = function add(newItem) {
    //拿到所有正在显示的项
    var items = this.state.items.filter(function (item) {
      return !item.removed;
    });
    //处理新项
    newItem.key = _common.utils.newGuid();
    newItem.duration = newItem.duration || SHOW_DURATION;
    //无论 duration 多少都确保先显示的先消失
    var prevPemainingTime = prevDuration - (Date.now() - prevTime);
    if (items.length > 0 && prevDuration > 0 && prevPemainingTime > 0 && newItem.duration - prevPemainingTime < HIDE_MIN_INTERVAL) {
      newItem.duration += HIDE_MIN_INTERVAL - (newItem.duration - prevPemainingTime);
    }
    items.push(newItem);
    this.setState({ items: items });
    //记录上次信息
    prevDuration = newItem.duration;
    prevTime = Date.now();
  };

  return Stack;
}(_common.ComBase);

// toast 方法


exports.default = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(content, opts) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (stack) {
              _context3.next = 4;
              break;
            }

            _context3.next = 3;
            return (0, _common.render)(_react2.default.createElement(Stack, null));

          case 3:
            stack = _context3.sent;

          case 4:
            opts = opts || {};
            opts.content = content || '';
            stack.add(opts);

          case 7:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  function toast(_x, _x2) {
    return _ref3.apply(this, arguments);
  }

  return toast;
}();

module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(106);


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__(7);

var _index2 = _interopRequireDefault(_index);

var _common = __webpack_require__(0);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//注意不要改动上边的 components 引入代码
//因为 babel-import-plugin 有点问题，只能这样写

exports.default = (0, _extends3.default)({}, _index2.default, { common: _common2.default });
module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
module.exports = __webpack_require__(9).Object.assign;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(13);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(109) });


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(38);
var toObject = __webpack_require__(57);
var IObject = __webpack_require__(73);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(26)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(21);
var toLength = __webpack_require__(74);
var toAbsoluteIndex = __webpack_require__(111);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(52);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Alert/index.js": 113,
	"./Breadcrumb/index.js": 171,
	"./Button/index.js": 174,
	"./Calendar/index.js": 66,
	"./Card/index.js": 182,
	"./Carousel/index.js": 184,
	"./Cascader/TreeSelect/index.js": 96,
	"./Cascader/index.js": 196,
	"./CheckBox/index.js": 199,
	"./CheckBoxGroup/index.js": 201,
	"./DatePicker/index.js": 203,
	"./DateRangePicker/index.js": 208,
	"./Dialog/index.js": 212,
	"./Form/index.js": 214,
	"./Grid/index.js": 67,
	"./HyperText/index.js": 220,
	"./Icon/index.js": 31,
	"./Input/index.js": 68,
	"./InputNumber/index.js": 222,
	"./Loading/index.js": 225,
	"./Menu/index.js": 228,
	"./Overlay/index.js": 232,
	"./Pagination/index.js": 234,
	"./Popover/index.js": 47,
	"./Progress/index.js": 246,
	"./Proxy/index.js": 48,
	"./Radio/index.js": 248,
	"./RadioGroup/index.js": 250,
	"./SchemaForm/index.js": 251,
	"./Select/index.js": 100,
	"./Slider/index.js": 252,
	"./Sort/index.js": 254,
	"./Steps/index.js": 256,
	"./Switch/index.js": 260,
	"./Table/index.js": 262,
	"./Tabs/index.js": 269,
	"./Tag/index.js": 273,
	"./Tags/index.js": 275,
	"./Timeline/index.js": 277,
	"./Tooltip/index.js": 280,
	"./Transfer/index.js": 282,
	"./Tree/index.js": 288,
	"./Upload/index.js": 292,
	"./Validator/index.js": 294,
	"./index.js": 7,
	"./notification/index.js": 297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(143);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert(props) {
    (0, _classCallCheck3.default)(this, Alert);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.onClose = function () {
      _this.setState({ closed: true });
    };

    _this.state = {
      closed: false
    };
    return _this;
  }

  Alert.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        shadow = _props.shadow,
        type = _props.type,
        visible = _props.visible,
        className = _props.className,
        children = _props.children,
        closable = _props.closable;

    var names = (0, _common.cname)((_cname = {
      widget: true,
      aniTransition: true,
      widgetShadow: shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      alert: true
    }, _cname['alert-' + (type || 'success')] = true, _cname.stateHidden = visible === false, _cname.stateVisible = visible !== false, _cname), className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({
        className: names,
        style: this.style
      }, (0, _common.transportProps)(this.props)),
      _react2.default.createElement(_components.Icon, { type: this.tipIconType, className: (0, _common.cname)('tip-icon') }),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('content') },
        children
      ),
      closable && _react2.default.createElement(
        'i',
        { className: (0, _common.cname)('close-icon'), onClick: this.onClose },
        '\u2715'
      )
    );
  };

  (0, _createClass3.default)(Alert, [{
    key: 'style',
    get: function get() {
      var style = this.props.style || {};

      return (0, _assign2.default)(style, {
        display: this.state.closed ? 'none' : 'block'
      });
    }
  }, {
    key: 'tipIconType',
    get: function get() {
      var map = {
        info: 'info',
        error: 'wrong',
        danger: 'wrong',
        success: 'right',
        warning: 'bang'
      };

      return map[this.props.type];
    }
  }]);
  return Alert;
}(_common.ComBase), _class.propTypes = {
  /** 类名 */
  className: _propTypes2.default.string,
  /** 可见性 */
  visible: _propTypes2.default.bool,
  /** 类型 */
  type: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger']),
  /** 阴影 */
  shadow: _propTypes2.default.bool,
  /** 显示关闭按钮 */
  closable: _propTypes2.default.bool
}, _class.defaultProps = {
  type: 'info',
  visible: true,
  shadow: false,
  closable: false
}, _temp);
exports.default = Alert;
module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(115), __esModule: true };

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
var $Object = __webpack_require__(9).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(118), __esModule: true };

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(79);
module.exports = __webpack_require__(59).f('iterator');


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(52);
var defined = __webpack_require__(51);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(58);
var descriptor = __webpack_require__(42);
var setToStringTag = __webpack_require__(44);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(19)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(15);
var getKeys = __webpack_require__(27);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(20);
var toObject = __webpack_require__(57);
var IE_PROTO = __webpack_require__(53)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(124);
var step = __webpack_require__(125);
var Iterators = __webpack_require__(39);
var toIObject = __webpack_require__(21);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(76)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81);
__webpack_require__(84);
__webpack_require__(131);
__webpack_require__(132);
module.exports = __webpack_require__(9).Symbol;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(43)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(20);
var setDesc = __webpack_require__(16).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(26)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(38);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(36);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(21);
var gOPN = __webpack_require__(82).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('asyncIterator');


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('observable');


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
module.exports = __webpack_require__(9).Object.setPrototypeOf;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(13);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(136).set });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(15);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(35)(Function.call, __webpack_require__(83).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
var $Object = __webpack_require__(9).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(58) });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(140);
var invariant = __webpack_require__(141);
var ReactPropTypesSecret = __webpack_require__(142);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ComBase.js": 29,
	"./Error.js": 86,
	"./EventArgs.js": 87,
	"./KeyCode.js": 150,
	"./Locale.js": 151,
	"./cname.js": 23,
	"./console.js": 85,
	"./index.js": 0,
	"./meta.js": 152,
	"./render.js": 153,
	"./shadow.js": 63,
	"./sleep.js": 169,
	"./transportProps.js": 65,
	"./unmount.js": 170,
	"./utils.js": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146);
module.exports = __webpack_require__(9).Object.keys;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(57);
var $keys = __webpack_require__(27);

__webpack_require__(147)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(13);
var core = __webpack_require__(9);
var fails = __webpack_require__(26);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(149), __esModule: true };

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81);
module.exports = __webpack_require__(9).Symbol['for'];


/***/ }),
/* 150 */
/***/ (function(module, exports) {

exports.__esModule = true;
exports.default = {
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
};
module.exports = exports["default"];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BROWSER_LANG = navigator.language || navigator.userLanguage || navigator.languages && navigator.languages[0];

var Locale = function () {
  function Locale(map) {
    (0, _classCallCheck3.default)(this, Locale);

    (0, _assign2.default)(this, map);
  }

  (0, _createClass3.default)(Locale, [{
    key: 'defaultLanguage',
    get: function get() {
      return this._defaultLanguage || 'en';
    },
    set: function set(value) {
      this._defaultLanguage = value;
    }
  }, {
    key: 'language',
    get: function get() {
      return this._language || Locale.language || BROWSER_LANG || this.defaultLanguage;
    },
    set: function set(value) {
      this._language = value;
    }
  }, {
    key: 'current',
    get: function get() {
      var lang = this.language.toLowerCase().split('-')[0];
      return this[this.language] || this[lang] || this[this.defaultLanguage];
    }
  }]);
  return Locale;
}();

exports.default = Locale;
module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

exports.default = function (opts) {
  return function (T) {
    (0, _assign2.default)(T, opts);
    T.$meta = true;
  };
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _shadow = __webpack_require__(63);

var _shadow2 = _interopRequireDefault(_shadow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shadow2.default.render;
module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
__webpack_require__(75);
__webpack_require__(79);
__webpack_require__(155);
__webpack_require__(167);
__webpack_require__(168);
module.exports = __webpack_require__(9).Promise;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(37);
var global = __webpack_require__(10);
var ctx = __webpack_require__(35);
var classof = __webpack_require__(88);
var $export = __webpack_require__(13);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(41);
var anInstance = __webpack_require__(156);
var forOf = __webpack_require__(157);
var speciesConstructor = __webpack_require__(89);
var task = __webpack_require__(90).set;
var microtask = __webpack_require__(162)();
var newPromiseCapabilityModule = __webpack_require__(64);
var perform = __webpack_require__(91);
var userAgent = __webpack_require__(163);
var promiseResolve = __webpack_require__(92);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(164)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(44)($Promise, PROMISE);
__webpack_require__(165)(PROMISE);
Wrapper = __webpack_require__(9)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(166)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var call = __webpack_require__(158);
var isArrayIter = __webpack_require__(159);
var anObject = __webpack_require__(15);
var toLength = __webpack_require__(74);
var getIterFn = __webpack_require__(160);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(15);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(39);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(88);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(39);
module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var macrotask = __webpack_require__(90).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(36)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(19);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var core = __webpack_require__(9);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(18);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(13);
var core = __webpack_require__(9);
var global = __webpack_require__(10);
var speciesConstructor = __webpack_require__(89);
var promiseResolve = __webpack_require__(92);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(64);
var perform = __webpack_require__(91);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

exports.default = sleep;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * sleep 函数，用于等待指定的时间后继续执行
 * 示例: await sleep(1000);
 * @param {int} ms 延迟的毫秒数
 * @returns {promise} promise 对象
 */
function sleep(ms) {
  return new _promise2.default(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms || 0);
  });
}
module.exports = exports["default"];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _shadow = __webpack_require__(63);

var _shadow2 = _interopRequireDefault(_shadow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shadow2.default.unmount;
module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(172);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _index = __webpack_require__(31);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  breadcrumbData: _propTypes2.default.array,
  /**
   * @param {srting} type 分隔符的类型，使用icon
   */
  type: _propTypes2.default.string
};

var defaultProps = {
  breadcrumbData: [],
  type: 'arrow-right'
};

var Breadcrumb = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Breadcrumb, _ComBase);

  function Breadcrumb(props) {
    (0, _classCallCheck3.default)(this, Breadcrumb);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.renderTitle = function (item) {
      var _cname;

      var title = void 0;
      var cls = (0, _common.cname)((_cname = {
        aniTransition: true
      }, _cname['breadcrum-item-text'] = true, _cname));
      if (item.link) {
        title = _react2.default.createElement(
          'a',
          { className: cls, href: item.link },
          _react2.default.createElement(
            'span',
            null,
            item.title
          )
        );
      } else {
        title = _react2.default.createElement(
          'span',
          { className: cls },
          item.title
        );
      }
      return title;
    };

    _this.renderSeparator = function (index, type) {
      var breadcrumbData = _this.props.breadcrumbData;

      var num = breadcrumbData.length;
      return _react2.default.createElement(
        'span',
        { className: (0, _common.cname)('breadcrumb-separator') },
        num === index + 1 ? null : _react2.default.createElement(_index2.default, { type: type })
      );
    };

    _this.state = {};
    return _this;
  }

  Breadcrumb.prototype.render = function render() {
    var _cname2,
        _this2 = this;

    var _props = this.props,
        className = _props.className,
        breadcrumbData = _props.breadcrumbData,
        type = _props.type;


    var warpCls = (0, _common.cname)((_cname2 = {
      widget: true
    }, _cname2['breadcrumb'] = true, _cname2), className);

    return _react2.default.createElement(
      'div',
      { className: warpCls },
      breadcrumbData.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { key: index, className: (0, _common.cname)('breadcrumb-item') },
          _this2.renderTitle(item),
          _this2.renderSeparator(index, type)
        );
      })
    );
  };

  return Breadcrumb;
}(_common.ComBase), _class.propTypes = propTypes, _class.defaultProps = defaultProps, _temp);
exports.default = Breadcrumb;
module.exports = exports['default'];

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(175);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _cname2 = __webpack_require__(23);

var _cname3 = _interopRequireDefault(_cname2);

var _ComBase2 = __webpack_require__(29);

var _ComBase3 = _interopRequireDefault(_ComBase2);

var _transportProps = __webpack_require__(65);

var _transportProps2 = _interopRequireDefault(_transportProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Button, _ComBase);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Button.prototype.getType = function getType() {
    var shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'normal';
    var type = arguments[1];

    var typeMap = {
      ghost: {
        primary: 'dark',
        secondary: 'dark',
        normal: 'light',
        dark: 'dark',
        light: 'light'
      },
      warning: {
        primary: 'primary',
        secondary: 'normal',
        normal: 'normal',
        dark: 'primary',
        light: 'normal'
      },
      normal: {
        primary: 'primary',
        secondary: 'secondary',
        normal: 'normal',
        dark: 'primary',
        light: 'normal'
      }
    };
    var shapeMap = typeMap[shape] || typeMap.normal;
    return shapeMap[type];
  };

  Button.prototype.onMouseUp = function onMouseUp(e) {
    _reactDom2.default.findDOMNode(this).blur();

    if (this.props.onMouseUp) {
      this.props.onMouseUp(e);
    }
  };

  Button.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        children = _props.children,
        shape = _props.shape,
        shadow = _props.shadow,
        size = _props.size,
        type = _props.type,
        htmlType = _props.htmlType,
        className = _props.className,
        others = (0, _objectWithoutProperties3.default)(_props, ['children', 'shape', 'shadow', 'size', 'type', 'htmlType', 'className']);

    var realType = this.getType(shape, type);
    var btnCls = (0, _cname3.default)((_cname = {
      aniTransition: true,
      widget: true,
      widgetShadow: shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      btn: true
    }, _cname['btn-' + realType] = realType, _cname['btn-' + shape] = shape, _cname['size-' + size] = size, _cname), className);
    var finalAttrs = {
      type: htmlType,
      className: btnCls
    };
    var TagName = others.href ? 'a' : 'button';
    return _react2.default.createElement(
      TagName,
      (0, _extends3.default)({}, (0, _transportProps2.default)(others), finalAttrs, {
        onMouseUp: this.onMouseUp.bind(this) }),
      children
    );
  };

  return Button;
}(_ComBase3.default), _class.propTypes = {
  /**
   * 容器类名
   */
  className: _propTypes2.default.string,
  /**
   * 按钮的类型
   */
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'normal', 'dark', 'light']),
  /**
   * 按钮的尺寸
   */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'hero']),
  /**
   * 按钮的形状
   */
  shape: _propTypes2.default.oneOf(['ghost', 'text', 'warning']),
  /**
   * 设置 `button` 标签的原生 `type` 值，可选值请参考 
   * [HTML 标准](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type)
   */
  htmlType: _propTypes2.default.string,
  /**
   * 点击跳转的地址，指定此属性 `button` 的行为和 `a` 链接一致	
   */
  href: _propTypes2.default.string,
  /**
   * 相当于 `a` 链接的 `target` 属性，`href` 存在时生效
   */
  target: _propTypes2.default.oneOf(['_blank', '_self', '_parent', '_top'])
}, _class.defaultProps = {
  type: 'normal',
  size: 'medium',
  htmlType: 'button'
}, _temp);
exports.default = Button;
module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() {
  return this || (typeof self === "object" && self);
})() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(177);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() {
    return this || (typeof self === "object" && self);
  })() || Function("return this")()
);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.NUM_OF_DAYS = undefined;
exports.isDivisible = isDivisible;
exports.isLeapYear = isLeapYear;
exports.numOfDays = numOfDays;
exports.getFirstDay = getFirstDay;
exports.getDates = getDates;
exports.getNearDates = getNearDates;

var _common = __webpack_require__(0);

var _dateEntity = __webpack_require__(34);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUM_OF_DAYS = exports.NUM_OF_DAYS = [{
  num: 31, months: [1, 3, 5, 7, 8, 10, 12]
}, {
  num: 30, months: [4, 6, 9, 11]
}, {
  num: 28, months: [2]
}];

function isDivisible(numerator, denominator) {
  return numerator % denominator === 0;
}

function isLeapYear(year) {
  return isDivisible(year, 4) && !isDivisible(year, 100) || isDivisible(year, 400);
}

function numOfDays(year, month) {
  var num = NUM_OF_DAYS.find(function (item) {
    return ~item.months.indexOf(month);
  }).num;
  if (isLeapYear(year) && month == 2) num++;
  return num;
}

function getFirstDay(year, month) {
  var date = new _dateEntity2.default(year + '/' + month + '/1');
  return date.day;
}

function getDates(year, month) {
  var dayCount = numOfDays(year, month);
  var dates = [];
  _common.utils.fromTo(1, dayCount, function (date) {
    dates.push(new _dateEntity2.default(year + '/' + month + '/' + date));
  });
  return dates;
}

function getNearDates(year, month, near) {
  var entity = new _dateEntity2.default(year + '/' + month + '/1');
  entity.month += near;
  return getDates(entity.year, entity.month);
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _col = __webpack_require__(94);

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Row, _ComBase);

  function Row() {
    (0, _classCallCheck3.default)(this, Row);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Row.prototype.wrapChildren = function wrapChildren(children) {
    var _props = this.props,
        cellPadding = _props.cellPadding,
        colPadding = _props.colPadding;

    if (_common.utils.isNull(cellPadding) && _common.utils.isNull(colPadding)) return children;
    if (cellPadding && !_common.utils.isNumber(cellPadding)) cellPadding = 0;
    var cols = this.findChildren(_col2.default);
    if (_common.utils.isNumber(colPadding)) {
      cellPadding = (cellPadding || 0) + 'px ' + colPadding + 'px';
    }
    return cols.map(function (col, index) {
      return _react2.default.cloneElement(col, {
        key: index,
        padding: _common.utils.isNull(col.props.padding) ? cellPadding : col.props.padding
      });
    });
  };

  Row.prototype.render = function render() {
    var _props2 = this.props,
        visible = _props2.visible,
        className = _props2.className,
        spacing = _props2.spacing,
        children = _props2.children,
        style = _props2.style,
        otherProps = (0, _objectWithoutProperties3.default)(_props2, ['visible', 'className', 'spacing', 'children', 'style']);

    var names = (0, _common.cname)({
      aniTransition: true,
      gridRow: true,
      stateHidden: visible === false,
      stateVisible: visible === true
    }, className);
    var element = _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), {
        style: style,
        className: names }),
      this.wrapChildren(children)
    );
    if (_common.utils.isNumber(spacing)) {
      element = _react2.default.cloneElement(element, {
        style: (0, _extends3.default)({ margin: spacing + 'px 0' }, style)
      });
    }
    return element;
  };

  return Row;
}(_common.ComBase), _class.propTypes = {

  /** 指定当前 row 的间距 */
  spacing: _propTypes2.default.number,

  /** 指定 Grid 中每个 col 的填充 */
  colPadding: _propTypes2.default.number,

  /** 类名 */
  className: _propTypes2.default.string,

  /** 可见性 */
  visible: _propTypes2.default.bool,

  /** 样式 */
  style: _propTypes2.default.object
}, _class.defaultProps = {}, _temp);
exports.default = Row;
module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(183);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Card, _ComBase);

  function Card() {
    (0, _classCallCheck3.default)(this, Card);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Card.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        title = _props.title,
        extra = _props.extra,
        bordered = _props.bordered,
        hoverable = _props.hoverable,
        type = _props.type,
        bodyStyle = _props.bodyStyle,
        children = _props.children,
        className = _props.className,
        others = (0, _objectWithoutProperties3.default)(_props, ['title', 'extra', 'bordered', 'hoverable', 'type', 'bodyStyle', 'children', 'className']);

    var classString = (0, _common.cname)((_cname = {
      aniTransition: true,
      widget: true,
      'card-hoverable': hoverable,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      'card-bordered': bordered,
      card: true
    }, _cname['card-type-' + type] = !!type, _cname), className);
    var head = _react2.default.createElement(
      'div',
      { className: (0, _common.cname)({ 'card-head': true, 'card-hoverable-head': hoverable }) },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('card-head-wrapper') },
        title && _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('card-head-title') },
          title
        ),
        extra && _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('card-extra') },
          extra
        )
      )
    );
    var body = _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('card-body'), style: bodyStyle },
      children
    );
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({ className: classString }, (0, _common.transportProps)(others)),
      !title && !extra ? null : head,
      body
    );
  };

  return Card;
}(_common.ComBase), _class.propTypes = {
  /** 标题 */
  title: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  /** 卡片右上角的操作区域 */
  extra: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  /** 是否有边框 */
  bordered: _propTypes2.default.bool,
  /** 鼠标 `hover` 是否浮起 */
  hoverable: _propTypes2.default.bool,
  /** 卡片的类型 */
  type: _propTypes2.default.oneOf(['inner', '']),
  /** 样式 */
  bodyStyle: _propTypes2.default.object
}, _class.defaultProps = {
  title: '',
  extra: null,
  bordered: true,
  hoverable: false,
  type: '',
  bodyStyle: {}
}, _temp);
exports.default = Card;
module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(185);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slidesCarousel = __webpack_require__(186);

var _slidesCarousel2 = _interopRequireDefault(_slidesCarousel);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _lodash = __webpack_require__(95);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Carousel = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Carousel, _ComBase);

  function Carousel(props) {
    (0, _classCallCheck3.default)(this, Carousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.refs = {
      sliderCarouse: null
    };

    _this.onWindowResized = function () {
      _this.setState({ width: _this.domNode.offsetWidth });
    };

    _this.next = function () {
      // 跳到下一页
      _this.sliderCarouse.next();
    };

    _this.prev = function () {
      // 跳到上一页
      _this.sliderCarouse.prev();
    };

    _this.play = function () {
      // 播放
      _this.sliderCarouse.play();
    };

    _this.pause = function () {
      // 暂停
      _this.sliderCarouse.pause();
    };

    _this.goto = function (index) {
      // 跳到某一页
      _this.sliderCarouse.goto(index);
    };

    _this.onWindowResized = (0, _lodash2.default)(_this.onWindowResized, 500);
    _this.state = {
      width: 0
    };
    return _this;
  }

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.setState({ width: this.domNode.offsetWidth || this.domNode.parentElement.offsetWidth });
  };

  Carousel.prototype.render = function render() {
    var _this2 = this;

    var width = this.state.width;
    var _props = this.props,
        style = _props.style,
        className = _props.className;

    var props = (0, _extends3.default)({}, this.props, {
      width: width
    });
    var names = (0, _common.cname)({
      widget: true,
      carousel: true
    }, className);

    return _react2.default.createElement(
      'div',
      { className: names, style: style },
      _react2.default.createElement(_slidesCarousel2.default, (0, _extends3.default)({ ref: function ref(el) {
          return _this2.sliderCarouse = el;
        } }, props)),
      _react2.default.createElement(_components.Proxy, { target: window, onResize: this.onWindowResized })
    );
  };

  return Carousel;
}(_common.ComBase), _class.defaultProps = {
  dots: true,
  arrows: true, // 是否显示上下箭头
  motion: true, // 是否启用动效
  infinite: true, // 是否无限循环
  autoplay: false, // 是否自动播放
  speed: 500, // 滚动速度
  initialSlide: 0, // 默认定位到第几屏
  slidesToShow: 1, // 一屏显示的个数
  slidesToScroll: 1, // 一次滚动的个数
  autoplaySpeed: 3000 // 自动循环的间隔时间
}, _class.propTypes = {
  /** 是否显示面板指示点 */
  dots: _propTypes2.default.bool,
  /** 是否显示箭头 */
  arrows: _propTypes2.default.bool,
  /** 是否启用动画 */
  motion: _propTypes2.default.bool,
  /** 是否无限循环滚动 */
  infinite: _propTypes2.default.bool,
  /** 是否自动播放 */
  autoplay: _propTypes2.default.bool,
  /** 自动循环播放的时间间隔 */
  autoplaySpeed: _propTypes2.default.number,
  /** 滚动速度，表示从开始滚动到完成的时间，单位 `毫秒` */
  speed: _propTypes2.default.number,
  /** 默认定位到第几屏 */
  initialSlide: _propTypes2.default.number,
  /** 一屏显示的页数 */
  slidesToShow: _propTypes2.default.number,
  /** 一次滚动的页数 */
  slidesToScroll: _propTypes2.default.number
}, _temp);
exports.default = Carousel;
module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _innerCarousel = __webpack_require__(187);

var _innerCarousel2 = _interopRequireDefault(_innerCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlidesCarousel = function (_ComBase) {
  (0, _inherits3.default)(SlidesCarousel, _ComBase);

  function SlidesCarousel(props) {
    (0, _classCallCheck3.default)(this, SlidesCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.refs = {
      innerCarousel: null
    };

    _this.next = function () {
      // 跳到下一页
      _this.innerCarousel.next();
    };

    _this.prev = function () {
      // 跳到上一页
      _this.innerCarousel.prev();
    };

    _this.play = function () {
      // 播放
      _this.innerCarousel.play();
    };

    _this.pause = function () {
      // 暂停
      _this.innerCarousel.pause();
    };

    _this.goto = function (index) {
      // 跳到某一页
      _this.innerCarousel.goto(index);
    };

    return _this;
  }

  SlidesCarousel.prototype.render = function render() {
    var _this2 = this;

    var names = (0, _common.cname)({ slidesCarousel: true });
    return _react2.default.createElement(
      'div',
      { className: names },
      _react2.default.createElement(_innerCarousel2.default, (0, _extends3.default)({ ref: function ref(el) {
          return _this2.innerCarousel = el;
        } }, this.props))
    );
  };

  return SlidesCarousel;
}(_common.ComBase);

exports.default = SlidesCarousel;
module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _arrows = __webpack_require__(188);

var _dots = __webpack_require__(189);

var _dots2 = _interopRequireDefault(_dots);

var _track = __webpack_require__(190);

var _track2 = _interopRequireDefault(_track);

var _slideUtils = __webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLAY_STATE = {
  PENDING: 'pending',
  PLAYING: 'playing',
  PAUSE: 'pause'
};

var InnerCarousel = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(InnerCarousel, _ComBase);

  function InnerCarousel(props) {
    (0, _classCallCheck3.default)(this, InnerCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      playState: PLAY_STATE.PENDING,
      useTransform: false,
      slideState: {
        startIndex: _this.props.initialSlide || 0
      }
    };
    return _this;
  }

  InnerCarousel.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var autoplay = this.props.autoplay;

    var spec = (0, _extends3.default)({}, this.props);
    var slideState = (0, _slideUtils.initializeState)(spec);
    this.setState({ slideState: slideState }, function () {
      if (autoplay) {
        _this2.play();
        _this2.autoPlayHandler();
      }
    });
  };

  InnerCarousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var spec = (0, _extends3.default)({}, nextProps);
    var slideState = this.state.slideState;

    var startIndex = slideState.startIndex;
    var nextSlideState = (0, _slideUtils.changeState)((0, _assign2.default)(spec, { startIndex: startIndex }));
    this.setState({ slideState: nextSlideState });
  };

  InnerCarousel.prototype.render = function render() {
    var names = (0, _common.cname)({
      innerCarousel: true
    });
    var _props = this.props,
        dots = _props.dots,
        arrows = _props.arrows,
        slidesToShow = _props.slidesToShow;
    var _state = this.state,
        slideState = _state.slideState,
        useTransform = _state.useTransform;

    var _ref = slideState || {},
        childrenCount = _ref.childrenCount,
        slideNum = _ref.slideNum,
        targetIndex = _ref.targetIndex,
        startIndex = _ref.startIndex;

    var unslick = childrenCount > slidesToShow;
    var setting = (0, _extends3.default)({}, this.props, { startIndex: startIndex, slideNum: slideNum, targetIndex: targetIndex, useTransform: useTransform });

    return _react2.default.createElement(
      'div',
      { className: names },
      unslick && arrows ? this.getPrevArrowNode() : null,
      _react2.default.createElement(
        _track2.default,
        setting,
        this.props.children
      ),
      unslick && arrows ? this.getNextArrowNode() : null,
      unslick && dots ? this.getDotsNode(setting) : null
    );
  };

  return InnerCarousel;
}(_common.ComBase), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getPrevArrowNode = function () {
    return _react2.default.createElement(_arrows.PrevArrow, (0, _extends3.default)({ callback: _this3.prev }, _this3.props));
  };

  this.getNextArrowNode = function () {
    return _react2.default.createElement(_arrows.NextArrow, (0, _extends3.default)({ callback: _this3.next }, _this3.props));
  };

  this.getDotsNode = function (setting) {
    return _react2.default.createElement(_dots2.default, (0, _extends3.default)({}, setting, { onClickDot: function onClickDot(index) {
        return _this3.goto(index);
      } }));
  };

  this.next = function () {
    // 跳到下一页
    var slideState = _this3.state.slideState;

    var nextStartIndex = (0, _slideUtils.nextSlideState)(slideState);
    _this3.slideHandler(nextStartIndex);
  };

  this.prev = function () {
    // 跳到上一页
    var slideState = _this3.state.slideState;

    var prevStartIndex = (0, _slideUtils.prevSlideState)(slideState);
    _this3.slideHandler(prevStartIndex);
  };

  this.goto = function (index) {
    if (_this3.validateIndex(index)) {
      _this3.slideHandler(index);
    }
  };

  this.play = function (callback) {
    // 播放
    _this3.setState({ playState: PLAY_STATE.PLAYING }, function () {
      callback && callback();
    });
  };

  this.pause = function () {
    // 暂停
    _this3.setState({ playState: PLAY_STATE.PAUSE });
  };

  this.validateIndex = function (index) {
    var slideState = _this3.state.slideState;

    var _ref2 = slideState || 0,
        slideNum = _ref2.slideNum;

    return index >= -1 && index < slideNum;
  };

  this.slideHandler = function (startIndex) {
    var animateEnable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _props2 = _this3.props,
        motion = _props2.motion,
        speed = _props2.speed,
        afterChange = _props2.afterChange,
        autoplay = _props2.autoplay,
        beforeChange = _props2.beforeChange;
    var _state2 = _this3.state,
        playState = _state2.playState,
        slideState = _state2.slideState;

    var useAnimation = motion && animateEnable;
    _this3.slideTimeoutId && clearTimeout(_this3.slideTimeoutId);
    var props = (0, _extends3.default)({}, _this3.props);
    var currentSlideState = (0, _slideUtils.changeState)((0, _assign2.default)(props, slideState, { startIndex: startIndex }));

    if (useAnimation) {
      beforeChange && beforeChange(slideState.startIndex); // 没有动画的话不需要执行beforeChange
      _this3.setState({
        useTransform: useAnimation,
        slideState: currentSlideState
      }, function () {
        _this3.animationEndCallback = setTimeout(function () {
          _this3.setState({
            useTransform: false
          }, function () {
            afterChange && afterChange(startIndex);
          });
          delete _this3.animationEndCallback;
          _this3.updateSlideState();
          if (autoplay && playState === PLAY_STATE.PLAYING) {
            _this3.autoPlayHandler();
          }
        }, speed);
      });
    } else {
      _this3.setState({ slideState: currentSlideState }, function () {
        afterChange && afterChange(startIndex); // 如果没有动画的话直接执行afterChange
      });
    }
  };

  this.autoPlayHandler = function () {
    var autoplaySpeed = _this3.props.autoplaySpeed;

    _this3.slideTimeoutId = setTimeout(function () {
      _this3.next();
    }, autoplaySpeed);
  };

  this.updateSlideState = function () {
    var slideState = _this3.state.slideState;
    var slideNum = slideState.slideNum,
        startIndex = slideState.startIndex;

    if (startIndex == slideNum) {
      // 轮播位置需要重置
      _this3.slideHandler(0, false);
    } else if (startIndex < 0) {
      _this3.slideHandler(slideNum - 1, false);
    }
  };
}, _temp);


InnerCarousel.defaultProps = {
  unslick: true // 是否不用显示切换按钮及圆点
};

exports.default = InnerCarousel;
module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PrevArrow = function (_ComBase) {
  (0, _inherits3.default)(_class, _ComBase);

  function _class() {
    (0, _classCallCheck3.default)(this, _class);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  _class.prototype.render = function render() {
    var names = (0, _common.cname)({
      arrow: true,
      prevArrow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      aniTransition: true
    });
    return _react2.default.createElement(
      'div',
      { className: names,
        onClick: this.props.callback },
      _react2.default.createElement(_components.Icon, { type: 'arrow-left' })
    );
  };

  return _class;
}(_common.ComBase);

exports.NextArrow = function (_ComBase2) {
  (0, _inherits3.default)(_class2, _ComBase2);

  function _class2() {
    (0, _classCallCheck3.default)(this, _class2);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase2.apply(this, arguments));
  }

  _class2.prototype.render = function render() {
    var names = (0, _common.cname)({
      arrow: true,
      nextArrow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      aniTransition: true
    });
    return _react2.default.createElement(
      'div',
      { className: names,
        onClick: this.props.callback },
      _react2.default.createElement(_components.Icon, { type: 'arrow-right' })
    );
  };

  return _class2;
}(_common.ComBase);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayRange = _common.utils.arrayRange;

var DotCell = function (_ComBase) {
  (0, _inherits3.default)(DotCell, _ComBase);

  function DotCell() {
    (0, _classCallCheck3.default)(this, DotCell);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  DotCell.prototype.render = function render() {
    var _props = this.props,
        startIndex = _props.startIndex,
        index = _props.index,
        onClickDot = _props.onClickDot;

    var names = (0, _common.cname)({
      dotCell: true,
      active: index === startIndex,
      aniTransition: true
    });
    return _react2.default.createElement('div', { className: names, onClick: function onClick() {
        return onClickDot(index);
      } });
  };

  return DotCell;
}(_common.ComBase);

var Dots = function (_ComBase2) {
  (0, _inherits3.default)(Dots, _ComBase2);

  function Dots() {
    (0, _classCallCheck3.default)(this, Dots);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase2.apply(this, arguments));
  }

  Dots.prototype.render = function render() {
    var _this3 = this;

    var slideNum = this.props.slideNum;

    var dotsArr = arrayRange(slideNum);
    var names = (0, _common.cname)({
      dots: true
    });
    return _react2.default.createElement(
      'div',
      { className: names },
      dotsArr.map(function (item) {
        return _react2.default.createElement(DotCell, (0, _extends3.default)({}, _this3.props, { key: item, index: item }));
      })
    );
  };

  return Dots;
}(_common.ComBase);

exports.default = Dots;
module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// track dom to sliders

var Track = function (_ComBase) {
  (0, _inherits3.default)(Track, _ComBase);

  function Track() {
    (0, _classCallCheck3.default)(this, Track);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = []; // 重排之后的slide元素
    var totalSlides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = _react2.default.Children.count(this.props.children);
    var _props = this.props,
        slidesToShow = _props.slidesToShow,
        width = _props.width,
        targetIndex = _props.targetIndex,
        useTransform = _props.useTransform,
        speed = _props.speed,
        motion = _props.motion;

    var targetWidth = width / slidesToShow;
    var slideStyle = getSlideStyle();
    var names = (0, _common.cname)({
      slidesList: true
    });

    _react2.default.Children.forEach(this.props.children, function (item, index) {
      slides.push(getSlideItemNode(item, index));

      if (childrenCount > slidesToShow) {
        // 右侧多出一倍
        postCloneSlides.push(getSlideItemNode(item, index + childrenCount));
        // 左侧多出一屏
        if (index >= childrenCount - slidesToShow) {
          preCloneSlides.push(getSlideItemNode(item, -(childrenCount - index)));
        }
      }
    });

    function getSlideItemNode(element, index) {
      return _react2.default.createElement(
        'div',
        { key: index,
          style: slideStyle },
        element
      );
    }

    function getSlideStyle() {
      return {
        width: targetWidth,
        float: 'left'
      };
    }

    totalSlides = preCloneSlides.concat(slides).concat(postCloneSlides);

    return _react2.default.createElement(
      'div',
      { className: names,
        style: {
          width: totalSlides.length * targetWidth,
          transform: 'translate3d(' + (-slidesToShow - targetIndex) * targetWidth + 'px, 0px, 0px)',
          transition: motion && useTransform ? speed / 1000 + 's' : 'none'
        } },
      totalSlides
    );
  };

  return Track;
}(_common.ComBase);

exports.default = Track;
module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.prevSlideState = exports.nextSlideState = exports.changeState = exports.initializeState = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initializeState = exports.initializeState = function initializeState(spec) {
  var slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll;
  /** 当前轮播的屏幕索引值，从0开始 */

  var startIndex = spec.initialSlide || 0;
  /** 轮播内容的数目，注意：并不完全等于屏幕数 */
  var childrenCount = _react2.default.Children.count(spec.children);
  /** 轮播内容的屏幕数，总共有几屏，注意：并不完全等于内容的数目，和childrenCount有区别 */
  var slideNum = 1 + Math.ceil((childrenCount - slidesToShow) / slidesToScroll);
  /** 当前轮播动画结束的屏幕索引值，动画结束之后等于startIndex */
  var targetIndex = startIndex * slidesToScroll; // 索引值，所以需要-1
  return { childrenCount: childrenCount, slideNum: slideNum, targetIndex: targetIndex, startIndex: startIndex };
};

var changeState = exports.changeState = function changeState(spec) {
  var slidesToShow = spec.slidesToShow,
      startIndex = spec.startIndex,
      slidesToScroll = spec.slidesToScroll;

  var childrenCount = _react2.default.Children.count(spec.children);
  var slideNum = 1 + Math.ceil((childrenCount - slidesToShow) / slidesToScroll);
  var targetIndex = startIndex * slidesToScroll; // 索引值，所以需要-1 
  return { childrenCount: childrenCount, slideNum: slideNum, targetIndex: targetIndex, startIndex: startIndex };
};

var nextSlideState = exports.nextSlideState = function nextSlideState(spec) {
  // 下一页
  var startIndex = spec.startIndex,
      slideNum = spec.slideNum;

  return startIndex < slideNum ? startIndex + 1 : 0;
};

var prevSlideState = exports.prevSlideState = function prevSlideState(spec) {
  // 上一页
  var startIndex = spec.startIndex,
      slideNum = spec.slideNum;

  return startIndex > 0 ? startIndex - 1 : slideNum - 1;
};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_ComBase) {
  (0, _inherits3.default)(Item, _ComBase);

  function Item() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.handleChecked = function (event) {
      event.stopPropagation();
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onSelect = _this$props.onSelect,
          value = _this$props.value;

      if (disabled) return;
      onSelect(value, event.target.checked);
    }, _this.handleClick = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick;

      if (disabled) return;
      onClick(value);
    }, _this.handleMouseOver = function () {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          multiple = _this$props3.multiple,
          onMouseOver = _this$props3.onMouseOver;

      if (multiple) return;
      onMouseOver(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Item.prototype.render = function render() {
    var _props = this.props,
        multiple = _props.multiple,
        value = _props.value,
        label = _props.label,
        disabled = _props.disabled,
        children = _props.children,
        indeterminate = _props.indeterminate,
        checked = _props.checked,
        active = _props.active,
        leafOnly = _props.leafOnly,
        isLeaf = _props.isLeaf;

    var classNames = (0, _common.cname)({
      'option': true,
      'selected': checked,
      'active': active
    });
    return _react2.default.createElement(
      'li',
      { key: value, className: classNames },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('option-content'), onClick: this.handleClick, onMouseOver: this.handleMouseOver },
        multiple && (!leafOnly || leafOnly && isLeaf) && _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('option-checkbox'), onClick: function onClick(event) {
              return event.stopPropagation();
            } },
          _react2.default.createElement(_components.CheckBox, {
            disabled: disabled,
            indeterminate: indeterminate,
            checked: !!checked,
            onChange: this.handleChecked
          })
        ),
        label,
        children && children.length > 0 && !disabled && _react2.default.createElement(_components.Icon, { type: 'arrow-right', className: (0, _common.cname)('option-arrow') })
      )
    );
  };

  return Item;
}(_common.ComBase);

exports.default = Item;
module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

__webpack_require__(197);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _constants = __webpack_require__(97);

var _TreeSelect = __webpack_require__(96);

var _TreeSelect2 = _interopRequireDefault(_TreeSelect);

var _prev = __webpack_require__(198);

var _prev2 = _interopRequireDefault(_prev);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cascader = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Cascader, _ComBase);

  function Cascader(props) {
    (0, _classCallCheck3.default)(this, Cascader);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var multiple = props.multiple,
        resultRender = props.resultRender;

    _this.resultRender = resultRender || (multiple ? _this.resultMultipleRender : _this.resultSingleRender);
    _this.state = {
      cascaderFocused: false,
      cascaderOpened: false,
      selectedData: [],
      treeData: []
    };
    return _this;
  }

  Cascader.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        size = _props.size,
        value = _props.value,
        popoverInline = _props.popoverInline,
        multiple = _props.multiple;
    var _state = this.state,
        cascaderFocused = _state.cascaderFocused,
        cascaderOpened = _state.cascaderOpened,
        selectedData = _state.selectedData;


    var names = (0, _common.cname)({
      widget: true,
      cascader: true,
      cascaderBlock: popoverInline,
      cascaderLg: size && size === _constants.SelectSize.LARGE,
      cascaderMd: !size || size === _constants.SelectSize.MEDIUM,
      cascaderSm: size && size === _constants.SelectSize.SMALL,
      cascaderSingle: !multiple,
      cascaderMultiple: multiple,
      cascaderEmpty: !value,
      cascaderFocused: cascaderFocused,
      cascaderOpened: cascaderOpened
    }, className);
    var content = this.renderTreeSelect();
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names, style: this.props.style }),
      _react2.default.createElement(
        'div',
        {
          ref: function ref(cascaderInner) {
            _this2.cascaderInner = cascaderInner;
          },
          className: (0, _common.cname)('cascader-inner'),
          onClick: this.onClickCascader },
        this.renderSelectedResult(selectedData),
        !popoverInline && _react2.default.createElement(_components.Icon, { type: 'arrow-down',
          className: (0, _common.cname)('select-icon select-arrow ani-transition') }),
        value && !multiple && _react2.default.createElement(_components.Icon, { type: 'wrong',
          className: (0, _common.cname)('select-icon select-clear ani-transition'),
          onClick: this.handleClear })
      ),
      popoverInline ? content : this.renderPopover(content)
    );
  };

  return Cascader;
}(_common.ComBase), _class.propTypes = {
  /** 当前值 */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  /** 默认值 */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  /** 数据源 */
  options: _propTypes2.default.array.isRequired,
  /** 选中值变化时，仅返回 value */
  onChange: _propTypes2.default.func,
  /** 选中值变化时，返回value，及对应原始信息 */
  onSelect: _propTypes2.default.func,
  /** 选中结果个性化展示：单选模式返回字符串；多选模式下需返回`Array<{label,value}>` */
  resultRender: _propTypes2.default.func,
  /** 只能选择叶子节点 */
  leafOnly: _propTypes2.default.bool,
  /** 严格选择，父子节点选中不关联 */
  checkStrictly: _propTypes2.default.bool,
  /** 选择器内联，不使用Popover */
  popoverInline: _propTypes2.default.bool
}, _class.defaultProps = {
  size: _constants.SelectSize.MEDIUM,
  leafOnly: false,
  popoverInline: false,
  multiple: false
}, _class.prev = _prev2.default, _class.TreeSelect = _TreeSelect2.default, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.resultSingleRender = function (values) {
    return values.map(function (item) {
      return item.label || item.text || item.value;
    }).join('/');
  };

  this.resultMultipleRender = function (treeData) {
    var result = [];
    var loop = function loop(list, father) {
      list.forEach(function (item) {
        item.label = (father ? father.label + '-' : '') + item.label;
        if (item.selected) result.push(item);
        if (Array.isArray(item.children)) loop(item.children, item);
      });
    };
    loop(treeData);
    return result;
  };

  this.onBlurFromDomHandler = function (e) {
    if (!_this3.popover) return;
    if (!_common.utils.inContainer(_this3.domNode, e.target) && !_common.utils.inContainer(_this3.popover.domNode, e.target)) {
      _this3.setState({
        cascaderOpened: false,
        cascaderFocused: false
      });
    }
  };

  this.onClickCascader = function () {
    if (_this3.props.disabled) return;
    _this3.setState({
      cascaderOpened: !_this3.state.cascaderOpened,
      cascaderFocused: true,
      temporaryValue: _this3.state.cascaderOpened ? _this3.state.temporaryValue : []
    });
    return true;
  };

  this.renderPopover = function (content) {
    var cascaderOpened = _this3.state.cascaderOpened;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _components.Popover,
        {
          ref: function ref(popover) {
            _this3.popover = popover;
          },
          className: (0, _common.cname)('cascader-drop-down'),
          follow: _this3.cascaderInner,
          overlay: false,
          allowedDirection: ['bottom', 'top'],
          visible: cascaderOpened },
        content
      ),
      _react2.default.createElement(_components.Proxy, { target: document, onClick: _this3.onBlurFromDomHandler })
    );
  };

  this.reduceData = function (data) {
    var item = data,
        result = [];
    if (!item) return result;
    while (item && !item.root) {
      result.unshift(item);
      item = item.father;
    }
    return result;
  };

  this.handleChange = function (value, data, treeData) {
    var _props2 = _this3.props,
        multiple = _props2.multiple,
        onChange = _props2.onChange,
        onSelect = _props2.onSelect;

    var selectedData = multiple ? data.map(function (item) {
      return _this3.reduceData(item);
    }) : _this3.reduceData(data);
    onChange && onChange(new _common.EventArgs(_this3, value));
    onSelect && onSelect(value, data, treeData);
    var state = { selectedData: selectedData, treeData: treeData };
    if (!multiple) state.cascaderOpened = false; //单选模式下，选中自动关闭弹层
    _this3.setState(state);
  };

  this.handleClear = function () {
    _this3.treeSelect.setSelected('', false);
  };

  this.renderTreeSelect = function () {
    var _props3 = _this3.props,
        options = _props3.options,
        multiple = _props3.multiple,
        leafOnly = _props3.leafOnly,
        value = _props3.value,
        defaultValue = _props3.defaultValue,
        checkStrictly = _props3.checkStrictly;

    if (!Array.isArray(options) || !options.length) return null;
    return _react2.default.createElement(_TreeSelect2.default, {
      checkStrictly: checkStrictly,
      ref: function ref(el) {
        return _this3.treeSelect = el;
      },
      value: value,
      leafOnly: leafOnly,
      defaultValue: defaultValue,
      options: options,
      multiple: multiple,
      onChange: _this3.handleChange
    });
  };

  this.renderMultipleSelectedValues = function () {
    var treeData = _this3.state.treeData;

    var handleClose = function handleClose(event, value) {
      event.stopPropagation();
      _this3.treeSelect.setSelected(value, false);
    };
    var result = _this3.resultRender(_common.utils.clone(treeData));
    if (!Array.isArray(result)) return null;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('selected-value-list') },
      result.map(function (item, index) {
        var label = item.label,
            value = item.value;

        return _react2.default.createElement(
          'span',
          { key: index, className: (0, _common.cname)('selected-value-item') },
          _react2.default.createElement(
            'span',
            { className: (0, _common.cname)('selected-value-label') },
            label
          ),
          _react2.default.createElement(_components.Icon, { type: 'close',
            className: (0, _common.cname)('selected-close'),
            onClick: function onClick(event) {
              return handleClose(event, value);
            }
          })
        );
      })
    );
  };

  this.renderSelectedResult = function (selectedData) {
    var multiple = _this3.props.multiple;

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('selected-value') },
      multiple ? _this3.renderMultipleSelectedValues() : _this3.resultRender(selectedData)
    );
  };
}, _temp);
exports.default = Cascader;
module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _constants = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cascader = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Cascader, _ComBase);

  function Cascader(props) {
    (0, _classCallCheck3.default)(this, Cascader);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.transformFromValueToIndex = function (valueList, options) {
      var indexArr = [];
      var layerData = options;
      valueList.forEach(function (item) {
        var idx = layerData.findIndex(function (data) {
          return data.value === item;
        });
        if (idx < 0) {
          return null;
        }
        indexArr.push(idx);
        layerData = layerData[idx].children;
      });

      return indexArr;
    };

    _this.transformFromIndexToValue = function (indexList, options) {
      var valueArr = [];
      var layerData = options;
      indexList.forEach(function (item) {
        valueArr.push(layerData[item]);
        layerData = layerData[item].children;
      });
      return valueArr;
    };

    _this.onClickCascader = function () {
      if (_this.props.disabled) return;
      _this.setState({
        cascaderOpened: !_this.state.cascaderOpened,
        cascaderFocused: true,
        temporaryValue: _this.state.cascaderOpened ? _this.state.temporaryValue : []
      });
      return true;
    };

    _this.onBlurFromDomHandler = function (e) {
      if (!_this.popover) return;
      if (!_common.utils.inContainer(_this.domNode, e.target) && !_common.utils.inContainer(_this.popover.domNode, e.target)) {
        _this.setState({
          cascaderOpened: false,
          cascaderFocused: false,
          temporaryValue: []
        });
      }
    };

    _this.renderOptions = function (items, selectedIndex, layer) {
      return _react2.default.createElement(
        'ul',
        { key: 'layer_' + layer, className: (0, _common.cname)('option-list') },
        items.map(function (item, index) {
          var timer = void 0;
          return _react2.default.createElement(
            'li',
            {
              key: item.value,
              className: (0, _common.cname)({
                option: true,
                selected: index === selectedIndex,
                disabled: item.disabled
              }),
              onMouseEnter: function onMouseEnter() {
                if (!item.disabled) {
                  timer = setTimeout(function () {
                    if (timer && item.children && item.children.length) {
                      _this.selectItem(layer, index, 'expand', !item.children || !item.children.length);
                    }
                  }, 300);
                }
              },
              onClick: function onClick() {
                if (!item.disabled) {
                  _this.selectItem(layer, index, 'select', !item.children || !item.children.length);
                }
              },
              onMouseLeave: function onMouseLeave() {
                clearTimeout(timer);
              } },
            _react2.default.createElement(
              'div',
              { className: (0, _common.cname)('option-content') },
              item.children && item.children.length ? _react2.default.createElement(_components.Icon, { type: 'arrow-right', className: (0, _common.cname)('option-arrow') }) : null,
              item.label || item.text || item.value
            )
          );
        })
      );
    };

    _this.renderPopover = function () {
      var options = _this.props.options;
      var _this$state = _this.state,
          cascaderOpened = _this$state.cascaderOpened,
          selectedValue = _this$state.selectedValue,
          temporaryValue = _this$state.temporaryValue;


      var content = [];
      var layer = 0;
      var deepFind = function deepFind(options, selected) {
        if (!selected || !options || !options.length) return;

        content.push(_this.renderOptions(options, selected[0], layer));
        layer++;

        selected[0] >= 0 && options[selected[0]] && deepFind(options[selected[0]].children, selected.slice(1));
      };
      deepFind(options, cascaderOpened && temporaryValue.length ? temporaryValue : selectedValue);

      return _react2.default.createElement(
        _components.Popover,
        {
          ref: function ref(popover) {
            _this.popover = popover;
          },
          className: (0, _common.cname)('cascader-drop-down'),
          follow: _this.cascaderInner,
          overlay: false,
          allowedDirection: ['bottom', 'top'],
          visible: cascaderOpened },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('option-list-wrapper') },
          content
        )
      );
    };

    _this.selectItem = function (layer, value, type, end) {
      var resultRender = _this.props.resultRender;
      var _this$state2 = _this.state,
          temporaryValue = _this$state2.temporaryValue,
          selectedValue = _this$state2.selectedValue;
      var leafOnly = _this.props.leafOnly;

      var current = temporaryValue && temporaryValue.length ? temporaryValue.concat() : selectedValue.concat();
      current[layer] = value;
      if (current.length - 1 > layer) {
        current.splice(layer + 1);
      }
      _this.setState({
        temporaryValue: current
      });

      if (type === 'select') {
        if (leafOnly && end || !leafOnly) {
          _this.setState({
            selectedValue: current,
            cascaderFocused: false,
            cascaderOpened: false
          });
          var currentResult = resultRender(_this.transformFromIndexToValue(current, _this.props.options));
          if (_this.props.onChange) {
            var eventArgs = new _common.EventArgs(_this, _this.transformFromIndexToValue(current, _this.props.options).map(function (item) {
              return item.value;
            }), { currentResult: currentResult });
            _this.props.onChange(eventArgs);
          }
        }
      }
    };

    _this.state = {
      cascaderFocused: false,
      cascaderOpened: false,
      selectedValue: _this.props.value ? _this.transformFromValueToIndex(_this.props.value, _this.props.options) : [],
      temporaryValue: []
    };
    return _this;
  }

  Cascader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        selectedValue: this.transformFromValueToIndex(nextProps.value, nextProps.options) || []
      });
    }
  };

  Cascader.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        size = _props.size,
        options = _props.options,
        resultRender = _props.resultRender,
        triggerNode = _props.triggerNode;
    var _state = this.state,
        cascaderFocused = _state.cascaderFocused,
        cascaderOpened = _state.cascaderOpened,
        selectedValue = _state.selectedValue;

    var names = (0, _common.cname)({
      widget: true,
      cascader: true,
      cascaderLg: size && size === _constants.SelectSize.LARGE,
      cascaderMd: !size || size === _constants.SelectSize.MEDIUM,
      cascaderSm: size && size === _constants.SelectSize.SMALL,
      cascaderFocused: cascaderFocused,
      cascaderOpened: cascaderOpened
    }, className);

    var currentResult = resultRender(this.transformFromIndexToValue(selectedValue, options));

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names, style: this.props.style }),
      triggerNode ? _react2.default.createElement(
        'div',
        {
          ref: function ref(cascaderInner) {
            _this2.cascaderInner = cascaderInner;
          },
          onClick: this.onClickCascader },
        triggerNode()
      ) : _react2.default.createElement(
        'div',
        {
          ref: function ref(cascaderInner) {
            _this2.cascaderInner = cascaderInner;
          },
          className: (0, _common.cname)('cascader-inner'),
          onClick: this.onClickCascader },
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('selected-value') },
          currentResult
        ),
        _react2.default.createElement(_components.Icon, { type: 'arrow-down', className: (0, _common.cname)('select-arrow ani-transition') })
      ),
      this.renderPopover(),
      _react2.default.createElement(_components.Proxy, { target: document, onClick: this.onBlurFromDomHandler })
    );
  };

  return Cascader;
}(_common.ComBase), _class.propTypes = {
  value: _propTypes2.default.array,
  options: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func,
  resultRender: _propTypes2.default.func,
  leafOnly: _propTypes2.default.bool,
  triggerNode: _propTypes2.default.node
}, _temp);


Cascader.defaultProps = {
  size: _constants.SelectSize.MEDIUM,
  leafOnly: true,
  resultRender: function resultRender(values) {
    var str = '';
    values.forEach(function (item, index) {
      str += '' + (item.label || item.text || item.value) + (index + 1 === values.length ? '' : ' / ');
    });
    return str;
  }
};

exports.default = Cascader;
module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(200);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckBox = (_dec = (0, _common.meta)({
  valuePropName: 'checked',
  valuePath: 'target.checked'
}), _dec(_class = (_temp = _class2 = function (_ComBase) {
  (0, _inherits3.default)(CheckBox, _ComBase);

  function CheckBox() {
    (0, _classCallCheck3.default)(this, CheckBox);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  /**
   * 组件挂载后
   * @returns {void} 无返回
   */
  CheckBox.prototype.componentDidMount = function componentDidMount() {
    if (this.props.indeterminate === true) {
      this._setIndeterminate(true);
    }
  };

  /**
   * 组件更新时（属性发生变化）
   * @param {object} previousProps 更新的属性
   * @returns {void} 无返回
   */


  CheckBox.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (previousProps.indeterminate !== this.props.indeterminate) {
      this._setIndeterminate(this.props.indeterminate);
    }
  };

  /**
   * 设置 indeterminate
   * @param {boolean} indeterminate indeterminate 的值
   * @returns {void} 无返回
   */


  CheckBox.prototype._setIndeterminate = function _setIndeterminate(indeterminate) {
    var node = this.domNode.querySelector('input');
    node.indeterminate = indeterminate;
    if (indeterminate) {
      node.setAttribute('indeterminate', 'indeterminate');
    } else {
      node.removeAttribute('indeterminate');
    }
  };

  /**
   * 渲染组件 dom
   * @returns {object} 组件 dom
   */


  CheckBox.prototype.render = function render() {
    /*eslint-disable*/
    var _props = this.props,
        indeterminate = _props.indeterminate,
        type = _props.type,
        className = _props.className,
        style = _props.style,
        others = (0, _objectWithoutProperties3.default)(_props, ['indeterminate', 'type', 'className', 'style']);
    /*eslint-enable*/

    var wrapperNames = (0, _common.cname)({
      checkBox: true,
      aniTransition: true,
      widget: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, className);
    var innerNames = (0, _common.cname)({
      checkBoxInner: true,
      aniTransition: true
    });
    return _react2.default.createElement(
      'label',
      { className: wrapperNames, style: style },
      _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, (0, _common.transportProps)(others))),
      _react2.default.createElement(
        'span',
        { className: innerNames },
        _react2.default.createElement(_components.Icon, { type: 'right1',
          className: (0, _common.cname)('aniTransition check-box-checked') }),
        _react2.default.createElement('i', { className: (0, _common.cname)('aniTransition icon check-box-indeterminate') })
      )
    );
  };

  return CheckBox;
}(_common.ComBase), _class2.propTypes = {

  /** 是否选中（受控属性） */
  checked: _propTypes2.default.bool,

  /** 默认选中（非受控属性） */
  defaultChecked: _propTypes2.default.bool,

  /** 是否禁用 */
  disabled: _propTypes2.default.bool,

  /** 是否半选状态 */
  indeterminate: _propTypes2.default.bool

}, _temp)) || _class);
exports.default = CheckBox;
module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

__webpack_require__(202);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(RadioGroup, _ComBase);

  function RadioGroup() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { value: null }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  RadioGroup.prototype.getClassNames = function getClassNames() {
    var _cname;

    var _props = this.props,
        layout = _props.layout,
        type = _props.type;

    return (0, _common.cname)((_cname = {
      checkBoxGroup: true,
      widget: true,
      aniTransition: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, _cname['layout-' + layout] = !!layout, _cname['type-' + type] = !!type, _cname), this.props.className);
  };

  RadioGroup.prototype.getItems = function getItems() {
    var _props2 = this.props,
        _props2$dataSource = _props2.dataSource,
        dataSource = _props2$dataSource === undefined ? [] : _props2$dataSource,
        _props2$data = _props2.data,
        data = _props2$data === undefined ? dataSource : _props2$data,
        _props2$items = _props2.items,
        items = _props2$items === undefined ? data : _props2$items;

    return items.map(function (item) {
      if (_common.utils.isObject(item)) return item;
      return { text: item, value: item };
    });
  };

  RadioGroup.prototype.getSelectedValues = function getSelectedValues() {
    var _props3 = this.props,
        _props3$defaultValue = _props3.defaultValue,
        defaultValue = _props3$defaultValue === undefined ? [] : _props3$defaultValue,
        _props3$value = _props3.value,
        value = _props3$value === undefined ? this.state.value || defaultValue : _props3$value;

    var selectedValues = value;
    if (!_common.utils.isArray(selectedValues)) selectedValues = [selectedValues];
    return selectedValues.map(function (value) {
      return String(value);
    });
  };

  RadioGroup.prototype.onItemChange = function onItemChange(event) {
    var _props4 = this.props,
        onChange = _props4.onChange,
        single = _props4.single;

    if (!_common.utils.isFunction(onChange)) return;
    var values = this.getSelectedValues().slice(0);
    if (event.target.checked && single) {
      values.length = 0;
      values[0] = event.target.value;
    } else if (event.target.checked) {
      values.push(event.target.value);
    } else {
      var index = values.indexOf(event.target.value);
      if (index > -1) values.splice(index, 1);
    }
    var value = single ? values[0] : values;
    this.setState({ value: value });
    onChange(new _common.EventArgs(this, value));
  };

  RadioGroup.prototype.isSelected = function isSelected(item) {
    var selectedValues = this.getSelectedValues();
    return selectedValues.some(function (value) {
      return value === String(item.value);
    });
  };

  //渲染内容


  RadioGroup.prototype.render = function render() {
    var _this2 = this;

    var items = this.getItems();
    var _props5 = this.props,
        _props5$name = _props5.name,
        name = _props5$name === undefined ? _common.utils.newGuid() : _props5$name,
        _props5$control = _props5.control,
        control = _props5$control === undefined ? _components.CheckBox : _props5$control,
        _props5$Control = _props5.Control,
        Control = _props5$Control === undefined ? control : _props5$Control,
        disabled = _props5.disabled;

    return _react2.default.createElement(
      'ul',
      { className: this.getClassNames() },
      items.map(function (item, index) {
        return _react2.default.createElement(
          'li',
          { key: item.value + String(index), disabled: item.disabled ? item.disabled : disabled },
          _react2.default.createElement(Control, { id: name + '-' + index,
            className: (0, _common.cname)('checkBoxGroupControl'),
            checked: _this2.isSelected(item),
            onChange: _this2.onItemChange.bind(_this2),
            disabled: item.disabled ? item.disabled : disabled,
            value: item.value }),
          _react2.default.createElement(
            'label',
            { className: (0, _common.cname)({
                checkBoxGroupLabel: true,
                stateActive: _this2.isSelected(item)
              }),
              disabled: item.disabled ? item.disabled : disabled,
              style: { width: _this2.props.itemWidth },
              htmlFor: name + '-' + index },
            item.text
          )
        );
      })
    );
  };

  return RadioGroup;
}(_common.ComBase), _class.propTypes = {

  /** 当前选中的值（数组） */
  value: _propTypes2.default.arrayOf(_propTypes2.default.string),

  /** 数据源（别名 data、items）`Array<{text:string,value:string}>` */
  dataSource: _propTypes2.default.arrayOf(_propTypes2.default.any),

  /** 选中项改变事件（`event.target.value` 或 `event.detail`） */
  onChange: _propTypes2.default.func,

  /** 显示类型（可指定为 button） */
  type: _propTypes2.default.string

}, _temp2);
exports.default = RadioGroup;
module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(204);

var _common = __webpack_require__(0);

var _Popover = __webpack_require__(47);

var _Popover2 = _interopRequireDefault(_Popover);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__(68);

var _Input2 = _interopRequireDefault(_Input);

var _Proxy = __webpack_require__(48);

var _Proxy2 = _interopRequireDefault(_Proxy);

var _Calendar = __webpack_require__(66);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _dateEntity = __webpack_require__(34);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

var _icon = __webpack_require__(207);

var _icon2 = _interopRequireDefault(_icon);

var _i18n = __webpack_require__(93);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePicker = (_dec = (0, _common.meta)({
  valuePropName: 'value',
  valuePath: 'detail'
}), _dec(_class = (_temp2 = _class2 = function (_ComBase) {
  (0, _inherits3.default)(DatePicker, _ComBase);

  function DatePicker() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { pickerVisible: false, value: null }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  DatePicker.prototype.render = function render() {
    var _this2 = this;

    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      widgetShadow: this.props.shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      datePicker: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible === true
    }, this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names }),
      _react2.default.createElement(_Input2.default, { ref: function ref(_ref) {
          _this2.input = _ref;
        },
        className: (0, _common.cname)('datePickerInput'),
        suffix: _react2.default.createElement(_icon2.default, {
          disabled: this.props.disabled,
          value: this.props.value,
          onClick: function onClick(type) {
            if (type === 'wrong') {
              var event = new _common.EventArgs(_this2, null);
              _this2.onChange.call(_this2, event);
            } else {
              _this2.onInputClick.call(_this2);
            }
          }
        }),
        value: this.value && this.value.format(this.format),
        readOnly: true,
        disabled: this.props.disabled,
        placeholder: this.props.placeholder,
        size: this.props.size,
        onClick: this.onInputClick.bind(this) }),
      _react2.default.createElement(
        _Popover2.default,
        { className: (0, _common.cname)('datePickerPanel'),
          ref: function ref(panel) {
            _this2.panel = panel;
          },
          follow: this.input,
          overlay: false,
          inside: this.props.inside,
          allowedDirection: ['bottom', 'top'],
          visible: this.state.pickerVisible },
        _react2.default.createElement(_Calendar2.default, (0, _extends3.default)({}, this.props, {
          onChange: this.onChange.bind(this),
          onDayClick: this.props.onDayClick,
          value: this.value,
          format: this.format,
          type: this.props.type,
          defaultType: this.props.defaultType,
          onSwitch: this.onSwitch.bind(this),
          visible: this.state.pickerVisible }))
      ),
      _react2.default.createElement(_Proxy2.default, { onClick: this.onDocumentClick.bind(this) })
    );
  };

  DatePicker.prototype._hasValue = function _hasValue() {
    return 'value' in this.props;
  };

  DatePicker.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        defaultValue = _props.defaultValue,
        _props$value = _props.value,
        value = _props$value === undefined ? defaultValue : _props$value;

    this.setState({ value: value });
  };

  DatePicker.prototype.onDocumentClick = function onDocumentClick(event) {
    if (_common.utils.inContainer(this.domNode, event.target) || _common.utils.inContainer(this.findDOMNode(this.panel), event.target)) {
      return;
    }
    if (this.state.pickerVisible) this.onClose();
  };

  DatePicker.prototype.onInputClick = function onInputClick() {
    this.setState({ pickerVisible: true });
  };

  DatePicker.prototype.onChange = function onChange(event, close) {
    this.setState({ value: event.detail });
    var type = this.props.type || this.props.defaultType;
    var onChange = this.props.onChange;

    if (_common.utils.isFunction(onChange)) onChange(event);
    if ((type === 'datetime' || type === 'time') && close !== true) return;
    this.onOk(event.detail);
    this.onClose(event.detail);
  };

  DatePicker.prototype.onClose = function onClose(value) {
    var event = new _common.EventArgs(this, new _dateEntity2.default(value || this.value));
    this.setState({ pickerVisible: false });
    var onClose = this.props.onClose;

    if (_common.utils.isFunction(onClose)) onClose(event);
  };

  DatePicker.prototype.onOk = function onOk(value) {
    var event = new _common.EventArgs(this, new _dateEntity2.default(value || this.value));
    this.setState({ pickerVisible: false });
    var onOk = this.props.onOk;

    if (_common.utils.isFunction(onOk)) onOk(event);
  };

  DatePicker.prototype.onSwitch = function onSwitch() {
    this.panel.reflow();
  };

  (0, _createClass3.default)(DatePicker, [{
    key: 'value',
    get: function get() {
      var _props$value2 = this.props.value,
          value = _props$value2 === undefined ? this.state.value || this.props.defaultValue : _props$value2;

      if (!value) return '';
      return new _dateEntity2.default(value);
    }
  }, {
    key: 'format',
    get: function get() {
      var builtInformat = _i18n2.default.current.format;
      var _props2 = this.props,
          type = _props2.type,
          defaultType = _props2.defaultType,
          format = _props2.format;

      if (format) return format;
      type = type || defaultType;
      return builtInformat[type] || builtInformat.date;
    }
  }]);
  return DatePicker;
}(_common.ComBase), _class2.i18n = _i18n2.default, _class2.DateEntity = _dateEntity2.default, _class2.defaultProps = {
  disabled: false,
  visible: true,
  format: 'yyyy/MM/dd',
  size: 'medium'
}, _class2.propTypes = {
  /* 修改日期的回调，`(event) => void` */
  onChange: _propTypes2.default.func,
  /** 是否显示阴影 */
  shadow: _propTypes2.default.bool,
  /** 格式化 */
  format: _propTypes2.default.string,
  /** 是否显示 */
  visible: _propTypes2.default.bool,
  /** 是否禁用 */
  disabled: _propTypes2.default.bool,
  /** 占位符 */
  placeholder: _propTypes2.default.string,
  /** 大小，同 Input */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'hero']),
  /** 日期 */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date), _propTypes2.default.instanceOf(_dateEntity2.default), _propTypes2.default.shape({
    year: _propTypes2.default.number,
    month: _propTypes2.default.number
  })]),
  /** 默认展示日期 */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date), _propTypes2.default.instanceOf(_dateEntity2.default), _propTypes2.default.shape({
    year: _propTypes2.default.number,
    month: _propTypes2.default.number
  })]),
  /** 日期选择器类型 */
  type: _propTypes2.default.oneOf(['time', 'year', 'month', 'date']),
  /** 默认日期选择器类型 */
  defaultType: _propTypes2.default.oneOf(['time', 'year', 'month', 'date'])
}, _temp2)) || _class);
exports.default = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _Icon = __webpack_require__(31);

var _Icon2 = _interopRequireDefault(_Icon);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickerIcon = function (_ComBase) {
  (0, _inherits3.default)(PickerIcon, _ComBase);

  function PickerIcon() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PickerIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      iconType: 'calendar'
    }, _this.onMouseHover = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          disabled = _this$props.disabled;
      var iconType = _this.state.iconType;

      if (iconType === 'calendar' && value && !disabled) {
        _this.setState({
          iconType: 'wrong'
        });
      }
    }, _this.onMouseOut = function () {
      var iconType = _this.state.iconType;

      if (iconType === 'wrong') {
        _this.setState({
          iconType: 'calendar'
        });
      }
    }, _this.onClick = function () {
      var iconType = _this.state.iconType;
      var _this$props2 = _this.props,
          onClick = _this$props2.onClick,
          disabled = _this$props2.disabled;

      !disabled && onClick && onClick(iconType);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  PickerIcon.prototype.render = function render() {
    var iconType = this.state.iconType;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Icon2.default, {
        onMouseOver: this.onMouseHover.bind(this),
        onMouseOut: this.onMouseOut.bind(this),
        onClick: this.onClick.bind(this),
        type: iconType })
    );
  };

  return PickerIcon;
}(_common.ComBase);

exports.default = PickerIcon;
module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _Icon = __webpack_require__(31);

var _Icon2 = _interopRequireDefault(_Icon);

var _Popover = __webpack_require__(47);

var _Popover2 = _interopRequireDefault(_Popover);

var _Input = __webpack_require__(68);

var _Input2 = _interopRequireDefault(_Input);

var _Proxy = __webpack_require__(48);

var _Proxy2 = _interopRequireDefault(_Proxy);

var _Grid = __webpack_require__(67);

var _Grid2 = _interopRequireDefault(_Grid);

var _Calendar = __webpack_require__(66);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _dateEntity = __webpack_require__(34);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

var _i18n = __webpack_require__(209);

var _i18n2 = _interopRequireDefault(_i18n);

var _quicks = __webpack_require__(210);

var _quicks2 = _interopRequireDefault(_quicks);

var _ntils = __webpack_require__(45);

__webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _Grid2.default.Row,
    Col = _Grid2.default.Col;
var DatePicker = (_dec = (0, _common.meta)({
  valuePropName: 'value',
  valuePath: 'detail'
}), _dec(_class = (_temp2 = _class2 = function (_ComBase) {
  (0, _inherits3.default)(DatePicker, _ComBase);

  function DatePicker() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { panelVisible: false, value: {} }, _this.getInputText = function () {
      var _this$props$format = _this.props.format,
          format = _this$props$format === undefined ? 'yyyy-MM-dd' : _this$props$format;
      var _this$value = _this.value,
          begin = _this$value.begin,
          end = _this$value.end;

      var beginLabel = begin ? begin.format(format) : '';
      var endLabel = end ? end.format(format) : '';
      if (!beginLabel && !endLabel) return '';
      return beginLabel + '  ~  ' + endLabel;
    }, _this.renderQuickItems = function () {
      var _this$props$quicks = _this.props.quicks,
          quicks = _this$props$quicks === undefined ? _quicks2.default : _this$props$quicks;

      return quicks.map(function (item) {
        return _react2.default.createElement(
          'li',
          { key: item.label, onClick: function onClick() {
              return _this.onQuickClick(item);
            } },
          item.label
        );
      });
    }, _this.renderFoot = function () {
      return _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('foot') },
        _react2.default.createElement(
          'ul',
          { className: (0, _common.cname)('quick') },
          _this.renderQuickItems()
        ),
        _react2.default.createElement(
          'a',
          { className: (0, _common.cname)('ok'), onClick: _this.onOk },
          _i18n2.default.current.ok
        )
      );
    }, _this.onInputClick = function () {
      _this.setState({ panelVisible: true });
    }, _this.onDocumentClick = function (event) {
      if (_common.utils.inContainer(_this.domNode, event.target) || _common.utils.inContainer(_this.findDOMNode(_this.panel), event.target)) {
        return;
      }
      if (_this.state.panelVisible) _this.onClose();
    }, _this.onClose = function () {
      _this.setState({ panelVisible: false });
      var onClose = _this.props.onClose;

      if (onClose) onClose(new _common.EventArgs(_this.value, _this.value));
    }, _this.onSwitch = function () {
      _this.panel.reflow();
    }, _this.onChange = function () {
      var onChange = _this.props.onChange;

      if (onChange) onChange(new _common.EventArgs(_this.value, _this.value));
    }, _this.onOk = function () {
      var onOk = _this.props.onOk;

      if (onOk) onOk(new _common.EventArgs(_this.value, _this.value));
      _this.onClose();
    }, _this.onBeginChange = function (event) {
      var _this2 = _this,
          value = _this2.value;

      value.begin = event.detail;
      _this.setState({ value: value });
      _this.onChange();
    }, _this.onEndChange = function (event) {
      var _this3 = _this,
          value = _this3.value;

      value.end = event.detail;
      _this.setState({ value: value });
      _this.onChange();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  DatePicker.prototype.render = function render() {
    var _this4 = this;

    var names = (0, _common.cname)({
      aniTransition: true,
      widgetShadow: this.props.shadow,
      cornerTl: true, cornerTr: true, cornerBl: true, cornerBr: true,
      dateRangePicker: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible === true
    }, this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names }),
      _react2.default.createElement(_Input2.default, (0, _extends3.default)({}, this.props, {
        ref: function ref(_ref) {
          _this4.input = _ref;
        },
        className: (0, _common.cname)('dateRangePickerInput'),
        suffix: _react2.default.createElement(_Icon2.default, { onClick: this.onInputClick,
          type: 'calendar' }),
        value: this.getInputText(),
        readOnly: true,
        placeholder: this.props.placeholder,
        size: this.props.size,
        onClick: this.onInputClick })),
      this.renderPanel(),
      _react2.default.createElement(_Proxy2.default, { onClick: this.onDocumentClick })
    );
  };

  DatePicker.prototype.renderPanel = function renderPanel() {
    var _this5 = this;

    var _props = this.props,
        min = _props.min,
        max = _props.max;

    return _react2.default.createElement(
      _Popover2.default,
      { className: (0, _common.cname)('dateRangePickerPanel'),
        ref: function ref(panel) {
          _this5.panel = panel;
        },
        follow: this.input,
        overlay: false,
        inside: this.props.inside,
        allowedDirection: ['bottom', 'top'],
        visible: this.state.panelVisible },
      _react2.default.createElement(
        _Grid2.default,
        { fluid: true, rowSpacing: 5, colPadding: 5 },
        _react2.default.createElement(
          Row,
          null,
          _react2.default.createElement(
            Col,
            { span: 12 },
            _react2.default.createElement(_Calendar2.default, (0, _extends3.default)({}, this.props, {
              onChange: this.onBeginChange,
              onDayClick: this.props.onDayClick,
              value: this.value.begin,
              onSwitch: this.onSwitch,
              footVisible: false,
              max: this.value.end || max,
              min: min,
              highlight: this.value,
              visible: this.state.panelVisible }))
          ),
          _react2.default.createElement(
            Col,
            { span: 12 },
            _react2.default.createElement(_Calendar2.default, (0, _extends3.default)({}, this.props, {
              onChange: this.onEndChange,
              onDayClick: this.props.onDayClick,
              value: this.value.end,
              onSwitch: this.onSwitch,
              footVisible: false,
              min: this.value.begin || min,
              max: max,
              highlight: this.value,
              visible: this.state.panelVisible }))
          )
        )
      ),
      this.renderFoot()
    );
  };

  DatePicker.prototype.onQuickClick = function onQuickClick(item) {
    var begin = item.begin,
        end = item.end;
    var value = this.value;

    value.begin = begin;
    value.end = end;
    this.setState({ value: value });
    this.onChange();
  };

  (0, _createClass3.default)(DatePicker, [{
    key: 'value',
    get: function get() {
      var value = this.props.value || this.state.value || this.props.defaultValue || {};
      if (!(value.begin instanceof _dateEntity2.default) && !(0, _ntils.isNull)(value.begin)) {
        value.begin = new _dateEntity2.default(value.begin);
      }
      if (!(value.end instanceof _dateEntity2.default) && !(0, _ntils.isNull)(value.end)) {
        value.end = new _dateEntity2.default(value.end);
      }
      return value;
    }
  }]);
  return DatePicker;
}(_common.ComBase), _class2.defaultQuicks = _quicks2.default, _class2.i18n = _i18n2.default, _temp2)) || _class);
exports.default = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    format: {
      year: 'yyyy',
      month: 'yyyy-MM',
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      time: 'hh:mm:ss'
    },
    weeks: [{ text: '一', value: 1 }, { text: '二', value: 2 }, { text: '三', value: 3 }, { text: '四', value: 4 }, { text: '五', value: 5 }, { text: '六', value: 6 }, { text: '日', value: 0 }],
    today: '今天',
    ok: '确定',
    time: '时间',
    hours: '时',
    minutes: '分',
    seconds: '秒'
  },
  en: {
    format: {
      year: 'yyyy',
      month: 'yyyy-MM',
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      time: 'hh:mm:ss'
    },
    weeks: [{ text: 'Sun', value: 0 }, { text: 'Mon', value: 1 }, { text: 'Tue', value: 2 }, { text: 'Wed', value: 3 }, { text: 'Thu', value: 4 }, { text: 'Fri', value: 5 }, { text: 'Sat', value: 6 }],
    today: 'Now',
    ok: 'Ok',
    time: 'Time',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  }
});
module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _dateEntity = __webpack_require__(34);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
  begin: new _dateEntity2.default().addDay(-7),
  end: new _dateEntity2.default(),
  label: '近7天'
}, {
  begin: new _dateEntity2.default().addDay(-17),
  end: new _dateEntity2.default(),
  label: '近14天'
}, {
  begin: new _dateEntity2.default().addDay(-30),
  end: new _dateEntity2.default(),
  label: '近30天'
}, {
  begin: new _dateEntity2.default().addMonth(0),
  end: new _dateEntity2.default().addMonth(1).addDay(-1),
  label: '本月'
}, {
  begin: new _dateEntity2.default().addMonth(-1),
  end: new _dateEntity2.default().addMonth(0).addDay(-1),
  label: '上月'
}];
module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(213);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dialog = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Dialog, _ComBase);

  function Dialog() {
    (0, _classCallCheck3.default)(this, Dialog);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  //渲染内容
  Dialog.prototype.render = function render() {
    var _props = this.props,
        modal = _props.modal,
        className = _props.className,
        props = (0, _objectWithoutProperties3.default)(_props, ['modal', 'className']);

    var names = (0, _common.cname)({
      dialog: true,
      widget: true
    }, className);
    return _react2.default.createElement(
      _components.Popover,
      (0, _extends3.default)({}, props, {
        className: names,
        visible: this.isVisible(),
        dock: 'center',
        overlay: modal !== false }),
      this.renderClose(),
      this.renderHeader(),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('content') },
        this.props.children
      ),
      this.renderFooter()
    );
  };

  Dialog.prototype.renderClose = function renderClose() {
    if (this.props.close === false) return null;
    return _react2.default.createElement(_components.Icon, { type: 'close', className: (0, _common.cname)('close'),
      onClick: this.close.bind(this) });
  };

  Dialog.prototype.renderHeader = function renderHeader() {
    if (this.props.title === false) return null;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('header') },
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)('title') },
        this.props.title
      )
    );
  };

  Dialog.prototype.renderFooter = function renderFooter() {
    var _this2 = this;

    var buttons = this.props.buttons;
    if (buttons === false) return null;
    buttons = (buttons || []).map(function (item) {
      if (_common.utils.isString(item)) {
        item = { text: item };
      }
      item.size = item.size || 'small';
      return item;
    });
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('footer') },
      buttons.map(function (item, index) {
        return _react2.default.createElement(
          _components.Button,
          (0, _extends3.default)({}, item, {
            key: index,
            onClick: _this2.onButtonClick.bind(_this2, index, item) }),
          item.text
        );
      })
    );
  };

  Dialog.prototype.isVisible = function isVisible() {
    if ('visible' in this.props) {
      return this.props.visible;
    }
    return !!(this.state && this.state.visible);
  };

  Dialog.prototype.onButtonClick = function onButtonClick(index, item, event) {
    var onButtonClick = this.props.onButtonClick;

    if (onButtonClick) {
      onButtonClick(new _common.EventArgs(this, index, event));
    }
    if (item.onClick) item.onClick(event);
  };

  Dialog.prototype.show = function show(event) {
    this.setState({ visible: true });
    var onShow = this.props.onShow;

    if (onShow) {
      onShow(new _common.EventArgs(this, null, event));
    }
  };

  Dialog.prototype.close = function close(event) {
    this.setState({ visible: false });
    var onClose = this.props.onClose;

    if (onClose) {
      onClose(new _common.EventArgs(this, null, event));
    }
  };

  return Dialog;
}(_common.ComBase), _class.propTypes = {

  /** 是否显示 */
  visible: _propTypes2.default.bool,

  /** 对话框标题 */
  title: _propTypes2.default.string,

  /** 底部按钮 `Array<{ButtonProps}>` */
  buttons: _propTypes2.default.arrayOf(_propTypes2.default.any),

  /** 底部按钮被单击事件 `function(index:number,item:object)` */
  onButtonClick: _propTypes2.default.func,

  /** 遮罩被单击事件 */
  onOverlayClick: _propTypes2.default.func,

  /** 右上角关闭按钮单击事件 */
  onClose: _propTypes2.default.func

}, _temp);
exports.default = Dialog;
module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _form = __webpack_require__(215);

var _form2 = _interopRequireDefault(_form);

var _item = __webpack_require__(98);

var _item2 = _interopRequireDefault(_item);

var _message = __webpack_require__(218);

var _message2 = _interopRequireDefault(_message);

var _control = __webpack_require__(219);

var _control2 = _interopRequireDefault(_control);

var _validate = __webpack_require__(69);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_form2.default.Item = _item2.default;
_form2.default.FormItem = _item2.default;

_form2.default.Message = _message2.default;
_form2.default.FormMessage = _message2.default;

_form2.default.Control = _control2.default;
_form2.default.FormControl = _control2.default;

_form2.default.validate = _validate2.default;
_form2.default.rules = _validate2.default.rules;

exports.default = _form2.default;
module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(216);

var _common = __webpack_require__(0);

var _item = __webpack_require__(98);

var _item2 = _interopRequireDefault(_item);

var _validate = __webpack_require__(69);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = (_dec = (0, _common.meta)({
  valuePropName: 'value',
  valuePath: 'detail.data'
}), _dec(_class = function (_ComBase) {
  (0, _inherits3.default)(Form, _ComBase);

  function Form() {
    (0, _classCallCheck3.default)(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args)));

    _this.state = { data: {} };

    _this.rules = {};
    return _this;
  }

  Form.prototype.getData = function getData() {
    var _props = this.props,
        vm = _props.vm,
        name = _props.name,
        value = _props.value,
        data = _props.data;

    var result = void 0;
    if (vm && name) {
      result = vm.state && vm.state[name] && vm.state[name].data;
    } else if (vm) {
      result = vm.state && vm.state.data;
    } else {
      result = value || data || this.state.data;
    }
    return (0, _assign2.default)({}, result);
  };

  Form.prototype.getUpdateMethod = function getUpdateMethod() {
    var _props2 = this.props,
        name = _props2.name,
        vm = _props2.vm,
        update = _props2.update;

    return function (state) {
      var _state;

      delete state.info;
      if (name) state = (_state = {}, _state[name] = state, _state);
      if (vm) {
        vm.setState(state);
      } else if (update) update(state);
    };
  };

  Form.prototype.wrapChildren = function wrapChildren(children, parentKey) {
    var _this2 = this;

    if (!children || !_common.utils.isObject(children)) return children;
    parentKey = parentKey || 'root';
    var data = this.getData();
    var _state2 = this.state,
        validate = _state2.validate,
        controledValidate = _state2.controledValidate;

    var foundChildren = this.findChildren(null, children);
    var wrappedChildren = foundChildren.map(function (child, index) {
      var selfKey = parentKey + '.' + index;
      if (child.type != _item2.default) {
        return _react2.default.cloneElement(child, {
          key: selfKey,
          children: _this2.wrapChildren(child.props.children, selfKey)
        });
      }
      var _child$props = child.props,
          name = _child$props.name,
          value = _child$props.value,
          rule = _child$props.rule;

      _this2.rules[name] = rule;
      return _react2.default.cloneElement(child, {
        key: selfKey,
        value: value || data[name],
        invalid: controledValidate && validate ? !validate.fields[name] : undefined,
        onChange: _this2.itemChange.bind(_this2, name),
        style: (0, _extends3.default)({}, child.props.style, {
          width: _this2.props.itemWidth
        })
      });
    });
    return wrappedChildren;
  };

  Form.prototype.validateData = function validateData(data) {
    var _this3 = this;

    var fields = {};
    var invalid = false;
    _common.utils.each(data, function (name, value) {
      fields[name] = (0, _validate2.default)(value, _this3.rules[name]);
      if (!fields[name]) invalid = true;
    });
    var result = { fields: fields, invalid: invalid };
    var onValidate = this.props.onValidate;

    if (onValidate) onValidate(new _common.EventArgs(this, result));
    return result;
  };

  Form.prototype.itemChange = function itemChange(name, event) {
    if (event.stopPropagation) event.stopPropagation();
    if (!event.detail) return;
    var detail = (0, _create2.default)(null);
    var data = this.getData();
    //info
    detail.info = {
      name: name,
      oldValue: data[name],
      newValue: event.detail.value,
      invalid: event.detail.invalid
    };
    //set
    data[name] = event.detail.value;
    detail.data = data;
    //validate
    detail.validate = this.validateData(detail.data);
    //update
    this.setState(detail);
    var onChange = this.props.onChange;

    if (onChange) onChange(new _common.EventArgs(this, detail, event));
    var update = this.getUpdateMethod();
    if (update) update(detail);
  };

  Form.prototype.verify = function verify() {
    var data = this.getData();
    var validate = this.validateData(data);
    this.setState({ validate: validate, controledValidate: true });
    return validate;
  };

  Form.prototype.componentDidMount = function componentDidMount() {
    var data = this.getData();
    var validate = this.validateData(data);
    var onChange = this.props.onChange;

    if (onChange) onChange(new _common.EventArgs(this, { validate: validate, data: data }));
    var update = this.getUpdateMethod();
    if (update) update({ validate: validate, data: data });
  };

  Form.prototype.render = function render() {
    var _cname;

    var layout = this.props.layout || 'block';
    var labelVAlign = this.props.labelVerticalAlign;
    var names = (0, _common.cname)((_cname = {
      widget: true,
      form: true,
      aniTransition: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, _cname['layout-' + layout] = !!layout, _cname.labelTop = this.props.labelTop, _cname['label-vertical-align-' + labelVAlign] = !!labelVAlign, _cname), this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names }),
      this.wrapChildren(this.props.children)
    );
  };

  return Form;
}(_common.ComBase)) || _class);
exports.default = Form;
module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormMessage = function (_ComBase) {
  (0, _inherits3.default)(FormMessage, _ComBase);

  function FormMessage() {
    (0, _classCallCheck3.default)(this, FormMessage);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  FormMessage.prototype.render = function render() {
    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      formMessage: true
    }, this.props.className);
    return _react2.default.createElement(
      'span',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names }),
      this.props.children
    );
  };

  return FormMessage;
}(_common.ComBase);

exports.default = FormMessage;
module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormControl = function (_ComBase) {
  (0, _inherits3.default)(FormControl, _ComBase);

  function FormControl() {
    (0, _classCallCheck3.default)(this, FormControl);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var control = this.findChildren()[0];
    if (!control) return _react2.default.createElement('span', { className: (0, _common.cname)('state-hidden') });
    return _react2.default.cloneElement(control, {
      className: (0, _common.cname)('form-control', this.props.className)
    });
  };

  return FormControl;
}(_common.ComBase);

exports.default = FormControl;
module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(221);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HyperText = function (_ComBase) {
  (0, _inherits3.default)(HyperText, _ComBase);

  function HyperText() {
    (0, _classCallCheck3.default)(this, HyperText);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  //渲染内容
  HyperText.prototype.render = function render() {
    var _props = this.props,
        visible = _props.visible,
        className = _props.className,
        content = _props.content,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['visible', 'className', 'content']);

    var names = (0, _common.cname)({
      hyperText: true,
      widget: true,
      aniTransition: true,
      stateHidden: visible === false,
      stateVisible: visible !== false
    }, className);
    return _react2.default.createElement('div', (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), { className: names,
      dangerouslySetInnerHTML: { __html: content } }));
  };

  return HyperText;
}(_common.ComBase);

exports.default = HyperText;
module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(30);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; //公共样式


__webpack_require__(61);

__webpack_require__(223);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _Icon = __webpack_require__(31);

var _Icon2 = _interopRequireDefault(_Icon);

var _util = __webpack_require__(224);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixCls = 'ipt-num';
var SPEED = 200;

var InputNumber = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(InputNumber, _ComBase);

  function InputNumber(props) {
    (0, _classCallCheck3.default)(this, InputNumber);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    var value = void 0;

    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    value = (0, _util.toNumber)(value);
    var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max;


    if (value < min || value > max) {
      throw new Error('the value should be between min and max');
    }

    _this.onKeyDown = _this.onKeyDown.bind(_this);

    if (!(typeof _this.onKeyDown === 'function')) {
      throw new TypeError('Value of "this.onKeyDown" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onKeyDown));
    }

    _this.onKeyUp = _this.onKeyUp.bind(_this);

    if (!(typeof _this.onKeyUp === 'function')) {
      throw new TypeError('Value of "this.onKeyUp" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onKeyUp));
    }

    _this.down = _this.down.bind(_this);

    if (!(typeof _this.down === 'function')) {
      throw new TypeError('Value of "this.down" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.down));
    }

    _this.up = _this.up.bind(_this);

    if (!(typeof _this.up === 'function')) {
      throw new TypeError('Value of "this.up" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.up));
    }

    _this.step = _this.step.bind(_this);

    if (!(typeof _this.step === 'function')) {
      throw new TypeError('Value of "this.step" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.step));
    }

    _this.stop = _this.stop.bind(_this);

    if (!(typeof _this.stop === 'function')) {
      throw new TypeError('Value of "this.stop" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.stop));
    }

    _this.onChange = _this.onChange.bind(_this);

    if (!(typeof _this.onChange === 'function')) {
      throw new TypeError('Value of "this.onChange" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChange));
    }

    _this.onBlur = _this.onBlur.bind(_this);

    if (!(typeof _this.onBlur === 'function')) {
      throw new TypeError('Value of "this.onBlur" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onBlur));
    }

    _this.onFocus = _this.onFocus.bind(_this);

    if (!(typeof _this.onFocus === 'function')) {
      throw new TypeError('Value of "this.onFocus" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onFocus));
    }

    _this.state = {
      inputValue: value,
      value: value,
      focused: props.autoFocus
    };
    return _this;
  }

  InputNumber.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        inputValue: nextProps.value,
        value: nextProps.value
      });
    }
  };

  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stop();
  };

  InputNumber.prototype.onKeyDown = function onKeyDown(e) {
    var onKeyDown = this.props.onKeyDown;

    if (e.keyCode === _common.KeyCode.ARROW_UP) {
      this.up(e);
      this.stop();
    } else if (e.keyCode === _common.KeyCode.ARROW_DOWN) {
      this.down(e);
      this.stop();
    }
    if (onKeyDown) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      onKeyDown.apply(undefined, [e].concat(args));
    }
  };

  InputNumber.prototype.onChange = function onChange(e) {
    var input = (0, _util.parser)(this.getValueFromEvent(e).trim());
    this.setState({ inputValue: input });
    this.props.onChange(this.toNumberWhenUserInput(input)); // valid number or invalid string
  };

  InputNumber.prototype.toNumberWhenUserInput = function toNumberWhenUserInput(num) {
    if ((/\.\d*0$/.test(num) || num.length > 16) && this.state.focused) {
      return num;
    }
    return (0, _util.toNumber)(num);
  };

  InputNumber.prototype.onFocus = function onFocus() {
    var _props;

    this.setState({
      focused: true
    });
    (_props = this.props).onFocus.apply(_props, arguments);
  };

  InputNumber.prototype.onBlur = function onBlur(e) {
    var _this2 = this;

    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    this.setState({
      focused: false
    });
    var value = this.getCurrentValidValue(this.state.inputValue);
    e.persist();
    this.setValue(value, function () {
      var _props2;

      (_props2 = _this2.props).onBlur.apply(_props2, [e].concat(args));
    });
  };

  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
    return e.target.value;
  };

  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
    var val = value;
    var props = this.props;
    if (val === '') {
      val = '';
    } else if (!(0, _util.isNotCompleteNumber)(val)) {
      val = Number(val);
      if (val < props.min) {
        val = props.min;
      }
      if (val > props.max) {
        val = props.max;
      }

      if (this.props.autoAjust && val % this.props.step != 0) {
        val = Math.floor(val / this.props.step) * this.props.step;
      }
    } else {
      val = this.state.value;
    }
    return (0, _util.toNumber)(val);
  };

  InputNumber.prototype.step = function step(type, e) {
    var ratio = 1;
    if (e) {
      e.preventDefault();
    }
    var _props3 = this.props,
        disabled = _props3.disabled,
        max = _props3.max,
        min = _props3.min;

    if (disabled) {
      return;
    }
    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
    if ((0, _util.isNotCompleteNumber)(value)) {
      return;
    }
    var val = this[type + 'Step'](value, ratio);
    if (val > max) {
      val = max;
    } else if (val < min) {
      val = min;
    }
    this.setValue(val);
    this.setState({
      focused: true
    });
  };

  InputNumber.prototype.stop = function stop() {
    if (this.autoStepTimer) {
      clearTimeout(this.autoStepTimer);
    }
  };

  InputNumber.prototype.down = function down(e) {
    var _this3 = this;

    if (e.persist) {
      e.persist();
    }
    this.stop();
    this.step('down', e);
    this.autoStepTimer = setTimeout(function () {
      _this3.down(e, true);
    }, SPEED);
  };

  InputNumber.prototype.up = function up(e) {
    var _this4 = this;

    if (e.persist) {
      e.persist();
    }
    this.stop();
    this.step('up', e);
    this.autoStepTimer = setTimeout(function () {
      _this4.up(e, true);
    }, SPEED);
  };

  InputNumber.prototype.onKeyUp = function onKeyUp(e) {
    this.stop();
    var onKeyUp = this.props.onKeyUp;

    if (onKeyUp) {
      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      onKeyUp.apply(undefined, [e].concat(args));
    }
  };

  InputNumber.prototype.setValue = function setValue(v, callback) {
    var newValue = (0, _util.isNotCompleteNumber)(parseFloat(v, 10)) ? undefined : parseFloat(v, 10);
    var changed = newValue !== this.state.value;
    if (!('value' in this.props)) {
      this.setState({
        value: newValue,
        inputValue: this.toPrecisionAsStep(v)
      }, callback);
    } else {
      this.setState({
        inputValue: this.toPrecisionAsStep(this.state.value)
      }, callback);
    }
    if (changed) {
      this.props.onChange(newValue);
    }
  };

  InputNumber.prototype.upStep = function upStep(val, rat) {
    var _props4 = this.props,
        step = _props4.step,
        min = _props4.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? step : min;
    }
    return (0, _util.toNumber)(result);
  };

  InputNumber.prototype.downStep = function downStep(val, rat) {
    var _props5 = this.props,
        step = _props5.step,
        min = _props5.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? -step : min;
    }
    return (0, _util.toNumber)(result);
  };

  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
    if ((0, _util.isNotCompleteNumber)(num) || num === '') {
      return num;
    }
    var precision = Math.abs(this.getMaxPrecision(num));
    if (!isNaN(precision)) {
      return Number(num).toFixed(precision);
    }
    return num.toString();
  };

  InputNumber.prototype.getPrecision = function getPrecision(value) {
    if ('precision' in this.props) {
      return this.props.precision;
    }
    var valueString = String(value).toString();
    if (valueString.indexOf('e-') >= 0) {
      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
    }
    var precision = 0;
    if (valueString.indexOf('.') >= 0) {
      precision = valueString.length - valueString.indexOf('.') - 1;
    }
    return precision;
  };

  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    if ('precision' in this.props) {
      return this.props.precision;
    }
    var step = this.props.step;

    var ratioPrecision = this.getPrecision(ratio);
    var stepPrecision = this.getPrecision(step);
    var currentValuePrecision = this.getPrecision(currentValue);
    if (!currentValue) {
      return ratioPrecision + stepPrecision;
    }
    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
  };

  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var precision = this.getMaxPrecision(currentValue, ratio);
    return Math.pow(10, precision);
  };

  InputNumber.prototype.getInputAttr = function getInputAttr() {
    var _cname;

    var props = this.props;
    var placeholder = props.placeholder,
        onClick = props.onClick,
        tabIndex = props.tabIndex,
        autoFocus = props.autoFocus,
        maxLength = props.maxLength,
        readOnly = props.readOnly,
        max = props.max,
        min = props.min,
        step = props.step,
        id = props.id,
        name = props.name;

    var disabled = this.disabled();

    var editable = !readOnly && !disabled;
    var inputDisplayValue = void 0;
    if (this.state.focused) {
      inputDisplayValue = this.state.inputValue;
    } else {
      inputDisplayValue = this.toPrecisionAsStep(this.state.value);
    }

    if (inputDisplayValue === undefined || inputDisplayValue === null) {
      inputDisplayValue = '';
    }
    var inputDisplayValueFormat = (0, _util.parser)(inputDisplayValue);
    var className = (0, _common.cname)((_cname = {}, _cname[prefixCls + '-input'] = true, _cname[prefixCls + '-input-disable'] = disabled, _cname));

    return {
      placeholder: placeholder,
      onClick: onClick,
      className: className,
      tabIndex: tabIndex,
      autoComplete: 'off',
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      autoFocus: autoFocus,
      maxLength: maxLength,
      readOnly: readOnly,
      disabled: disabled,
      max: max,
      min: min,
      step: step,
      id: id,
      name: name,
      onKeyDown: editable ? this.onKeyDown : _util.noop,
      onKeyUp: editable ? this.onKeyUp : _util.noop,
      onChange: this.onChange,
      value: inputDisplayValueFormat
    };
  };

  InputNumber.prototype.getHandlerEvent = function getHandlerEvent() {
    var props = this.props;
    var readOnly = props.readOnly,
        max = props.max,
        min = props.min;

    var disabled = this.disabled();
    var editable = !readOnly && !disabled;
    var upDisabledClass = disabled ? prefixCls + '-handler-up-disabled' : '';
    var downDisabledClass = disabled ? prefixCls + '-handler-down-disabled' : '';
    var value = this.state.value;

    if (value) {
      if (!isNaN(value)) {
        var val = Number(value);
        if (val >= max) {
          upDisabledClass = prefixCls + '-handler-up-disabled';
        }
        if (val <= min) {
          downDisabledClass = prefixCls + '-handler-down-disabled';
        }
      } else {
        upDisabledClass = prefixCls + '-handler-up-disabled';
        downDisabledClass = prefixCls + '-handler-down-disabled';
      }
    }

    var upEvents = {
      onMouseDown: editable && !upDisabledClass ? this.up : _util.noop,
      onMouseUp: this.stop,
      onMouseLeave: this.stop
    };
    var downEvents = {
      onMouseDown: editable && !downDisabledClass ? this.down : _util.noop,
      onMouseUp: this.stop,
      onMouseLeave: this.stop
    };
    return { upEvents: upEvents, downEvents: downEvents, downDisabledClass: downDisabledClass, upDisabledClass: upDisabledClass };
  };

  InputNumber.prototype.disabled = function disabled() {
    var _props6 = this.props,
        max = _props6.max,
        min = _props6.min,
        disabled = _props6.disabled;

    return disabled || max === min;
  };

  InputNumber.prototype.render = function render() {
    var _cname2, _cname3;

    var props = this.props;
    var inputAttr = this.getInputAttr();

    var _getHandlerEvent = this.getHandlerEvent(),
        upEvents = _getHandlerEvent.upEvents,
        downEvents = _getHandlerEvent.downEvents,
        downDisabledClass = _getHandlerEvent.downDisabledClass,
        upDisabledClass = _getHandlerEvent.upDisabledClass;

    var wrapCls = (0, _common.cname)((_cname2 = {}, _cname2['' + prefixCls] = true, _cname2['input-number'] = true, _cname2[prefixCls + '-hide'] = !props.visible, _cname2[prefixCls + '-disable'] = this.disabled(), _cname2), props.className);
    var handerAttr = {
      title: '',
      role: 'button',
      href: 'javascript:void(0);'
    };
    var divProps = (0, _assign2.default)({}, this.props);
    delete divProps.unit;
    delete divProps.step;

    var unitClassName = (0, _common.cname)((_cname3 = {}, _cname3[prefixCls + '-unit'] = true, _cname3[prefixCls + '-unit-disable'] = this.disabled(), _cname3));
    return _react2.default.createElement(
      'div',
      { className: wrapCls },
      _react2.default.createElement(
        'a',
        (0, _extends3.default)({}, handerAttr, {
          className: (0, _common.cname)(prefixCls + '-handle ' + prefixCls + '-reduce ' + downDisabledClass + ' corner-tl corner-bl')
        }, downEvents),
        _react2.default.createElement(_Icon2.default, { type: 'reduce', className: (0, _common.cname)(prefixCls + '-reduce-icon') })
      ),
      _react2.default.createElement('input', inputAttr),
      _react2.default.createElement(
        'span',
        { className: unitClassName },
        props.unit
      ),
      _react2.default.createElement(
        'a',
        (0, _extends3.default)({}, handerAttr, {
          className: (0, _common.cname)(prefixCls + '-handle ' + prefixCls + '-increase ' + upDisabledClass + ' corner-tr corner-br')
        }, upEvents),
        _react2.default.createElement(_Icon2.default, { type: 'add', className: (0, _common.cname)(prefixCls + '-icon') })
      )
    );
  };

  return InputNumber;
}(_common.ComBase), _class.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  value: _propTypes2.default.number,
  defaultValue: _propTypes2.default.number,
  step: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  autoAjust: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['large', 'small', 'default']),
  placeholder: _propTypes2.default.string,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  unit: _propTypes2.default.string
}, _class.defaultProps = {
  step: 1,
  min: 1,
  autoAjust: false,
  defaultValue: 1,
  onBlur: _util.noop,
  onChange: _util.noop,
  onFocus: _util.noop,
  disabled: false,
  unit: '个'
}, _temp);
exports.default = InputNumber;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

exports.__esModule = true;
function isNotCompleteNumber(num) {
  return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
}
function noop() {}
function parser(input) {
  return String(input).replace(/[^\w\.-]+/g, '');
}
exports.default = {
  noop: noop,
  parser: parser,
  isNotCompleteNumber: isNotCompleteNumber,
  toNumber: function toNumber(num, precision) {
    if (isNotCompleteNumber(num)) {
      return num;
    }
    if (precision) {
      return Number(Number(num).toFixed(this.props.precision));
    }
    return Number(num);
  }
};
module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(32);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

var _asyncToGenerator2 = __webpack_require__(33);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(7);

var _i18n = __webpack_require__(226);

var _i18n2 = _interopRequireDefault(_i18n);

__webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_DELAY = 25;
var DISTORY_DELAY = 500;

var Loading = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Loading, _ComBase);

  function Loading() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Loading);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { defaultVisiable: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Loading.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$content = _props.content,
        content = _props$content === undefined ? _i18n2.default.current.loading : _props$content,
        inside = _props.inside,
        _props$simple = _props.simple,
        simple = _props$simple === undefined ? inside ? true : false : _props$simple,
        icon = _props.icon,
        className = _props.className,
        _props$dock = _props.dock,
        dock = _props$dock === undefined ? 'center' : _props$dock,
        _props$overlay = _props.overlay,
        overlay = _props$overlay === undefined ? true : _props$overlay,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? this.state.defaultVisiable : _props$visible;

    icon = icon || Loading.icon;
    var classNames = (0, _common.cname)({
      loading: true, simple: simple
    }, className);
    return _react2.default.createElement(
      _components.Popover,
      (0, _extends3.default)({}, this.props, {
        className: classNames,
        dock: dock,
        overlay: overlay,
        inside: inside,
        visible: visible }),
      icon,
      ' ',
      simple ? null : children || content
    );
  };

  Loading.prototype.show = function show() {
    var onShow = this.props.onShow;

    this.setState({ defaultVisiable: true });
    if (onShow) onShow(new _common.EventArgs(this));
  };

  Loading.prototype.close = function close() {
    var onClose = this.props.onClose;

    this.setState({ defaultVisiable: false });
    if (onClose) onClose(new _common.EventArgs(this));
  };

  return Loading;
}(_common.ComBase), _class.propTypes = {

  /** 类名 */
  className: _propTypes2.default.string,

  /** 内容 */
  content: _propTypes2.default.string,

  /** 可见性 */
  visible: _propTypes2.default.bool,

  /** 阴影 */
  shadow: _propTypes2.default.bool,

  /** 是否显示遮罩 */
  overlay: _propTypes2.default.bool,

  /** 在父容器内部展示 */
  inside: _propTypes2.default.bool,

  /** 简单模式 */
  simple: _propTypes2.default.bool

}, _temp2);


Loading.icon = _react2.default.createElement(_components.Icon, { type: 'loading', spin: true });

Loading.show = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(content, opts) {
    var _this2 = this;

    var loadingInstance, closeAndDistory, initailOnClose;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            opts = opts || (0, _create2.default)(null);
            opts.content = content;
            loadingInstance = void 0;
            //关闭并且销毁

            closeAndDistory = function () {
              var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _common.sleep)(DISTORY_DELAY);

                      case 2:
                        (0, _common.unmount)(loadingInstance);

                      case 3:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this2);
              }));

              return function closeAndDistory() {
                return _ref2.apply(this, arguments);
              };
            }();

            initailOnClose = opts.onClose;

            opts.onClose = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
              return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (initailOnClose) initailOnClose();
                      closeAndDistory();

                    case 2:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, _this2);
            }));
            _context3.next = 8;
            return (0, _common.render)(_react2.default.createElement(Loading, opts));

          case 8:
            loadingInstance = _context3.sent;
            _context3.next = 11;
            return (0, _common.sleep)(SHOW_DELAY);

          case 11:
            loadingInstance.show();
            return _context3.abrupt('return', loadingInstance);

          case 13:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = Loading;
module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    loading: '正在载入...'
  },
  en: {
    loading: 'Loading...'
  }
});
module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _menu = __webpack_require__(99);

var _menu2 = _interopRequireDefault(_menu);

var _item = __webpack_require__(229);

var _item2 = _interopRequireDefault(_item);

var _submenu = __webpack_require__(230);

var _submenu2 = _interopRequireDefault(_submenu);

__webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_menu2.default.Item = _item2.default;
_menu2.default.SubMenu = _submenu2.default;

exports.default = _menu2.default;
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Item, _ComBase);

  function Item() {
    (0, _classCallCheck3.default)(this, Item);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Item.prototype.onClick = function onClick(e) {
    if (e.target.tagName !== 'LI') return;
    var _props = this.props,
        itemKey = _props.itemKey,
        onClick = _props.onClick;

    onClick(new _common.EventArgs(this, itemKey, e));
    this.onSelectChange(e);
  };

  Item.prototype.onCheckChange = function onCheckChange(e) {
    this.onSelectChange(e);
  };

  Item.prototype.onSelectChange = function onSelectChange(e) {
    var _props2 = this.props,
        itemKey = _props2.itemKey,
        selectMode = _props2.selectMode,
        selected = _props2.selected,
        onSelect = _props2.onSelect,
        onDeselect = _props2.onDeselect;

    if (selectMode === 'multiple') {
      if (selected) {
        return onDeselect(new _common.EventArgs(this, { key: itemKey }, e));
      }
      return onSelect(new _common.EventArgs(this, { key: itemKey }, e));
    }
    onSelect(new _common.EventArgs(this, { key: itemKey }, e));
  };

  Item.prototype.render = function render() {
    var _props3 = this.props,
        selectMode = _props3.selectMode,
        disabled = _props3.disabled,
        selected = _props3.selected,
        className = _props3.className,
        children = _props3.children,
        other = (0, _objectWithoutProperties3.default)(_props3, ['selectMode', 'disabled', 'selected', 'className', 'children']);

    var multiple = selectMode === 'multiple';
    var cls = (0, _common.cname)({
      menuItem: true,
      multiple: multiple,
      stateDisabled: disabled,
      stateActive: selected
    }, className);
    var events = disabled ? { onClick: function onClick() {} } : { onClick: this.onClick.bind(this) };
    return _react2.default.createElement(
      'li',
      (0, _extends3.default)({}, (0, _common.transportProps)(other), { className: cls }, events),
      multiple ? _react2.default.createElement(_components.CheckBox, {
        className: (0, _common.cname)('menu-item-checkbox'),
        checked: selected,
        onChange: this.onCheckChange.bind(this)
      }) : null,
      children
    );
  };

  return Item;
}(_common.ComBase), _class.propTypes = {
  /**
   * 是否禁用
   */
  disabled: _propTypes2.default.bool
}, _class.defaultProps = {
  disabled: false,
  selected: false
}, _temp);
exports.default = Item;
module.exports = exports['default'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _menu = __webpack_require__(99);

var _menu2 = _interopRequireDefault(_menu);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubMenu = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(SubMenu, _ComBase);

  function SubMenu() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SubMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      mouseInTitle: false,
      mouseInPopover: false,
      isSubOpen: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  SubMenu.prototype.onTitleClick = function onTitleClick(e) {
    var _props = this.props,
        itemKey = _props.itemKey,
        onTitleClick = _props.onTitleClick;

    onTitleClick(new _common.EventArgs(this, itemKey, e));
    this.setState(function (prev) {
      return { isSubOpen: !prev.isSubOpen };
    });
  };

  SubMenu.prototype.onMouseEnter = function onMouseEnter() {
    this.setState({ mouseInTitle: true });
  };

  SubMenu.prototype.onMouseLeave = function onMouseLeave() {
    this.setState({ mouseInTitle: false });
  };

  SubMenu.prototype.onMouseEnterPopover = function onMouseEnterPopover() {
    this.setState({ mouseInPopover: true });
  };

  SubMenu.prototype.onMouseLeavePopover = function onMouseLeavePopover() {
    this.setState({ mouseInPopover: false });
  };

  SubMenu.prototype.renderIcon = function renderIcon(mode) {
    var isSubOpen = this.state.isSubOpen;

    var inlineType = 'arrow-' + (isSubOpen ? 'up' : 'down');
    switch (mode) {
      case 'vertical':
        return _react2.default.createElement(_components.Icon, { type: 'arrow-right', className: (0, _common.cname)('submenu-arrow') });
      case 'inline':
        return _react2.default.createElement(_components.Icon, { type: inlineType, className: (0, _common.cname)('submenu-arrow') });
    }
  };

  SubMenu.prototype.renderChildren = function renderChildren(children) {
    var _props2 = this.props,
        mode = _props2.mode,
        selectMode = _props2.selectMode,
        selectedKeys = _props2.selectedKeys,
        onClick = _props2.onClick,
        onSelect = _props2.onSelect,
        onDeselect = _props2.onDeselect;
    var _state = this.state,
        mouseInPopover = _state.mouseInPopover,
        mouseInTitle = _state.mouseInTitle,
        isSubOpen = _state.isSubOpen;

    var open = mouseInPopover || mouseInTitle;
    var direction = {
      'vertical': 'right',
      'horizontal': 'bottom'
    };
    var align = {
      'vertical': 'top',
      'horizontal': 'center'
    };
    if (mode == 'inline') {
      var subcls = (0, _common.cname)({
        aniTransition: true,
        'menu-sub': true,
        'sub-open': isSubOpen,
        'sub-hidden': !isSubOpen
      });
      return _react2.default.createElement(
        _menu2.default,
        {
          mode: mode,
          selectMode: selectMode,
          selectedKeys: selectedKeys,
          onClick: onClick,
          onSelect: onSelect,
          onDeselect: onDeselect,
          className: subcls
        },
        children
      );
    }
    return _react2.default.createElement(
      _components.Popover,
      { overlay: false,
        visible: open,
        follow: this.li,
        direction: direction[mode],
        align: align[mode],
        className: (0, _common.cname)('submenu-popover'),
        onMouseEnter: this.onMouseEnterPopover.bind(this),
        onMouseLeave: this.onMouseLeavePopover.bind(this)
      },
      _react2.default.createElement(
        _menu2.default,
        {
          selectMode: selectMode,
          selectedKeys: selectedKeys,
          onClick: onClick,
          onSelect: onSelect,
          onDeselect: onDeselect
        },
        children
      )
    );
  };

  SubMenu.prototype.render = function render() {
    var _cname,
        _this2 = this;

    var _props3 = this.props,
        mode = _props3.mode,
        title = _props3.title,
        disabled = _props3.disabled,
        style = _props3.style,
        className = _props3.className,
        children = _props3.children;
    var _state2 = this.state,
        mouseInPopover = _state2.mouseInPopover,
        mouseInTitle = _state2.mouseInTitle;

    var open = mouseInPopover || mouseInTitle;
    var cls = (0, _common.cname)((_cname = {
      submenu: true
    }, _cname['submenu-' + mode] = !!mode, _cname.stateDisabled = disabled, _cname.open = open, _cname), className);
    var titleCls = (0, _common.cname)({
      submenuTitle: true,
      stateDisabled: disabled
    });
    var titleEvents = disabled ? {} : {
      onClick: this.onTitleClick.bind(this),
      onMouseEnter: this.onMouseEnter.bind(this),
      onMouseLeave: this.onMouseLeave.bind(this)
    };
    return _react2.default.createElement(
      'li',
      { className: cls, ref: function ref(li) {
          _this2.li = li;
        } },
      _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: style, className: titleCls }, titleEvents),
        title,
        this.renderIcon(mode)
      ),
      this.renderChildren(children)
    );
  };

  return SubMenu;
}(_common.ComBase), _class.propTypes = {
  /**
   * 子菜单标题
   */
  title: _propTypes2.default.string,
  /**
   * 是否禁用
   */
  disabled: _propTypes2.default.bool,
  /**
   * 点击子菜单标题的回调
   */
  onTitleClick: _propTypes2.default.func
}, _class.defaultProps = {
  disabled: false,
  onTitleClick: function onTitleClick() {}
}, _temp2);
exports.default = SubMenu;
module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(30);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__(32);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(33);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class2, _temp;

__webpack_require__(233);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//内部私有遮罩实现
var OverlayInner = function (_ComBase) {
  (0, _inherits3.default)(OverlayInner, _ComBase);

  /**
   * 构造一个 OverlayInner 实例
   * @param {arguments} args 参数
   * @returns {void} 无返回
   */
  function OverlayInner() {
    (0, _classCallCheck3.default)(this, OverlayInner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args)));

    _this.state = { visible: false };
    _this.activeList = [];

    _this.show = _this.show.bind(_this);

    if (!(typeof _this.show === 'function')) {
      throw new TypeError('Value of "this.show" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.show));
    }

    _this.hide = _this.hide.bind(_this);

    if (!(typeof _this.hide === 'function')) {
      throw new TypeError('Value of "this.hide" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.hide));
    }

    _this.onClick = _this.onClick.bind(_this);

    if (!(typeof _this.onClick === 'function')) {
      throw new TypeError('Value of "this.onClick" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.onClick));
    }

    return _this;
  }

  /**
   * 渲染 dom
   * @returns {object} dom
   */


  OverlayInner.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? this.state.visible : _props$visible,
        inside = _props.inside;

    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      overlay: true,
      stateHidden: !visible,
      stateVisible: !!visible,
      inside: inside
    }, className);
    return _react2.default.createElement('div', { className: names,
      onClick: this.onClick });
  };

  /**
   * 单击时的处理方法，在此方法中处理 opts.onClick
   * @returns {void} 无返回
   */


  OverlayInner.prototype.onClick = function onClick() {
    var _this2 = this;

    var onClick = this.props.onClick;

    if (_common.utils.isFunction(onClick)) onClick(new _common.EventArgs(this.owner || this));
    this.activeList.filter(function (item) {
      return _common.utils.isFunction(item.onClick);
    }).forEach(function (item) {
      return item.onClick(new _common.EventArgs(item.target || _this2));
    });
  };

  /**
   * 显示 overlay
   * @param {any} opts 显示选项
   * @returns {function} overlay 的引用标识 
   */


  OverlayInner.prototype.show = function show(opts) {
    var _this3 = this;

    if (!opts) return this.setState({ visible: true });
    opts = (0, _extends3.default)({}, opts);
    opts.id = opts.id || _common.utils.newGuid();
    var foundItem = this.activeList.find(function (item) {
      return item.id == opts.id;
    });
    if (foundItem) return foundItem.ref;
    this.setState({ visible: true });
    opts.ref = function () {
      _this3.hide(opts.id);
    };
    opts.ref.id = opts.id;
    this.activeList.push(opts);
    return opts.ref;
  };

  /**
   * 隐藏 overlay
   * @param {object} ref 已显示的 overlay 的引用
   * @returns {void} 无返回
   */


  OverlayInner.prototype.hide = function hide(ref) {
    if (!ref) return this.setState({ visible: false });
    var id = ref.id || ref;
    var index = this.activeList.findIndex(function (item) {
      return item.id == id;
    });
    if (index < 0) return;
    this.activeList.splice(index, 1);
    if (this.activeList.length < 1) {
      this.setState({ visible: false });
    }
  };

  return OverlayInner;
}(_common.ComBase);

//创建 overlayInner 唯一实例


var overlayInner = void 0;

function getOverlayInner() {
  if (!overlayInner) overlayInner = (0, _common.render)(_react2.default.createElement(OverlayInner, null));
  return overlayInner;
}

// Overlay 组件类
var Overlay = (_temp = _class2 = function (_ComBase2) {
  (0, _inherits3.default)(Overlay, _ComBase2);

  /**
   * 构造一个 OverlayInner 实例
   * @param {arguments} args 参数
   * @returns {void} 无返回
   */
  function Overlay() {
    (0, _classCallCheck3.default)(this, Overlay);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _this4 = (0, _possibleConstructorReturn3.default)(this, _ComBase2.call.apply(_ComBase2, [this].concat(args)));

    _this4.id = _common.utils.newGuid();
    return _this4;
  }

  Overlay.prototype.render = function render() {
    if (this.props.inside) {
      return _react2.default.createElement(OverlayInner, (0, _extends3.default)({}, this.props, { owner: this }));
    } else {
      return _react2.default.createElement('span', { className: (0, _common.cname)('state-hidden') });
    }
  };

  /**
   * 在属性有更新新时通过 update 方法执行 overlayInner 的动作
   * @param {Object} nextProps 新的属性 map
   * @returns {void} 无返回
   */


  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.inside) return;
    this.update(nextProps);
  };

  /**
   * 在组件挂载时通过 update 方法执行 overlayInner 的动作
   * @returns {void} 无返回
   */


  Overlay.prototype.componentDidMount = function componentDidMount() {
    if (this.props.inside) return;
    this.update(this.props);
  };

  Overlay.prototype.componentWillUnmount = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var overlayInner;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.props.inside) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return getOverlayInner();

            case 4:
              overlayInner = _context.sent;

              overlayInner.hide(this.id);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentWillUnmount() {
      return _ref.apply(this, arguments);
    }

    return componentWillUnmount;
  }();

  /**
   * 通过 opts 执行 overlayInner 的动作
   * @param {object} opts 选项
   * @returns {void} 无返回
   */


  Overlay.prototype.update = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(opts) {
      var overlayInner;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.props.inside) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              _context2.next = 4;
              return getOverlayInner();

            case 4:
              overlayInner = _context2.sent;

              if (opts.visible) {
                opts = (0, _extends3.default)({}, opts, { id: this.id, target: this });
                overlayInner.show(opts);
              } else {
                overlayInner.hide(this.id);
              }

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function update(_x) {
      return _ref2.apply(this, arguments);
    }

    return update;
  }();

  return Overlay;
}(_common.ComBase), _class2.propTypes = {
  /** 类名 */
  className: _propTypes2.default.string,

  /** 可见性 */
  visible: _propTypes2.default.bool,

  /** 组件内部展示 */
  inside: _propTypes2.default.bool,

  /** 点击事件 */
  onClick: _propTypes2.default.func
}, _class2.defaultProps = {
  visible: false,
  inside: false
}, _temp);

//挂载静态方法

Overlay.show = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var overlayInner,
        _args3 = arguments;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getOverlayInner();

          case 2:
            overlayInner = _context3.sent;
            return _context3.abrupt('return', overlayInner.show.apply(overlayInner, _args3));

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function () {
    return _ref3.apply(this, arguments);
  };
}();

Overlay.hide = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    var overlayInner,
        _args4 = arguments;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getOverlayInner();

          case 2:
            overlayInner = _context4.sent;
            return _context4.abrupt('return', overlayInner.hide.apply(overlayInner, _args4));

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function () {
    return _ref4.apply(this, arguments);
  };
}();

//导出组件
exports.default = Overlay;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps; //公共样式

// import Options from "./Options";


__webpack_require__(61);

__webpack_require__(235);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = __webpack_require__(236);

var _i18n2 = _interopRequireDefault(_i18n);

var _Pager = __webpack_require__(239);

var _Pager2 = _interopRequireDefault(_Pager);

var _input = __webpack_require__(240);

var _input2 = _interopRequireDefault(_input);

var _option = __webpack_require__(241);

var _option2 = _interopRequireDefault(_option);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixCls = 'pagination';
var wrapPrefixCls = 'pagination-full';

function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type) {
  return _react2.default.createElement(
    'a',
    null,
    type === 'page' ? page : ''
  );
}

var Pagination = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Pagination, _ComBase);

  function Pagination(props) {
    (0, _classCallCheck3.default)(this, Pagination);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var current = props.defaultCurrent;

    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    var totalPage = _this.calculatePage(pageSize);
    if (current > totalPage) {
      current = totalPage;
    }
    if (current < 1) {
      current = 1;
    }

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  Pagination.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('current' in nextProps) {
      var current = nextProps.current;
      this.setState({
        current: current,
        currentInputValue: current
      });
    }

    if ('pageSize' in nextProps) {
      var newState = {};
      var _current = this.state.current;
      var newCurrent = this.calculatePage(nextProps.pageSize);
      _current = _current > newCurrent ? newCurrent : _current;
      if (!('current' in nextProps)) {
        newState.current = _current;
        newState.currentInputValue = _current;
      }
      newState.pageSize = nextProps.pageSize;
      this.setState(newState);
    }
  };

  Pagination.prototype.getJumpPrevPage = function getJumpPrevPage() {
    return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
  };

  /**
   *
   * @returns {Number} 要跳转的下一页
   * @memberof Pager
   */


  Pagination.prototype.getJumpNextPage = function getJumpNextPage() {
    return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
  };

  //计算需要显示总页数

  // 上一页

  // 下一页

  //跳到第一页

  //跳到最后一页


  /* eslint-disable */
  Pagination.prototype.render = function render() {
    var _this2 = this,
        _cname;

    var props = this.props;
    var _props = this.props,
        showLessItems = _props.showLessItems,
        showTitle = _props.showTitle,
        itemRender = _props.itemRender,
        selectComponentClass = _props.selectComponentClass,
        pageSizeOptions = _props.pageSizeOptions;


    var locale = this.locale;

    wrapPrefixCls = 'pagination-full';

    if (props.simple) {
      wrapPrefixCls = 'pagination-simple';
    }

    var _state = this.state,
        current = _state.current,
        pageSize = _state.pageSize;

    var allPages = this.calculatePage();
    var pagerList = [];
    var jumpPrev = null;
    var jumpNext = null;
    var firstPager = null;
    var lastPager = null;
    var totalText = null;

    var pageBufferSize = showLessItems ? 1 : 2;

    var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
    var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
    //返回每个页码的属性
    var getPagerAttr = function getPagerAttr(i) {
      return {
        locale: locale,
        active: current === i,
        showTitle: showTitle,
        rootPrefixCls: (0, _common.cname)('' + prefixCls),
        onClick: function onClick() {
          return _this2.handleChange(i);
        },
        onKeyPress: function onKeyPress(e) {
          return _this2.runIfEnter(e, _this2.handleChange, i);
        },
        key: i,
        page: i,
        itemRender: itemRender
      };
    };
    //获取中间部分页面的左右索引
    var getOffset = function getOffset() {
      var left = Math.max(1, current - pageBufferSize); //当前页码左侧的索引
      var right = Math.min(current + pageBufferSize, allPages); //当前页码右侧的索引

      // 如果页码很小，调整right的参数，使得显示的页码数量不会太少
      if (current - 1 <= pageBufferSize) {
        right = 1 + pageBufferSize * 2;
      }

      if (allPages - current <= pageBufferSize) {
        left = allPages - pageBufferSize * 2;
      }

      return { left: left, right: right };
    };

    //页数比较少，把页码全部显示出来
    if (allPages <= 5 + pageBufferSize * 2) {
      for (var i = 1; i <= allPages; i++) {
        pagerList.push(_react2.default.createElement(_Pager2.default, getPagerAttr(i)));
      }
    } else {
      // 第一部分的省略号
      jumpPrev = _react2.default.createElement(
        'li',
        {
          title: props.showTitle ? prevItemTitle : null,
          key: 'prev',
          tabIndex: '0',
          onClick: this.jumpPrev,
          onKeyPress: function onKeyPress(e) {
            return _this2.runIfEnter(e, _this2.jumpPrev);
          },
          className: (0, _common.cname)(prefixCls + '-jump-prev')
        },
        props.itemRender(this.getJumpPrevPage(), 'jump-prev')
      );
      // 第二部分的省略号
      jumpNext = _react2.default.createElement(
        'li',
        {
          title: props.showTitle ? nextItemTitle : null,
          key: 'next',
          tabIndex: '0',
          onClick: this.jumpNext,
          onKeyPress: function onKeyPress(e) {
            return _this2.runIfEnter(e, _this2.jumpNext);
          },
          className: (0, _common.cname)(prefixCls + '-jump-next')
        },
        props.itemRender(this.getJumpNextPage(), 'jump-next')
      );

      lastPager = _react2.default.createElement(_Pager2.default, getPagerAttr(allPages));
      firstPager = _react2.default.createElement(_Pager2.default, getPagerAttr(1));

      var _getOffset = getOffset(),
          left = _getOffset.left,
          right = _getOffset.right;

      for (var _i = left; _i <= right; _i++) {
        pagerList.push(_react2.default.createElement(_Pager2.default, getPagerAttr(_i)));
      }
      if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
        pagerList[0] = _react2.default.cloneElement(pagerList[0], {
          className: (0, _common.cname)(prefixCls + '-item-after-jump-prev')
        });
        pagerList.unshift(jumpPrev);
      }
      if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
        pagerList[pagerList.length - 1] = _react2.default.cloneElement(pagerList[pagerList.length - 1], {
          className: (0, _common.cname)(prefixCls + '-item-before-jump-next')
        });
        pagerList.push(jumpNext);
      }

      if (left !== 1) {
        if (left > 2) {
          firstPager = _react2.default.cloneElement(firstPager, {
            className: (0, _common.cname)(prefixCls + '-item-border')
          });
        }

        pagerList.unshift(firstPager);
      }
      if (right !== allPages) {
        pagerList.push(lastPager);
      }
    }
    //显示总数
    if (props.showTotal) {
      totalText = _react2.default.createElement(
        'li',
        { className: (0, _common.cname)(prefixCls + '-total-text') },
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)(prefixCls + '-total-items-text') },
          locale.totalItems(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        )
      );
    }
    //显示页码size
    if (pageSizeOptions) {
      var attr = {
        locale: locale,
        rootPrefixCls: prefixCls,
        changeSize: this.changePageSize,
        selectComponentClass: selectComponentClass,
        current: current,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions
      };
      totalText = _react2.default.createElement(
        'li',
        { className: (0, _common.cname)(prefixCls + '-total-text') },
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)(prefixCls + '-total-items-text') },
          locale.totalAndSize(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        ),
        _react2.default.createElement(_option2.default, attr)
      );
    }

    var prevDisabled = !this.hasPrev();
    var nextDisabled = !this.hasNext();
    var firstDisabled = this.isFirst();
    var lastDisabled = this.isLast();

    var prevPage = this.state.current - 1 > 0 ? this.state.current - 1 : 0;
    var nextPage = this.state.current + 1 < allPages ? this.state.current + 1 : allPages;

    // 跳到第一页
    var cls = (0, _common.cname)((!firstDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-jump-first');
    var jumpToFirst = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? nextItemTitle : null,
        key: 'first',
        tabIndex: '0',
        onClick: this.jumpToFirst,
        className: cls,
        'aria-disabled': firstDisabled
      },
      props.itemRender('', 'jump-first')
    );
    cls = (0, _common.cname)((!lastDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-jump-last');
    // 跳到最后一页
    var jumpToLast = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? nextItemTitle : null,
        key: 'last',
        tabIndex: '0',
        onClick: this.jumpToLast,
        className: cls,
        'aria-disabled': lastDisabled
      },
      props.itemRender('', 'jump-last')
    );
    cls = (0, _common.cname)((!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev');
    //上一页
    var jumpPrevButton = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? locale.prev_page : null,
        onClick: this.prev,
        tabIndex: '0',
        onKeyPress: function onKeyPress(e) {
          return _this2.runIfEnter(e, _this2.prev);
        },
        className: cls,
        'aria-disabled': prevDisabled
      },
      props.itemRender(prevPage, 'prev')
    );
    cls = (0, _common.cname)((!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next');
    // 下一页
    var jumpNextButton = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? locale.next_page : null,
        onClick: this.next,
        tabIndex: '0',
        onKeyPress: function onKeyPress(e) {
          return _this2.runIfEnter(e, _this2.next);
        },
        className: cls,
        'aria-disabled': nextDisabled
      },
      props.itemRender(nextPage, 'next')
    );

    var a = '' + prefixCls;
    var b = prefixCls + '-hide';
    var wrapCls = (0, _common.cname)((_cname = {}, _cname[a] = true, _cname['' + wrapPrefixCls] = true, _cname[b] = !props.visible, _cname), props.className);
    return _react2.default.createElement(
      'div',
      { className: wrapCls },
      _react2.default.createElement(
        'ul',
        {
          className: (0, _common.cname)(prefixCls + '-wrap'),
          style: props.style,
          unselectable: 'unselectable'
        },
        totalText,
        jumpPrevButton,
        pagerList,
        jumpNextButton
      ),
      _react2.default.createElement(_input2.default, {
        locale: locale,
        rootPrefixCls: prefixCls,
        current: this.state.current,
        quickGo: this.props.showQuickJumper ? this.handleChange : null
      })
    );
  };

  (0, _createClass3.default)(Pagination, [{
    key: 'locale',
    get: function get() {
      return this.props.locale || _i18n2.default.current || this.props.defaultLocale;
    }
  }]);
  return Pagination;
}(_common.ComBase), _class.i18n = _i18n2.default, _class.propTypes = {
  simple: _propTypes2.default.bool,
  visible: _propTypes2.default.bool,
  current: _propTypes2.default.number,
  defaultCurrent: _propTypes2.default.number,
  total: _propTypes2.default.number,
  pageSize: _propTypes2.default.number,
  defaultPageSize: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  showLessItems: _propTypes2.default.bool,
  onPageSizeChange: _propTypes2.default.func,
  selectComponentClass: _propTypes2.default.func,
  showQuickJumper: _propTypes2.default.bool,
  showTitle: _propTypes2.default.bool,
  pageSizeOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showTotal: _propTypes2.default.bool,
  locale: _propTypes2.default.object,
  style: _propTypes2.default.object,
  itemRender: _propTypes2.default.func
}, _class.defaultProps = {
  visible: true,
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectComponentClass: null,
  showQuickJumper: false,
  showLessItems: false,
  showTitle: true,
  onPageSizeChange: noop,
  defaultLocale: _i18n2.default.current,
  style: {},
  simple: false,
  itemRender: defaultItemRender
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.calculatePage = function (p) {
    var pageSize = p;
    if (typeof pageSize === 'undefined') {
      pageSize = _this3.state.pageSize;
    }
    return Math.floor((_this3.props.total - 1) / pageSize) + 1;
  };

  this.isValid = function (page) {
    return isInteger(page) && page >= 1 && page !== _this3.state.current;
  };

  this.changePageSize = function (size) {
    var current = _this3.state.current;
    var newCurrent = _this3.calculatePage(size);
    current = current > newCurrent ? newCurrent : current;
    if (typeof size === 'number') {
      if (!('pageSize' in _this3.props)) {
        _this3.setState({
          pageSize: size
        });
      }
      if (!('current' in _this3.props)) {
        _this3.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this3.props.onPageSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var page = p;
    if (_this3.isValid(page)) {
      if (page > _this3.calculatePage()) {
        page = _this3.calculatePage();
      }
      if (!('current' in _this3.props)) {
        _this3.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this3.state.pageSize;
      _this3.props.onChange(page, pageSize);

      return page;
    }

    return _this3.state.current;
  };

  this.prev = function () {
    if (_this3.hasPrev()) {
      _this3.handleChange(_this3.state.current - 1);
    }
  };

  this.next = function () {
    if (_this3.hasNext()) {
      _this3.handleChange(_this3.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this3.handleChange(_this3.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this3.handleChange(_this3.getJumpNextPage());
  };

  this.jumpToFirst = function () {
    _this3.handleChange(1);
  };

  this.jumpToLast = function () {
    _this3.handleChange(_this3.calculatePage());
  };

  this.isFirst = function () {
    return _this3.state.current === 1;
  };

  this.isLast = function () {
    return _this3.state.current === _this3.calculatePage();
  };

  this.hasPrev = function () {
    return _this3.state.current > 1;
  };

  this.hasNext = function () {
    return _this3.state.current < _this3.calculatePage();
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      return callback.apply(undefined, restParams);
    }
  };
}, _temp);
exports.default = Pagination;
module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

var _en_US = __webpack_require__(237);

var _en_US2 = _interopRequireDefault(_en_US);

var _zh_CN = __webpack_require__(238);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _common.Locale({ en: _en_US2.default, zh: _zh_CN2.default });
module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports) {

exports.__esModule = true;
exports.default = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  page: '',
  go: 'Go',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages',
  totalItems: function totalItems(total) {
    return 'Total ' + total + ' items';
  },
  totalAndSize: function totalAndSize(total) {
    return 'Total ' + total + ' items\uFF0Cper page\uFF1A';
  }
};
module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports) {

exports.__esModule = true;
exports.default = {
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳转至：',
  page: '页',
  go: '跳转',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页',
  totalItems: function totalItems(total) {
    return '\u5171\u6709 ' + total + ' \u6761';
  },
  totalAndSize: function totalAndSize(total) {
    return '\u5171\u6709 ' + total + ' \u6761\uFF0C\u6BCF\u9875\u663E\u793A\uFF1A';
  }
};
module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pager = function Pager(props) {
  var prefixCls = props.rootPrefixCls + '-item';
  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;

  if (props.active) {
    cls = (0, _common.cname)(cls + ' ' + prefixCls + '-active');
  }

  if (props.className) {
    cls = (0, _common.cname)(cls + ' ' + props.className);
  }

  return _react2.default.createElement(
    'li',
    {
      title: props.showTitle ? props.page : null,
      className: cls,
      onClick: props.onClick,
      onKeyPress: props.onKeyPress,
      tabIndex: '0'
    },
    props.itemRender(props.page, 'page')
  );
};

Pager.propTypes = {
  page: _propTypes2.default.number,
  active: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  showTitle: _propTypes2.default.bool,
  rootPrefixCls: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  itemRender: _propTypes2.default.func
};

exports.default = Pager;
module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DirectInput = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(DirectInput, _React$Component);

  function DirectInput(props) {
    (0, _classCallCheck3.default)(this, DirectInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    };

    _this.change = function (e) {
      if (e.target.value === '') {
        return;
      }
      var val = Number(_this.state.goInputText);
      if (isNaN(val)) {
        val = _this.state.current;
      }
      if (e.keyCode === _common.KeyCode.ENTER) {
        _this.setState({
          goInputText: '',
          current: _this.props.quickGo(val)
        });
      }
    };

    _this.go = function (e) {
      if (e.target.value === '') {
        return;
      }
      var val = Number(_this.state.goInputText);
      if (isNaN(val)) {
        val = _this.state.current;
      }
      _this.setState({
        goInputText: '',
        current: _this.props.quickGo(val)
      });
    };

    _this.state = {
      current: props.current,
      goInputText: ''
    };
    return _this;
  }

  DirectInput.prototype.render = function render() {
    var props = this.props;
    var state = this.state;
    var locale = props.locale || {};
    var prefixCls = props.rootPrefixCls + '-options';
    var quickGo = props.quickGo;
    var goInput = null;

    if (!quickGo) {
      return null;
    }

    goInput = _react2.default.createElement(
      'div',
      { className: (0, _common.cname)(prefixCls + '-quick-jumper') },
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)(prefixCls + '-quick-text') },
        locale.jump_to
      ),
      _react2.default.createElement(_components.Input, {
        type: 'number',
        value: state.goInputText,
        onChange: this.handleChange,
        onKeyUp: this.change
      })
    );

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('' + prefixCls) },
      goInput,
      _react2.default.createElement(
        'a',
        { className: (0, _common.cname)(prefixCls + '-go'), onClick: this.go },
        locale.go || 'Go'
      )
    );
  };

  return DirectInput;
}(_react2.default.Component), _class.propTypes = {
  quickGo: _propTypes2.default.func,
  current: _propTypes2.default.number,
  locale: _propTypes2.default.object
}, _temp);
exports.default = DirectInput;
module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import { Select } from "@ali/aps";


var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _Select = __webpack_require__(100);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _Select2.default.Option;

var Options = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Options, _React$Component);

  function Options(props) {
    (0, _classCallCheck3.default)(this, Options);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.buildOptionText = function (value) {
      return value;
    };

    _this.changeSize = function (value) {
      _this.props.changeSize(Number(value.value));
    };

    _this.state = {
      current: props.current,
      goInputText: ''
    };
    return _this;
  }

  Options.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.rootPrefixCls + '-options';
    var changeSize = props.changeSize;
    var buildOptionText = props.buildOptionText || this.buildOptionText;
    var changeSelect = null;

    if (!changeSize) {
      return null;
    }

    if (changeSize) {
      var pageSize = props.pageSize || props.pageSizeOptions[0];
      var options = props.pageSizeOptions.map(function (opt, i) {
        return _react2.default.createElement(
          Option,
          {
            key: i,
            value: opt,
            style: { fontSize: '12px' },
            className: 'opt'
          },
          buildOptionText(opt)
        );
      });

      changeSelect = _react2.default.createElement(
        _Select2.default,
        {
          prefixCls: props.selectPrefixCls,
          showSearch: false,
          className: (0, _common.cname)(prefixCls + '-size-changer'),
          optionLabelProp: 'children',
          dropdownMatchSelectWidth: false,
          value: pageSize.toString(),
          onChange: this.changeSize,
          size: 'small',
          hasArrow: true,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          }
        },
        options
      );
    }

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('' + prefixCls) },
      changeSelect
    );
  };

  return Options;
}(_react2.default.Component), _class.propTypes = {
  changeSize: _propTypes2.default.func,
  selectComponentClass: _propTypes2.default.func,
  current: _propTypes2.default.number,
  pageSizeOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),
  pageSize: _propTypes2.default.number,
  buildOptionText: _propTypes2.default.func,
  locale: _propTypes2.default.object
}, _class.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
}, _temp);
exports.default = Options;
module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

exports.SelectMode = {
  MULTIPLE: 'multiple',
  TAGS: 'tags',
  COMBOBOX: 'combobox',
  NORMAL: 'normal'
};

exports.SelectSize = {
  HERO: 'hero',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(245);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Option, _ComBase);

  function Option() {
    (0, _classCallCheck3.default)(this, Option);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Option.prototype.onClick = function onClick() {
    var _props = this.props,
        disabled = _props.disabled,
        label = _props.label,
        value = _props.value,
        id = _props.id,
        onSelect = _props.onSelect;

    if (!disabled) {
      onSelect({
        label: label || value,
        value: value,
        id: id || 0
      });
    }
  };

  Option.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        selected = _props2.selected,
        disabled = _props2.disabled,
        tagMenu = _props2.tagMenu,
        children = _props2.children,
        size = _props2.size,
        label = _props2.label,
        value = _props2.value,
        showTitle = _props2.showTitle;

    var names = (0, _common.cname)((_cname = {
      option: true
    }, _cname['option-size-' + size] = size, _cname.stateActive = selected, _cname.stateDisabled = disabled, _cname.tagMenu = tagMenu, _cname));
    var title = label || value;
    var optProps = { className: (0, _common.cname)('option-content') };
    if (showTitle) {
      optProps.title = title;
    }
    return _react2.default.createElement(
      'li',
      { onClick: this.onClick.bind(this),
        className: names },
      _react2.default.createElement(
        'div',
        optProps,
        children || title
      )
    );
  };

  return Option;
}(_common.ComBase), _class.defaultProps = {
  disabled: false
}, _class.propTypes = {
  /** 当前值 */
  value: _propTypes2.default.string,
  /** 当前选项是否禁用 */
  disabled: _propTypes2.default.bool
}, _temp);
exports.default = Option;
module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(247);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROGRESS_STATUS = {
  INFO: 'info',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning'
};

var Progress = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Progress, _ComBase);

  function Progress(props) {
    (0, _classCallCheck3.default)(this, Progress);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.getStatusIconNode = function () {
      var status = _this.props.status;


      switch (status) {
        case PROGRESS_STATUS.SUCCESS:
          return _react2.default.createElement(_components.Icon, { type: 'right', className: (0, _common.cname)(['progress-status-icon', 'progress-status-icon-success']) });

        case PROGRESS_STATUS.DANGER:
          return _react2.default.createElement(_components.Icon, { type: 'wrong', className: (0, _common.cname)(['progress-status-icon', 'progress-status-icon-error']) });

        default:
          return null;
      }
    };

    return _this;
  }

  Progress.prototype.render = function render() {
    var _cname, _cname2;

    var _props = this.props,
        percent = _props.percent,
        visible = _props.visible,
        status = _props.status,
        size = _props.size,
        className = _props.className;

    var percentStr = parseFloat(percent) * 100 + '%';
    var statusIconNode = this.getStatusIconNode();
    var names = (0, _common.cname)((_cname = {
      stateHidden: this.props.hasOwnProperty('visible') && !visible,
      widget: true
    }, _cname['size-' + size] = size, _cname[className] = !!className, _cname.progress = true, _cname.stateDisabled = !!this.props.disabled, _cname));
    var outerNames = (0, _common.cname)({
      progressOuter: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true
    });
    var innerNames = (0, _common.cname)({
      progressInner: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true
    });
    var overlayNames = (0, _common.cname)((_cname2 = {
      progressOverlay: true,
      cornerTl: true,
      cornerBl: true
    }, _cname2['scene-' + status] = !!status, _cname2));

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names,
        style: this.props.style }),
      _react2.default.createElement(
        'div',
        { className: outerNames },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('progress-bar') },
          _react2.default.createElement(
            'div',
            { className: innerNames },
            _react2.default.createElement('div', { className: overlayNames,
              style: { width: percentStr } })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)(['progress-text', 'lh-' + size]) },
          statusIconNode || percentStr
        )
      )
    );
  };

  return Progress;
}(_common.ComBase), _class.defaultProps = {
  percent: 0,
  status: PROGRESS_STATUS.INFO,
  size: 'medium'
}, _class.propTypes = {
  /** 进度占比，用浮点数 */
  percent: _propTypes2.default.number,
  /** 当前进度的状态，可选值：`info`, `success`, `danger`, `warning` */
  status: _propTypes2.default.oneOf(['info', 'success', 'danger', 'warning']),
  /** 组件大小 */
  size: _propTypes2.default.oneOf(['hero', 'large', 'medium', 'small'])
}, _temp);
exports.default = Progress;
module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

__webpack_require__(249);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Radio = (_dec = (0, _common.meta)({
  valuePropName: 'checked',
  valuePath: 'target.checked'
}), _dec(_class = (_temp = _class2 = function (_ComBase) {
  (0, _inherits3.default)(Radio, _ComBase);

  function Radio(props) {
    (0, _classCallCheck3.default)(this, Radio);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var checked = void 0;
    if ('checked' in props) {
      checked = props.checked;
    } else {
      checked = props.defaultChecked;
    }
    _this.state = {
      checked: checked
    };
    return _this;
  }

  Radio.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Radio.prototype.stateCheck = function stateCheck(checked, disabled) {
    var radioCls = (0, _common.cname)('radio') + ' ';
    var checkedCls = (0, _common.cname)('radio-checked') + ' ';
    var disabledCls = (0, _common.cname)('radio-disabled') + ' ';
    if (disabled && checked) {
      return radioCls + checkedCls + disabledCls;
    }
    if (disabled) {
      return radioCls + disabledCls;
    }
    if (checked) {
      return radioCls + checkedCls;
    }
    return radioCls;
  };

  Radio.prototype.renderLabel = function renderLabel() {
    var children = this.props.children;

    return children ? _react2.default.createElement(
      'span',
      null,
      children
    ) : null;
  };

  Radio.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        value = _props.value,
        id = _props.id,
        disabled = _props.disabled,
        htmlType = _props.htmlType,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['value', 'id', 'disabled', 'htmlType', 'className']);


    var labelCls = (0, _common.cname)((_cname = {
      aniTransition: true,
      widget: true
    }, _cname['radio-warpper'] = true, _cname), className);
    var radioIptCls = (0, _common.cname)('radio-input');
    var innerCls = (0, _common.cname)('radio-inner');

    var checked = this.state.checked;

    return _react2.default.createElement(
      'label',
      (0, _extends3.default)({ className: labelCls }, otherProps),
      _react2.default.createElement(
        'span',
        { className: this.stateCheck(checked, disabled) },
        _react2.default.createElement('input', { id: id,
          className: radioIptCls,
          type: htmlType,
          disabled: disabled,
          checked: checked,
          onChange: this.onChange,
          value: value }),
        _react2.default.createElement('span', { className: innerCls })
      ),
      this.renderLabel()
    );
  };

  return Radio;
}(_common.ComBase), _class2.defaultProps = {
  type: 'radio',
  htmlType: 'radio',
  defaultChecked: false,
  disabled: false
}, _class2.propTypes = {
  /** radio的类型 */
  type: _propTypes2.default.oneOf(['radio']),
  /** 设置 `input` 标签的原生 `type` 值 */
  htmlType: _propTypes2.default.string,
  /** 是否默认选中 */
  defaultChecked: _propTypes2.default.bool,
  /** 是否选中 */
  checked: _propTypes2.default.bool,
  /** 是否默认可用 */
  disabled: _propTypes2.default.bool,
  /** 选中后 input 的 value 属性 */
  value: _propTypes2.default.string
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onChange = function (event) {
    event.preventDefault();
    event.stopPropagation();
    var checked = event.target.checked;
    if (_this2.state.checked !== checked) {
      if (!('checked' in _this2.props)) {
        _this2.setState({ checked: checked });
      }
      _this2.props.onChange(new _common.EventArgs(_this2, event.target.value, event));
    }
  };
}, _temp)) || _class);
exports.default = Radio;
module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = function (_ComBase) {
  (0, _inherits3.default)(RadioGroup, _ComBase);

  function RadioGroup() {
    (0, _classCallCheck3.default)(this, RadioGroup);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  RadioGroup.prototype.render = function render() {
    return _react2.default.createElement(_components.CheckBoxGroup, (0, _extends3.default)({}, this.props, { control: _components.Radio, single: true }));
  };

  return RadioGroup;
}(_common.ComBase);

exports.default = RadioGroup;
module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(30);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgets = _components2.default;
var Form = _components2.default.Form,
    Input = _components2.default.Input,
    Select = _components2.default.Select;

var SchemaForm = function (_ComBase) {
  (0, _inherits3.default)(SchemaForm, _ComBase);

  function SchemaForm() {
    (0, _classCallCheck3.default)(this, SchemaForm);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  SchemaForm.prototype.renderForm = function renderForm(schema) {
    var _this2 = this;

    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var fieldNames = (0, _keys2.default)(schema.properties);
    return _react2.default.createElement(
      Form,
      (0, _extends3.default)({}, props, {
        className: (0, _common.cname)('schemaForm', props.className) }),
      fieldNames.map(function (fieldName) {
        var fieldItem = schema.properties[fieldName];
        fieldItem.name = fieldName;
        fieldItem.title = fieldItem.title || fieldItem.description;
        return _react2.default.createElement(
          Form.Item,
          { key: fieldName,
            name: fieldName,
            rule: fieldItem.rule,
            label: fieldItem.title },
          _react2.default.createElement(
            Form.Control,
            null,
            _this2.renderItem(fieldItem)
          ),
          _react2.default.createElement(
            Form.Message,
            null,
            fieldItem.description
          )
        );
      })
    );
  };

  SchemaForm.prototype.renderItem = function renderItem(fieldItem) {
    if (fieldItem.type == 'object') {
      return this.renderForm(fieldItem);
    } else if (fieldItem.widget) {
      var Component = widgets[fieldItem.widget];
      return _react2.default.createElement(Component, fieldItem.props);
    } else {
      return fieldItem.enum ? _react2.default.createElement(Select, (0, _extends3.default)({}, fieldItem.props, { dataSource: fieldItem.enum })) : _react2.default.createElement(Input, fieldItem.props);
    }
  };

  SchemaForm.prototype.render = function render() {
    var schema = this.props.schema;

    return this.renderForm(schema, this.props);
  };

  (0, _createClass3.default)(SchemaForm, null, [{
    key: 'widgets',
    get: function get() {
      return widgets;
    }
  }]);
  return SchemaForm;
}(_common.ComBase);

exports.default = SchemaForm;
module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(30);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(253);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = function (_ComBase) {
  (0, _inherits3.default)(Slider, _ComBase);

  function Slider(props) {
    (0, _classCallCheck3.default)(this, Slider);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this2.getValueByWidth = _this2.getValueByWidth.bind(_this2);

    if (!(typeof _this2.getValueByWidth === 'function')) {
      throw new TypeError('Value of "this.getValueByWidth" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this2.getValueByWidth));
    }

    _this2.onMouseMoveEvents = _this2.onMouseMoveEvents.bind(_this2);

    if (!(typeof _this2.onMouseMoveEvents === 'function')) {
      throw new TypeError('Value of "this.onMouseMoveEvents" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this2.onMouseMoveEvents));
    }

    _this2.onMouseUpEvents = _this2.onMouseUpEvents.bind(_this2);

    if (!(typeof _this2.onMouseUpEvents === 'function')) {
      throw new TypeError('Value of "this.onMouseUpEvents" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this2.onMouseUpEvents));
    }

    _this2.changeValue = _this2.changeValue.bind(_this2);

    if (!(typeof _this2.changeValue === 'function')) {
      throw new TypeError('Value of "this.changeValue" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this2.changeValue));
    }

    _this2.state = {
      unmove: true,
      value: 0,
      maskWidth: {},
      barLeft: {},
      selectIndex: 0
    };
    return _this2;
  }

  // 初始时，获取默认值显示


  Slider.prototype.componentDidMount = function componentDidMount() {
    var value = this.props.value;

    if (typeof value !== 'undefined') {
      var _value = this.returnValue(parseInt(value));
      var _w = this.getWidthByValue(_value);
      var maskWidth = { width: _w + 'px' };
      var barLeft = { left: _w + 'px' };
      var unmove = true;
      this.setState({
        maskWidth: maskWidth,
        barLeft: barLeft,
        unmove: unmove
      });
    }
  };

  // 在外修改默认值改变数值滑动


  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.state.value) {
      this.changeValue(value);
    }
  };

  Slider.prototype.changeValue = function changeValue(value) {
    var onChange = this.props.onChange;

    value = this.returnValue(parseInt(value));
    var _w = this.getWidthByValue(value);
    var maskWidth = { width: _w + 'px' };
    var barLeft = { left: _w + 'px' };
    var unmove = true;
    this.setState({
      maskWidth: maskWidth,
      barLeft: barLeft,
      unmove: unmove
    });
    onChange(value);
  };

  Slider.prototype.getSliderWidth = function getSliderWidth(props) {
    var type = props.type;

    var sliderWidth = 0;
    if (type === 'duration') {
      sliderWidth = 528;
    } else {
      sliderWidth = 412;
    }
    return sliderWidth;
  };

  Slider.prototype.getStepOption = function getStepOption(props) {
    var step = props.step,
        max = props.max,
        unit = props.unit;

    var options = [{ step: step, min: 0, max: Math.floor(max / 4), css: (0, _common.cname)('slider-l2') }, {
      step: step,
      min: Math.floor(max / 4),
      max: Math.floor(max / 2),
      css: (0, _common.cname)('slider-l1')
    }, {
      step: step,
      min: Math.floor(max / 2),
      max: max,
      css: (0, _common.cname)('slider-l1')
    }];
    options.map(function (item) {
      item.textLable = unit ? item.max + unit : item.max;
    });
    return options;
  };

  Slider.prototype.getWidthByCss = function getWidthByCss(css) {
    if (css == (0, _common.cname)('slider-l2')) {
      return 206 - 8;
    } else if (css == (0, _common.cname)('slider-l1')) {
      return 103;
    } else if (css == (0, _common.cname)('slider-mm')) {
      return 40;
    } else if (css == (0, _common.cname)('slider-yy')) {
      return 56;
    } else {
      return 0;
    }
  };

  //通过所选的宽度来获取值


  Slider.prototype.getValueByWidth = function getValueByWidth(w) {
    var _this3 = this;

    var max = this.props.max;

    var _stepOption = this._stepOption;
    var sliderWidth = this.getSliderWidth(this.props);

    if (w == 0) {
      return 0;
    }
    if (w == 1) {
      return max;
    }
    var _wd = w * sliderWidth; //选中的长度
    var _start = 0;
    var _end = 0;
    var keepGoing = true;
    var value = 0;

    _stepOption.map(function (o, i) {
      if (keepGoing) {
        _end = _start + _this3.getWidthByCss(o.css);
        if (_wd > _start && _wd <= _end) {
          value = o.min + (o.max - o.min) * (_wd - _start) / _this3.getWidthByCss(o.css);
          _this3.setState({
            selectIndex: i
          });
          keepGoing = false;
        }
        _start = _end;
        if (_wd > _end && i == _stepOption.length - 1) {
          value = max;
          keepGoing = false;
        }
      }
    });
    value = Math.ceil(value);
    value = this.returnValue(parseInt(value));
    return value;
  };

  Slider.prototype.getWidthByValue = function getWidthByValue(v) {
    var _this4 = this;

    var _stepOption = this._stepOption;
    var sliderWidth = this.getSliderWidth(this.props);

    if (v == 0) {
      return -9;
    }
    if (!v) {
      return sliderWidth - 10;
    }
    var keepGoing = true;
    var _width = 0;
    var width = 0;
    _stepOption.map(function (o, i) {
      if (keepGoing) {
        if (v > o.min && v <= o.max) {
          width = (v - o.min) / (o.max - o.min) * _this4.getWidthByCss(o.css) + _width;
          _this4.setState({
            selectIndex: i
          });
          keepGoing = false;
        }
        _width += _this4.getWidthByCss(o.css);
      }
    });
    return width > sliderWidth ? sliderWidth : width;
  };

  Slider.prototype.onMouseMoveEvents = function onMouseMoveEvents(e) {
    var _props = this.props,
        min = _props.min,
        max = _props.max;

    var sliderWidth = this.getSliderWidth(this.props);
    var _this = this;
    _this.setState({
      unmove: false
    });

    var _w = (e.pageX - 8 - this.sliderDom.offsetLeft) / sliderWidth;
    _w = _w > 0.99999 ? 1 : _w;
    _w = _w < 0.00001 ? 0 : _w;

    var _value = _this.getValueByWidth(_w);
    _value = this.returnValue(parseInt(_value));
    if (_value < min) {
      _value = min;
    }
    if (_value > max) {
      _value = max;
    }

    if (!!_value || _value == 0) {
      _this.setState({
        value: _value
      });
    }
    var maskWidth = { width: _w * sliderWidth + 'px' };
    var barLeft = { left: _w ? _w * sliderWidth : -9 + 'px' };
    _this.setState({
      maskWidth: maskWidth,
      barLeft: barLeft
    });
  };

  Slider.prototype.onMouseUpEvents = function onMouseUpEvents() {
    document.body.removeEventListener('mousemove', this.onMouseMoveEvents);
    document.body.removeEventListener('mouseup', this.onMouseUpEvents);
    this.changeValue(this.state.value);
  };

  Slider.prototype.returnValue = function returnValue(value) {
    var _props2 = this.props,
        min = _props2.min,
        max = _props2.max;

    this._stepOption.map(function (item) {
      if (item.step !== 1 && value <= item.max && value > item.min && value % item.step) {
        value = item.step - value % item.step + value;
      }
    });
    if (value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }
    return value;
  };

  Slider.prototype.down = function down(e) {
    var sliderWidth = this.getSliderWidth(this.props);

    var _width = (e.pageX - this.sliderDom.offsetLeft - 16) * 100 / sliderWidth;
    _width = _width >= 100 ? 100 : _width;
    var value = this.getValueByWidth(_width / 100);
    var maskWidth = { width: +_width + '%' };
    var barLeft = { left: _width + '%' };
    this.setState({
      value: value,
      maskWidth: maskWidth,
      barLeft: barLeft
    });
    this.sliderDomEvent = e;
    document.body.addEventListener('mousemove', this.onMouseMoveEvents);
    document.body.addEventListener('mouseup', this.onMouseUpEvents);
    e.preventDefault();
  };

  Slider.prototype.render = function render() {
    var _this5 = this;

    var _state = this.state;
    var _stepOption = this._stepOption = this.getStepOption(this.props);
    var _props3 = this.props,
        className = _props3.className,
        style = _props3.style;

    var selectIndex = _state.selectIndex;
    var sliderContainerClass = (0, _common.cname)({
      'slider-container': true,
      'slider-transition': _state.unmove
    });
    var sliderDragClass = (0, _common.cname)({
      'slider-drag': true,
      'slider-transition': _state.unmove
    });
    var apsSliderClass = (0, _common.cname)({
      slider: true
    }, className);
    return _react2.default.createElement(
      'div',
      {
        className: apsSliderClass,
        style: style,
        onMouseDown: this.down.bind(this),
        onKeyDown: this.down.bind(this),
        ref: function ref(refDom) {
          _this5.sliderDom = refDom;
        }
      },
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)('slider-range') },
        _stepOption.map(function (item, index) {
          var _cname;

          var boxLastClass = (0, _common.cname)({
            'slider-block-box': true,
            'aslider-block-box-last': index === _stepOption.length - 1,
            'select-action': index === selectIndex
          });
          var sliderBlockClass = (0, _common.cname)((_cname = {
            'slider-block': true
          }, _cname[item.css] = true, _cname));
          return _react2.default.createElement(
            'span',
            { className: sliderBlockClass, key: index },
            _react2.default.createElement(
              'span',
              { className: boxLastClass },
              _react2.default.createElement(
                'span',
                { className: (0, _common.cname)('slider-txt') },
                item.textLable
              )
            )
          );
        }),
        _react2.default.createElement(
          'span',
          { className: sliderContainerClass, style: _state.maskWidth },
          _react2.default.createElement(
            'span',
            { className: (0, _common.cname)('slider-current') },
            _stepOption.map(function (item, index) {
              var _cname2;

              var sliderUnitClass = (0, _common.cname)((_cname2 = {
                'slider-unit': true
              }, _cname2[item.css] = true, _cname2));
              var unitBoxClass = (0, _common.cname)({
                'slider-unit-box': true,
                'slider-unit-box-last': index === _stepOption.length - 1,
                'select-action': index === selectIndex
              });
              return _react2.default.createElement(
                'span',
                { className: sliderUnitClass, key: index },
                _react2.default.createElement(
                  'span',
                  { className: unitBoxClass },
                  _react2.default.createElement(
                    'span',
                    { className: (0, _common.cname)('slider-txt') },
                    item.textLable
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: sliderDragClass, style: _state.barLeft },
          _react2.default.createElement('i', null),
          _react2.default.createElement('i', null),
          _react2.default.createElement(
            'div',
            { style: { position: 'relative' } },
            _react2.default.createElement(
              'div',
              {
                className: (0, _common.cname)('tip-gray'),
                style: { display: _state.unmove ? 'none' : 'block' }
              },
              _react2.default.createElement(
                'span',
                null,
                _state.value
              ),
              _react2.default.createElement('span', { className: (0, _common.cname)('tip-arrow') })
            )
          )
        )
      )
    );
  };

  return Slider;
}(_common.ComBase);

exports.default = Slider;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

__webpack_require__(255);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sort = function (_ComBase) {
  (0, _inherits3.default)(Sort, _ComBase);

  function Sort() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Sort);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {}, _this.toggle = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          _this$props$defaultVa = _this$props.defaultValue,
          defaultValue = _this$props$defaultVa === undefined ? 'none' : _this$props$defaultVa,
          _this$props$value = _this$props.value,
          value = _this$props$value === undefined ? _this.state.value || defaultValue : _this$props$value;

      if (disabled) return;
      value = value == 'desc' ? 'asc' : 'desc';
      _this.setState({ value: value });
      if (!_common.utils.isFunction(onChange)) return;
      onChange(new _common.EventArgs(_this, value));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Sort.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        visible = _props.visible,
        _props$defaultValue = _props.defaultValue,
        defaultValue = _props$defaultValue === undefined ? 'none' : _props$defaultValue,
        _props$value = _props.value,
        value = _props$value === undefined ? this.state.value || defaultValue : _props$value;

    var classNames = (0, _common.cname)((_cname = {
      widget: true,
      aniTransition: true,
      sort: true
    }, _cname[value] = true, _cname.disabled = disabled, _cname.stateHidden = visible === false, _cname.stateVisible = visible !== false, _cname), className);
    return _react2.default.createElement(
      'span',
      { className: classNames, onClick: this.toggle },
      _react2.default.createElement(_components.Icon, { className: (0, _common.cname)('sortBtn sortBtnUp'), type: 'shangjiantou' }),
      _react2.default.createElement(_components.Icon, { className: (0, _common.cname)('sortBtn sortBtnDown'), type: 'xiajiantou' })
    );
  };

  return Sort;
}(_common.ComBase);

exports.default = Sort;
module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _Steps = __webpack_require__(257);

var _Steps2 = _interopRequireDefault(_Steps);

var _Step = __webpack_require__(258);

var _Step2 = _interopRequireDefault(_Step);

__webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Steps2.default.Step = _Step2.default;
exports.default = _Steps2.default;
module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__(95);

var _lodash2 = _interopRequireDefault(_lodash);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Steps = function (_ComBase) {
  (0, _inherits3.default)(Steps, _ComBase);

  function Steps(props) {
    (0, _classCallCheck3.default)(this, Steps);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.calcStepOffsetWidth = function () {
      var domNode = _reactDom2.default.findDOMNode(_this);
      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }
        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
          // Reduce shake bug
          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
            return;
          }
          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
        });
      }
    };

    _this.state = {
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = (0, _lodash2.default)(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.calcTimeout) {
      clearTimeout(this.calcTimeout);
    }
    if (this.calcStepOffsetWidth.cancel) {
      this.calcStepOffsetWidth.cancel();
    }
  };

  Steps.prototype.render = function render() {
    var _cname,
        _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        className = props.className,
        children = props.children,
        direction = props.direction,
        labelPlacement = props.labelPlacement,
        status = props.status,
        size = props.size,
        current = props.current,
        type = props.type,
        restProps = (0, _objectWithoutProperties3.default)(props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'status', 'size', 'current', 'type']);

    var childLength = children.length;
    var lastIndex = childLength - 1;
    var reLayouted = this.state.lastStepOffsetWidth > 0;
    // const adjustedlabelPlacement = type == 'cicle' ? labelPlacement : 'vertical';  //箭头+点状必须为水平
    // 点状标签必须在下方
    var adjustedlabelPlacement = type == 'dot' ? 'vertical' : labelPlacement;
    var classString = (0, _common.cname)((_cname = {}, _cname[prefixCls] = true, _cname[prefixCls + '-' + size] = size, _cname[prefixCls + '-' + direction] = true, _cname[prefixCls + '-label-' + adjustedlabelPlacement] = direction === 'horizontal', _cname[prefixCls + '-hidden'] = !reLayouted, _cname[prefixCls + '-dot'] = type == 'dot', _cname[prefixCls + '-arrow'] = type == 'arrow', _cname[className] = className, _cname));

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({ className: classString, style: style }, restProps),
      _react2.default.Children.map(children, function (ele, idx) {
        var itemWidth = type == 'arrow' ? null : direction === 'vertical' || idx === lastIndex || !reLayouted ? null : 100 / lastIndex + '%';
        var adjustMarginRight = type == 'arrow' ? null : direction === 'vertical' || idx === lastIndex ? null : -Math.round(_this2.state.lastStepOffsetWidth / lastIndex + 1);
        var np = {
          stepNumber: (idx + 1).toString(),
          childLength: childLength,
          index: idx,
          itemWidth: itemWidth,
          adjustMarginRight: adjustMarginRight,
          prefixCls: prefixCls,
          wrapperStyle: style,
          type: type
        };
        // fix tail color
        if (status === 'error' && idx === current - 1) {
          np.className = props.prefixCls + '-next-error';
        }
        if (!ele.props.status) {
          if (idx === current) {
            np.status = status;
          } else if (idx < current) {
            np.status = 'finish';
          } else {
            np.status = 'wait';
          }
        }
        return _react2.default.cloneElement(ele, np);
      }, this)
    );
  };

  return Steps;
}(_common.ComBase);

exports.default = Steps;


Steps.propTypes = {
  //prefixCls: PropTypes.string,

  /** 方向 */
  direction: _propTypes2.default.oneOf(['horizontal', 'vertical']),

  /** 标题位置 */
  labelPlacement: _propTypes2.default.oneOf(['vertical']),

  /** 当前步骤的状态 */
  status: _propTypes2.default.oneOf(['error', 'process', 'finish', 'wait']),

  /** 尺寸 */
  size: _propTypes2.default.string,

  /** 类型 */
  type: _propTypes2.default.oneOf(['dot', 'circle', 'arrow'])
};

Steps.defaultProps = {
  prefixCls: 'aps-steps',
  direction: 'horizontal',
  labelPlacement: 'vertical',
  current: 0,
  status: 'process',
  size: '',
  type: 'circle'
};
module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(7);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isString(str) {
  return typeof str === 'string';
}

var Step = function (_ComBase) {
  (0, _inherits3.default)(Step, _ComBase);

  function Step() {
    (0, _classCallCheck3.default)(this, Step);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Step.prototype.render = function render() {
    var _cname, _cname2;

    var _props = this.props,
        className = _props.className,
        prefixCls = _props.prefixCls,
        style = _props.style,
        itemWidth = _props.itemWidth,
        _props$status = _props.status,
        status = _props$status === undefined ? 'wait' : _props$status,
        icon = _props.icon,
        _props$wrapperStyle = _props.wrapperStyle,
        wrapperStyle = _props$wrapperStyle === undefined ? {} : _props$wrapperStyle,
        adjustMarginRight = _props.adjustMarginRight,
        stepNumber = _props.stepNumber,
        childLength = _props.childLength,
        index = _props.index,
        description = _props.description,
        title = _props.title,
        type = _props.type,
        restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'childLength', 'index', 'description', 'title', 'type']);

    var iconClassName = (0, _common.cname)((_cname = {}, _cname[prefixCls + '-icon'] = true, _cname['icon'] = true, _cname['icon-' + icon] = icon && isString(icon), _cname['icon-check'] = !icon && status === 'finish', _cname['icon-cross'] = !icon && status === 'error', _cname));

    var iconNode = void 0;
    var iconDot = _react2.default.createElement('span', { className: prefixCls + '-icon-dot' });
    // `progressDot` enjoy the highest priority
    if (type == 'dot') {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        iconDot
      );
    } else if (type == 'arrow') {
      //do nothing
    } else if (type === 'number') {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        stepNumber
      );
    } else if (icon && !isString(icon)) {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        icon
      );
    } else if (icon || status === 'finish') {
      iconNode = _react2.default.createElement(
        'span',
        { className: iconClassName },
        _react2.default.createElement(_components.Icon, { type: 'right1' })
      );
    } else if (icon || status === 'error') {
      iconNode = _react2.default.createElement(
        'span',
        { className: iconClassName },
        _react2.default.createElement(_components.Icon, { type: 'close' })
      );
    } else {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        stepNumber
      );
    }
    var classString = (0, _common.cname)((_cname2 = {}, _cname2[prefixCls + '-item'] = true, _cname2[prefixCls + '-item-first'] = index == 0, _cname2[prefixCls + '-item-last'] = index == childLength - 1, _cname2[prefixCls + '-status-' + status] = true, _cname2[prefixCls + '-custom'] = icon, _cname2[className] = !!className, _cname2));
    if (type == 'arrow') return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)(prefixCls + '-arrow-box'), style: { width: 100 / childLength + '%' } },
      _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, restProps, {
          className: classString,
          style: (0, _extends3.default)({ width: itemWidth, marginRight: adjustMarginRight }, style)
        }),
        _react2.default.createElement(
          'div',
          { className: 'title' },
          title
        )
      )
    );
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, restProps, {
        className: classString,
        style: (0, _extends3.default)({ width: itemWidth, marginRight: adjustMarginRight }, style)
      }),
      _react2.default.createElement(
        'div',
        {
          className: prefixCls + '-tail',
          style: { paddingRight: -adjustMarginRight }
        },
        _react2.default.createElement('i', null)
      ),
      _react2.default.createElement(
        'div',
        { className: prefixCls + '-step' },
        _react2.default.createElement(
          'div',
          {
            className: prefixCls + '-head',
            style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
          },
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-head-inner' },
            iconNode
          )
        ),
        _react2.default.createElement(
          'div',
          { className: prefixCls + '-main' },
          _react2.default.createElement(
            'div',
            {
              className: prefixCls + '-title',
              style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
            },
            title
          ),
          description ? _react2.default.createElement(
            'div',
            { className: prefixCls + '-description' },
            description
          ) : ''
        )
      )
    );
  };

  return Step;
}(_common.ComBase);

exports.default = Step;


Step.propTypes = {
  /** 类名 */
  className: _propTypes2.default.string,
  //prefixCls: PropTypes.string,
  /** 样式 */
  style: _propTypes2.default.object,
  /** 包裹样式 */
  wrapperStyle: _propTypes2.default.object,
  /** 宽度 */
  itemWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /** 状态 */
  status: _propTypes2.default.string,
  /** ICON */
  icon: _propTypes2.default.node,
  /** 右侧Margin */
  adjustMarginRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /** 步骤数 */
  stepNumber: _propTypes2.default.string,
  /** 描述 */
  description: _propTypes2.default.any,
  /** 标题 */
  title: _propTypes2.default.any,
  /** 类型 */
  type: _propTypes2.default.string
};
module.exports = exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

__webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switch = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Switch, _ComBase);

  function Switch() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Switch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.isChecked = false, _this.isFirstMount = true, _this.state = {
      sign: false
    }, _this.changeCheck = function () {
      var isChecked = !_this.isChecked;
      var sign = _this.state.sign;
      var _this$props = _this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      var isAutoSwitch = checked === undefined || false;

      if (disabled) {
        return;
      }

      if (isAutoSwitch) {
        _this.isChecked = isChecked;
        _this.setState({
          sign: !sign
        });
      }
      var eventArgs = new _common.EventArgs(_this, isChecked);

      onChange(eventArgs);
    }, _this.updateCheckedStatus = function () {
      /**
       * value checked
       * 首先以外部的checked为准
       * 其次以外部的defaultChecked为准
       * 最后以组件默认的isChecked为准
       * */
      var isChecked = _this.isChecked;

      var _this$props2 = _this.props,
          defaultChecked = _this$props2.defaultChecked,
          _this$props2$checked = _this$props2.checked,
          checked = _this$props2$checked === undefined ? _this.isFirstMount ? defaultChecked : isChecked : _this$props2$checked;


      _this.isChecked = checked;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Switch.prototype.componentDidMount = function componentDidMount() {
    this.isFirstMount = false;
  };

  Switch.prototype.render = function render() {
    this.updateCheckedStatus();

    var checked = this.isChecked;
    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        size = _props.size,
        width = _props.width,
        checkedChildren = _props.checkedChildren,
        unCheckedChildren = _props.unCheckedChildren;


    var names = (0, _common.cname)({
      switch: true
    }, className);

    var names_con = 'switch-' + size;
    var name_check = checked && 'switch-checked' || '';
    var name_disabled = disabled && 'switch-disabled' || '';

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names, onClick: this.changeCheck.bind(this) }),
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)(names_con + ' ' + name_check + ' ' + name_disabled), style: width ? { width: width } : {} },
        checked && _react2.default.createElement(
          'span',
          { className: '_cOk' },
          checkedChildren
        ),
        !checked && _react2.default.createElement(
          'span',
          { className: '_cNo' },
          unCheckedChildren
        )
      )
    );
  };

  return Switch;
}(_common.ComBase), _class.propTypes = {
  /**
  * 外部定义switch的状态
  */
  checked: _propTypes2.default.bool,
  /**
  * switch的默认状态
  */
  defaultChecked: _propTypes2.default.bool,
  /**
  * 定义switch是否禁止操作
  */
  disabled: _propTypes2.default.bool,
  /**
  * disable为false时switch点击改变时的触发事件
  */
  onChange: _propTypes2.default.func,
  /**
  * switch的大小
  */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /**
  * switch的自定义宽度,例如 '16px'
  */
  width: _propTypes2.default.string,
  /**
  * 用于用户个性定义switch为开时的状态说明
  */
  checkedChildren: _propTypes2.default.node,
  /**
  * 用于用户个性定义switch为关时的状态说明
  */
  unCheckedChildren: _propTypes2.default.node
}, _class.defaultProps = {
  disabled: false,
  size: 'medium',
  defaultChecked: false,
  onChange: function onChange() {},
  checkedChildren: '',
  unCheckedChildren: ''
}, _temp2);
exports.default = Switch;
module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends3 = __webpack_require__(5);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cname = __webpack_require__(23);

var _cname2 = _interopRequireDefault(_cname);

var _ComBase3 = __webpack_require__(29);

var _ComBase4 = _interopRequireDefault(_ComBase3);

var _transportProps = __webpack_require__(65);

var _transportProps2 = _interopRequireDefault(_transportProps);

var _utils = __webpack_require__(24);

var _utils2 = _interopRequireDefault(_utils);

var _EventArgs = __webpack_require__(87);

var _EventArgs2 = _interopRequireDefault(_EventArgs);

var _Column = __webpack_require__(263);

var _Column2 = _interopRequireDefault(_Column);

var _prev = __webpack_require__(264);

var _prev2 = _interopRequireDefault(_prev);

__webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Empty = function (_ComBase) {
  (0, _inherits3.default)(Empty, _ComBase);

  function Empty() {
    (0, _classCallCheck3.default)(this, Empty);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Empty.prototype.render = function render() {
    var children = this.props.children;

    return _react2.default.createElement(
      'div',
      null,
      children
    );
  };

  return Empty;
}(_ComBase4.default);

var Table = (_temp2 = _class = function (_ComBase2) {
  (0, _inherits3.default)(Table, _ComBase2);

  function Table() {
    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ComBase2.call.apply(_ComBase2, [this].concat(args))), _this2), _this2.state = { expandStates: null }, _this2.onRowClick = function (columns, row, index, rowKey) {
      var onRowClick = _this2.props.onRowClick;

      if (!onRowClick) return;
      var toggleRowExpand = _this2.toggleRowExpand.bind(_this2, rowKey);
      var rowExpand = _this2.isRowExpand(rowKey);
      var detail = {
        columns: columns, row: row, index: index, rowKey: rowKey, toggleRowExpand: toggleRowExpand, rowExpand: rowExpand
      };
      onRowClick(new _EventArgs2.default(_this2, detail, detail));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  /**
   * @deprecated
   */


  Table.prototype.findColumns = function findColumns() {
    var elements = this.findChildren(_Column2.default);
    return elements.map(function (element) {
      return element.props;
    });
  };

  Table.prototype.renderHeadCell = function renderHeadCell(column, index) {
    var content = _utils2.default.isNull(column.head) ? column.field : column.head;
    return _react2.default.createElement(
      'th',
      { key: column.field + index,
        className: (0, _cname2.default)(column.align),
        style: column.width ? { width: column.width } : null,
        'data-field': column.field || index },
      _utils2.default.isFunction(content) ? content(column) : content
    );
  };

  Table.prototype.renderHead = function renderHead(columns) {
    var _this3 = this;

    return _react2.default.createElement(
      'thead',
      null,
      _react2.default.createElement(
        'tr',
        null,
        columns.map(function (column, index) {
          return _this3.renderHeadCell(column, index);
        })
      )
    );
  };

  Table.prototype.renderRowCell = function renderRowCell(column, row, index, rowKey) {
    var toggleRowExpand = this.toggleRowExpand.bind(this, rowKey);
    var rowExpand = this.isRowExpand(rowKey);
    var value = row[column.field || ''];
    var content = column.cell || (_utils2.default.isNull(value) ? '' : value);
    var cellOpts = {
      column: column, row: row, value: value, index: index, rowKey: rowKey, toggleRowExpand: toggleRowExpand, rowExpand: rowExpand
    };
    var result = _utils2.default.isFunction(content) ? content(cellOpts) : content;
    var cell = this.props.cell;

    return _react2.default.createElement(
      'td',
      { key: column.field + index,
        className: (0, _cname2.default)(column.align),
        style: column.width ? { width: column.width } : null,
        'data-field': column.field || index },
      _utils2.default.isFunction(cell) ? cell((0, _extends4.default)({}, cellOpts, { result: result })) : result
    );
  };

  Table.prototype.renderRowExpand = function renderRowExpand(columns, row, index, rowKey) {
    var renderRowExpand = this.props.renderRowExpand;

    var rowExpand = this.isRowExpand(rowKey);
    if (!renderRowExpand || !rowExpand) return;
    var toggleRowExpand = this.toggleRowExpand.bind(this, rowKey);
    var expandContent = renderRowExpand({
      columns: columns, row: row, index: index, rowKey: rowKey, toggleRowExpand: toggleRowExpand, rowExpand: rowExpand
    });
    if (!expandContent) return;
    return _react2.default.createElement(
      'tr',
      { key: rowKey + '-expand', className: (0, _cname2.default)('expandRow') },
      _react2.default.createElement(
        'td',
        { colSpan: columns.length },
        expandContent
      )
    );
  };

  Table.prototype.isRowExpand = function isRowExpand(rowKey) {
    var _props = this.props,
        defaultExpandStates = _props.defaultExpandStates,
        _props$expandStates = _props.expandStates,
        expandStates = _props$expandStates === undefined ? this.state.expandStates || defaultExpandStates || {} : _props$expandStates;

    return !!expandStates[rowKey];
  };

  Table.prototype.toggleRowExpand = function toggleRowExpand(rowKey) {
    var _extends2;

    var _props2 = this.props,
        defaultExpandStates = _props2.defaultExpandStates,
        _props2$expandStates = _props2.expandStates,
        expandStates = _props2$expandStates === undefined ? this.state.expandStates || defaultExpandStates || {} : _props2$expandStates,
        onRowExpandChange = _props2.onRowExpandChange;

    var nextExpandStates = (0, _extends4.default)({}, expandStates, (_extends2 = {}, _extends2[rowKey] = !expandStates[rowKey], _extends2));
    this.setState({ expandStates: nextExpandStates });
    var event = new _EventArgs2.default(this, nextExpandStates);
    if (onRowExpandChange) onRowExpandChange(event);
  };

  Table.prototype.innerRenderRow = function innerRenderRow(opts) {
    var _this4 = this;

    var renderRow = this.props.renderRow;

    var customRow = void 0;
    if (renderRow) customRow = renderRow.call(this, opts, this);
    var columns = opts.columns,
        row = opts.row,
        index = opts.index,
        rowKey = opts.rowKey,
        className = opts.className;

    return customRow || _react2.default.createElement(
      'tr',
      { key: rowKey,
        'data-row': index, className: className,
        onClick: function onClick() {
          return _this4.onRowClick(columns, row, index, rowKey);
        } },
      columns.map(function (column, index) {
        return _this4.renderRowCell(column, row, index, rowKey);
      })
    );
  };

  Table.prototype.renderRow = function renderRow(columns, row, index) {
    var _props3 = this.props,
        _props3$keyField = _props3.keyField,
        keyField = _props3$keyField === undefined ? '' : _props3$keyField,
        _props3$autoRowKey = _props3.autoRowKey,
        autoRowKey = _props3$autoRowKey === undefined ? false : _props3$autoRowKey;
    //直接用 index 作为 key 在表格数据动增删时会显示错误
    //通过 keyField 可即不出问题，也能够重用 dom

    var rowKey = String(row[keyField] || (autoRowKey ? Table.uuid++ : index));
    var even = index % 2 === 0,
        odd = !even,
        stateExpand = this.isRowExpand(rowKey);
    var className = (0, _cname2.default)({ row: true, even: even, odd: odd, stateExpand: stateExpand });
    var rows = [this.innerRenderRow({ columns: columns, row: row, index: index, rowKey: rowKey, className: className })];
    var expandRow = this.renderRowExpand(columns, row, index, rowKey);
    if (expandRow) rows.push(expandRow);
    return rows;
  };

  Table.prototype.renderEmpty = function renderEmpty(columns) {
    var _props$empty = this.props.empty,
        empty = _props$empty === undefined ? this.findChildren(Empty) : _props$empty;

    return empty && empty.length > 0 ? _react2.default.createElement(
      'tr',
      null,
      _react2.default.createElement(
        'td',
        { className: (0, _cname2.default)('empty'), colSpan: columns.length },
        empty
      )
    ) : null;
  };

  Table.prototype.renderBody = function renderBody(columns, data) {
    var _this5 = this;

    var rows = data && data.length > 0 ? data.map(function (row, index) {
      return _this5.renderRow(columns, row, index);
    }) : this.renderEmpty(columns);
    return _react2.default.createElement(
      'tbody',
      null,
      rows
    );
  };

  Table.prototype.render = function render() {
    var _props4 = this.props,
        className = _props4.className,
        _props4$columns = _props4.columns,
        columns = _props4$columns === undefined ? this.findColumns() : _props4$columns,
        data = _props4.data,
        others = (0, _objectWithoutProperties3.default)(_props4, ['className', 'columns', 'data']);

    var classNames = (0, _cname2.default)(['table', 'widget', 'aniTransition'], className);
    return _react2.default.createElement(
      'table',
      (0, _extends4.default)({}, (0, _transportProps2.default)(others), { className: classNames }),
      this.renderHead(columns),
      this.renderBody(columns, data)
    );
  };

  return Table;
}(_ComBase4.default), _class.propTypes = {
  /** 表格数据 */
  data: _propTypes2.default.array,
  /** 行展开渲染函数 */
  renderRowExpand: _propTypes2.default.func,
  /**
   * 自定义行渲染 `renderRow(opts)`
   * 当有返回值时使用返回内容直接渲染，
   * 也可只更改 `opts` 中的渲染信息，比如 `opts.className+='xxx'`
   * 在行的 `className` 上追加了一个 `xxx`
   */
  renderRow: _propTypes2.default.func,
  /** 行展开状态（受控属性） */
  expandStates: _propTypes2.default.object,
  /** 默认行展开状态（非受控属性） */
  defaultExpandStates: _propTypes2.default.object,
  /** 行展开状态改事件 */
  onRowExpandChange: _propTypes2.default.func,
  /** 行单击事件 */
  onRowClick: _propTypes2.default.func,
  /** 是否自动生成唯一的行 key */
  autoRowKey: _propTypes2.default.bool,
  /** 主键字段 */
  keyField: _propTypes2.default.string
}, _class.uuid = 0, _class.Column = _Column2.default, _class.Empty = Empty, _class.Prev = _prev2.default, _temp2);
exports.default = Table;
module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Column, _ComBase);

  function Column() {
    (0, _classCallCheck3.default)(this, Column);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Column.prototype.render = function render() {};

  return Column;
}(_common.ComBase), _class.propTypes = {
  /** 字段名 */
  field: _propTypes2.default.string.isRequired,
  /** 列头 */
  head: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  /** 列单元格自定义渲染函数 */
  cell: _propTypes2.default.func,
  /** 列对齐方法 */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  /** 列宽 */
  width: _propTypes2.default.number
}, _temp);
exports.default = Column;
module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _entries = __webpack_require__(265);

var _entries2 = _interopRequireDefault(_entries);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp3;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Column, _ComBase);

  function Column() {
    (0, _classCallCheck3.default)(this, Column);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  return Column;
}(_common.ComBase), _class.propTypes = {
  field: _propTypes2.default.string.isRequired,
  head: _propTypes2.default.string.isRequired,
  align: _propTypes2.default.oneOf(['left', 'center', 'right'])
}, _temp);

var Empty = function (_ComBase2) {
  (0, _inherits3.default)(Empty, _ComBase2);

  function Empty() {
    (0, _classCallCheck3.default)(this, Empty);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase2.apply(this, arguments));
  }

  Empty.prototype.render = function render() {
    var children = this.props.children;

    return _react2.default.createElement(
      'div',
      null,
      children
    );
  };

  return Empty;
}(_common.ComBase);

var Table = (_temp3 = _class2 = function (_ComBase3) {
  (0, _inherits3.default)(Table, _ComBase3);

  function Table() {
    var _temp2, _this3, _ret;

    (0, _classCallCheck3.default)(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this3 = (0, _possibleConstructorReturn3.default)(this, _ComBase3.call.apply(_ComBase3, [this].concat(args))), _this3), _this3.handleRowClick = function (row, index) {
      var onRowClick = _this3.props.onRowClick;

      onRowClick && onRowClick(row, index, new _common.EventArgs(_this3));
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  Table.prototype.findColumns = function findColumns() {
    var elements = this.findChildren(Column);
    return elements.map(function (element) {
      return element.props;
    });
  };

  Table.prototype.renderHeadCell = function renderHeadCell(column, index) {
    var content = _common.utils.isNull(column.head) ? column.field : column.head;
    return _react2.default.createElement(
      'th',
      { key: column.field + index,
        className: (0, _common.cname)(column.align),
        style: column.width ? { width: column.width } : null,
        'data-field': column.field || index },
      _common.utils.isFunction(content) ? content(column) : content
    );
  };

  Table.prototype.renderHead = function renderHead(columns) {
    var _this4 = this;

    return _react2.default.createElement(
      'thead',
      null,
      _react2.default.createElement(
        'tr',
        null,
        columns.map(function (column, index) {
          return _this4.renderHeadCell(column, index);
        })
      )
    );
  };

  Table.prototype.renderRowCell = function renderRowCell(column, row, index) {
    var value = row[column.field || ''];
    var content = column.cell || String(value) || '';
    return _react2.default.createElement(
      'td',
      { key: column.field + index,
        className: (0, _common.cname)(column.align),
        'data-field': column.field || index
      },
      _common.utils.isFunction(content) ? content({ column: column, row: row, value: value }) : content
    );
  };

  Table.prototype.renderRow = function renderRow(columns, row, index) {
    var _this5 = this;

    var _props = this.props,
        _props$keyField = _props.keyField,
        keyField = _props$keyField === undefined ? '' : _props$keyField,
        _props$autoRowKey = _props.autoRowKey,
        autoRowKey = _props$autoRowKey === undefined ? true : _props$autoRowKey;
    //直接用 index 作为 key 在表格数据动增删时会显示错误
    //通过 keyField 可即不出问题，也能够重用 dom
    //但是如果没有 keyField，生成一个 uuid 不重用 dom 也要保证显示无问题

    var keyValue = String(autoRowKey && !keyField ? Table.uuid++ : row[keyField] || '');
    if (row['_type'] && row['_type'] === 'EXPAND') {
      return _react2.default.createElement(
        'tr',
        {
          className: (0, _common.cname)('rowTrExpand'),
          key: keyValue + index + 'expand',
          onClick: function onClick() {
            return _this5.handleRowClick(row, index);
          } },
        _react2.default.createElement(
          'td',
          { className: (0, _common.cname)('rowTdExpand'),
            colSpan: columns.length },
          row.children
        )
      );
    }
    return _react2.default.createElement(
      'tr',
      {
        key: keyValue + index,
        'data-row': index,
        onClick: function onClick() {
          return _this5.handleRowClick(row, index);
        } },
      columns.map(function (column, index) {
        return _this5.renderRowCell(column, row, index);
      })
    );
  };

  Table.prototype.renderBody = function renderBody(columns, data, expandObj) {
    var _this6 = this;

    var rows = void 0;
    if (data && data.length > 0) {
      var dataWithExpand = [].concat(data);
      (0, _entries2.default)(expandObj).forEach(function (_ref) {
        var key = _ref[0],
            children = _ref[1];

        var index = dataWithExpand.findIndex(function (_ref2) {
          var rowKey = _ref2.key;
          return key === rowKey && !!children;
        });
        if (index >= 0) dataWithExpand.splice(index + 1, 0, { _type: 'EXPAND', children: children });
      });
      rows = dataWithExpand.map(function (row, index) {
        return _this6.renderRow(columns, row, index);
      });
    } else {
      var _props$empty = this.props.empty,
          empty = _props$empty === undefined ? this.findChildren(Empty) : _props$empty;

      rows = empty && empty.length > 0 ? _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: (0, _common.cname)('empty'),
            colSpan: columns.length },
          empty
        )
      ) : null;
    }
    return _react2.default.createElement(
      'tbody',
      null,
      rows
    );
  };

  Table.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        _props2$columns = _props2.columns,
        columns = _props2$columns === undefined ? this.findColumns() : _props2$columns,
        data = _props2.data,
        _props2$renderExpand = _props2.renderExpand,
        renderExpand = _props2$renderExpand === undefined ? {} : _props2$renderExpand,
        others = (0, _objectWithoutProperties3.default)(_props2, ['className', 'columns', 'data', 'renderExpand']);

    var classNames = (0, _common.cname)(['table', 'widget', 'aniTransition'], className);
    return _react2.default.createElement(
      'table',
      (0, _extends3.default)({}, (0, _common.transportProps)(others), { className: classNames }),
      this.renderHead(columns),
      this.renderBody(columns, data, renderExpand)
    );
  };

  return Table;
}(_common.ComBase), _class2.propTypes = {
  data: _propTypes2.default.array,
  renderExpand: _propTypes2.default.object,
  onRowClick: _propTypes2.default.func
}, _class2.uuid = 0, _class2.Column = Column, _class2.Empty = Empty, _temp3);
exports.default = Table;
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(266), __esModule: true };

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(267);
module.exports = __webpack_require__(9).Object.entries;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(13);
var $entries = __webpack_require__(268)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(27);
var toIObject = __webpack_require__(21);
var isEnum = __webpack_require__(38).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

__webpack_require__(270);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tabPanel = __webpack_require__(271);

var _tabPanel2 = _interopRequireDefault(_tabPanel);

var _tabBar = __webpack_require__(272);

var _tabBar2 = _interopRequireDefault(_tabBar);

var _common = __webpack_require__(0);

var _utils = __webpack_require__(24);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tabs = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Tabs, _ComBase);

  function Tabs() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      activeKey: undefined
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Tabs.prototype.onTabChange = function onTabChange(key) {
    var _props$onChange = this.props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;
    var activeKey = this.props.activeKey;

    if (activeKey === undefined) {
      // activeKey未从Props传进来，使用state里面的值
      activeKey = this.state.activeKey;
      this.setState({ activeKey: key });
    } else {// 从props进来，受控组件
    }
    onChange(key);
  };

  Tabs.prototype.getActiveKey = function getActiveKey() {
    var _props = this.props,
        activeKey = _props.activeKey,
        defaultActiveKey = _props.defaultActiveKey;

    if (activeKey === undefined) {
      activeKey = this.state.activeKey;
    }
    if (activeKey === undefined) {
      activeKey = defaultActiveKey;
    }
    return activeKey;
  };

  Tabs.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        _props2$children = _props2.children,
        children = _props2$children === undefined ? [] : _props2$children,
        type = _props2.type,
        tabAlign = _props2.tabAlign,
        tabPosition = _props2.tabPosition,
        className = _props2.className,
        transparent = _props2.transparent,
        tabWrapperWidth = _props2.tabWrapperWidth,
        size = _props2.size;

    children = _utils2.default.findChildren(_tabPanel2.default, children);
    var activeKey = this.getActiveKey();
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)((_cname = {
          'tab': true
        }, _cname[className] = !!className, _cname['tab-position-' + tabPosition] = true, _cname)) },
      _react2.default.createElement(
        _tabBar2.default,
        { transparent: transparent,
          type: type,
          size: size,
          tabPosition: tabPosition,
          activeKey: activeKey,
          onTabChange: this.onTabChange.bind(this),
          tabAlign: tabAlign,
          wrapperWidth: tabWrapperWidth },
        children.map(function (child) {
          var key = child.key,
              label = child.props.label;

          return _react2.default.createElement(
            'span',
            { className: (0, _common.cname)({
                'tab-label-inner': true
              }), key: key },
            label
          );
        })
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)({
            'tab-pannel-wrapper': true
          }) },
        children.map(function (child) {
          var key = child.key;

          return key === activeKey ? child : '';
        })
      )
    );
  };

  return Tabs;
}(_common.ComBase), _class.TabPanel = _tabPanel2.default, _class.defaultProps = {
  visible: true,
  disabled: false,
  transparent: false,
  type: 'normal',
  size: 'normal',
  tabPosition: 'top',
  tabAlign: 'center',
  tabWrapperWidth: '100%',
  tabWrapperHeight: 'auto'
}, _class.propTypes = {
  /** 是否可见 */
  visible: _propTypes2.default.bool.isRequired,
  /** 是否禁用 */
  disabled: _propTypes2.default.bool.isRequired,
  /** 是否为透明的 Tab */
  transparent: _propTypes2.default.bool.isRequired,
  /** Tab 的基本样式: 锚点型 anchor、普通型 normal、卡片型 card、胶囊型 capsule、文本型 text */
  type: _propTypes2.default.oneOf(['anchor', 'normal', 'card', 'capsule', 'text']).isRequired,
  /** Tab 的尺寸 */
  size: _propTypes2.default.oneOf(['xs', 'small', 'normal', 'large']).isRequired,
  /** Tab 的位置 */
  tabPosition: _propTypes2.default.oneOf(['left', 'top']).isRequired,
  /** Tab 的对齐方式，该属性仅对 `tabPosition` 为 `top` 或 `bottom` 的 `Tab` 有效 */
  tabAlign: _propTypes2.default.oneOf(['left', 'center', 'right', 'full']).isRequired,
  /** 激活的 Tab 的 key */
  activeKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /** 默认选中 Tab 的 key */
  defaultActiveKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /** Tab 发生切换的时候触发的事件 */
  onChange: _propTypes2.default.func,
  /** TabBar 容器的内宽度 */
  tabWrapperWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /** TabBar 容器的内高度 */
  tabWrapperHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _temp2);
exports.default = Tabs;
module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPanel = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(TabPanel, _ComBase);

  function TabPanel() {
    (0, _classCallCheck3.default)(this, TabPanel);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  TabPanel.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        activeKey = _props.activeKey,
        height = _props.height;
    var key = this.key;

    return _react2.default.createElement(
      'div',
      { style: { height: height }, className: (0, _common.cname)({
          'tab-panel': true,
          'tab-panel-active': key === activeKey
        }) },
      children
    );
  };

  return TabPanel;
}(_common.ComBase), _class.propTypes = {
  /** Tab 的标签 */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  /** Tab 的内容的高度 */
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _temp);
exports.default = TabPanel;
module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabBar = function (_ComBase) {
  (0, _inherits3.default)(TabBar, _ComBase);

  function TabBar() {
    (0, _classCallCheck3.default)(this, TabBar);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  TabBar.prototype.getWrapperWidth = function getWrapperWidth() {
    var _props = this.props,
        wrapperWidth = _props.wrapperWidth,
        tabPosition = _props.tabPosition;

    if (tabPosition === 'left' && wrapperWidth.indexOf('%') >= 0) {
      //垂直Tab布局下，禁用百分比，一律auto
      wrapperWidth = undefined;
    }
    return wrapperWidth;
  };

  TabBar.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        children = _props2.children,
        activeKey = _props2.activeKey,
        type = _props2.type,
        tabAlign = _props2.tabAlign,
        onTabChange = _props2.onTabChange,
        className = _props2.className,
        transparent = _props2.transparent,
        size = _props2.size;

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)((_cname = {
          'tab-bar': true
        }, _cname[className] = !!className, _cname['tab-bar-type-' + type] = true, _cname['tab-bar-align-' + tabAlign] = true, _cname['tab-bar-size-' + size] = true, _cname['tab-bar-transparent'] = transparent, _cname)) },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)({
            'tab-bar-wrapper': true
          }), style: {
            width: this.getWrapperWidth()
          } },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)({
              'tab-item-wrapper': true
            }) },
          children.map(function (child) {
            var _cname2;

            var key = child.key;

            return _react2.default.createElement(
              'div',
              { key: key, className: (0, _common.cname)((_cname2 = {
                  'tab-label': true,
                  'tab-label-active': key === activeKey
                }, _cname2['tab-label-col-' + children.length] = true, _cname2)), onClick: function onClick() {
                  onTabChange(key);
                } },
              child
            );
          })
        )
      )
    );
  };

  return TabBar;
}(_common.ComBase);

TabBar.propTypes = {
  /**
   * Tab的基本样式，值有：锚点型anchor、普通型normal、卡片型card、胶囊型capsule、文本型text
   */
  type: _propTypes2.default.oneOf(['anchor', 'normal', 'card', 'capsule', 'text']).isRequired,
  /**
   * Tab的尺寸，值有：small，normal，large
   */
  size: _propTypes2.default.oneOf(['xs', 'small', 'normal', 'large']),
  /**
   * 是否透明
   */
  transparent: _propTypes2.default.bool.isRequired,
  /**
   * 激活的Tab的key
   */
  activeKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Tab的对齐方式：有'left', 'right', 'center', 'full',该属性仅对tabPosition为top或bottom的Tab有效
   */
  tabAlign: _propTypes2.default.oneOf(['left', 'center', 'right', 'full']).isRequired,
  /**
   * Tab切的时候触发的事件
   */
  onTabChange: _propTypes2.default.func.isRequired,
  /**
   * TabBar容器的内宽度
   */
  wrapperWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Tab的位置，值有'left', 'top'
   */
  tabPosition: _propTypes2.default.oneOf(['left', 'top']).isRequired
};

exports.default = TabBar;
module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

__webpack_require__(274);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _propTypes2.default.string,
  closable: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
};

var defaultProps = {
  closable: false
};

var Tag = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Tag, _ComBase);

  function Tag() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.close = function (e, otherProps) {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose(e, otherProps);
      }

      if (e.defaultPrevented) {
        return;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Tag.prototype.render = function render() {
    var _this2 = this,
        _cname;

    var _props = this.props,
        closable = _props.closable,
        colorField = _props.colorField,
        className = _props.className,
        children = _props.children,
        style = _props.style,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['closable', 'colorField', 'className', 'children', 'style']);

    var closeIcon = closable ? _react2.default.createElement(
      'span',
      { className: 'aps-tag-close',
        type: 'close',
        onClick: function onClick(e) {
          _this2.close(e, otherProps);
        } },
      '\u2715'
    ) : '';

    var names = (0, _common.cname)((_cname = {}, _cname['tag'] = true, _cname['tag-has-color'] = !!colorField, _cname), className);

    var tagStyle = (0, _extends3.default)({
      backgroundColor: colorField ? colorField : null
    }, style);

    return _react2.default.createElement(
      'div',
      { className: names, style: tagStyle },
      _react2.default.createElement(
        'span',
        null,
        children
      ),
      closeIcon
    );
  };

  return Tag;
}(_common.ComBase), _class.propTypes = propTypes, _class.defaultProps = defaultProps, _temp2);
exports.default = Tag;
module.exports = exports['default'];

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(276);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tags = function (_ComBase) {
  (0, _inherits3.default)(Tags, _ComBase);

  function Tags(props) {
    (0, _classCallCheck3.default)(this, Tags);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.onCloseSomeTag = function (e, p) {
      var items = _this.state.items.filter(function (item) {
        return item.value != p.value;
      });
      _this.setState({ items: items }, function () {
        _this.props.onRemove && _this.props.onRemove(e, p);
        _this.onChange();
      });
    };

    _this.onChange = function () {
      _this.props.onChange && _this.props.onChange(new _common.EventArgs(_this, _this.state.items));
    };

    _this.state = {
      items: _this.props.items || []
    };
    return _this;
  }

  Tags.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.value && (0, _stringify2.default)(nextProps.value) != (0, _stringify2.default)(this.props.value)) {
      this.setState({ items: nextProps.value });
    }
  };

  Tags.prototype.render = function render() {
    var _this2 = this;

    var items = this.state.items;
    var className = this.props.className;

    var names = (0, _common.cname)({
      Tags: true
    }, className);
    return _react2.default.createElement(
      'div',
      { className: names },
      items.map(function (tag, index) {
        return _react2.default.createElement(
          _components.Tag,
          (0, _extends3.default)({ key: index }, tag, { onClose: _this2.onCloseSomeTag }),
          tag.content
        );
      })
    );
  };

  return Tags;
}(_common.ComBase);

exports.default = Tags;
module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _cname2 = __webpack_require__(23);

var _cname3 = _interopRequireDefault(_cname2);

var _ComBase2 = __webpack_require__(29);

var _ComBase3 = _interopRequireDefault(_ComBase2);

var _Item = __webpack_require__(278);

var _Item2 = _interopRequireDefault(_Item);

__webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timeline = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Timeline, _ComBase);

  function Timeline() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Timeline);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.items = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Timeline.prototype.render = function render() {
    var _cname;

    var className = this.props.className;

    var clsName = (0, _cname3.default)((_cname = {}, _cname['time-line'] = true, _cname), className);

    return _react2.default.createElement(
      'ul',
      { style: this.props.title || {}, className: clsName },
      this.getItems.map(function (item, index) {
        return _react2.default.createElement(_Item2.default, (0, _extends3.default)({ key: index }, item));
      })
    );
  };

  (0, _createClass3.default)(Timeline, [{
    key: 'getItems',
    get: function get() {
      if (this.props.items) return this.props.items;

      return this.findChildren(Timeline.Item).map(function (item) {
        return (0, _extends3.default)({}, item.props, { component: item.props.children });
      });
    }
  }]);
  return Timeline;
}(_ComBase3.default), _class.Item = _Item2.default, _temp2);
exports.default = Timeline;
module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _dateEntity = __webpack_require__(34);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

var _ComBase2 = __webpack_require__(29);

var _ComBase3 = _interopRequireDefault(_ComBase2);

var _cname = __webpack_require__(23);

var _cname2 = _interopRequireDefault(_cname);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_ComBase) {
  (0, _inherits3.default)(Item, _ComBase);

  function Item() {
    (0, _classCallCheck3.default)(this, Item);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Item.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        content = _props.content,
        datetime = _props.datetime;


    return _react2.default.createElement(
      'li',
      { className: (0, _cname2.default)('time-line-item') },
      _react2.default.createElement('div', { className: (0, _cname2.default)('dot') }),
      _react2.default.createElement('div', { className: (0, _cname2.default)('line') }),
      _react2.default.createElement(
        'div',
        { className: (0, _cname2.default)('time') },
        new _dateEntity2.default(datetime).format('yyyy-MM-dd hh:mm:ss')
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _cname2.default)('info') },
        _react2.default.createElement(
          'p',
          { className: (0, _cname2.default)('title') },
          title
        ),
        _react2.default.createElement(
          'p',
          { className: (0, _cname2.default)('content') },
          content
        )
      )
    );
  };

  return Item;
}(_ComBase3.default);

exports.default = Item;
module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cname = __webpack_require__(23);

var _cname2 = _interopRequireDefault(_cname);

var _ComBase2 = __webpack_require__(29);

var _ComBase3 = _interopRequireDefault(_ComBase2);

var _utils = __webpack_require__(24);

var _utils2 = _interopRequireDefault(_utils);

var _Popover = __webpack_require__(47);

var _Popover2 = _interopRequireDefault(_Popover);

var _Proxy = __webpack_require__(48);

var _Proxy2 = _interopRequireDefault(_Proxy);

__webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_ALLOWED_DIRECTION = ['bottom', 'top', 'right', 'left'];
var DEFAULT_ALLOWED_V_ALIGN = ['top', 'middle', 'bottom'];
var DEFAULT_ALLOWED_H_ALIGN = ['left', 'center', 'right'];

var Tooltip = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Tooltip, _ComBase);

  function Tooltip() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { visible: false, element: null, mount: false }, _this.onDocumentClick = function (event) {
      var triggerType = _this.props.triggerType;

      if (triggerType !== 'click') return;
      var follow = _this.getFollow();
      var visible = _utils2.default.inContainer(_this.domNode, event.target) || _utils2.default.inContainer(follow, event.target) || _utils2.default.inContainer(_this.panel, event.target);
      _this.setState({ visible: visible });
    }, _this.onDocumentMouseMove = function (event) {
      var _this$props$triggerTy = _this.props.triggerType,
          triggerType = _this$props$triggerTy === undefined ? 'hover' : _this$props$triggerTy;

      if (triggerType !== 'hover') return;
      var follow = _this.getFollow();
      var visible = _utils2.default.inContainer(_this.domNode, event.target) || _utils2.default.inContainer(follow, event.target) || _utils2.default.inContainer(_this.panel, event.target);
      _this.setState({ visible: visible });
    }, _this.getFollow = function () {
      if (_this._followNode) return _this._followNode;
      var follow = _this.state.element ? _this.domNode : _this._follow;
      if (_utils2.default.isComponent(follow)) follow = follow.domNode;
      if (_utils2.default.isString(follow)) follow = document.querySelector(follow);
      _this._followNode = follow;
      return _this._followNode;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Tooltip.prototype.componentDidMount = function componentDidMount() {
    var trigger = this.props.trigger;

    this._follow = _utils2.default.isFunction(trigger) ? trigger() : trigger;
    var element = _utils2.default.isReactElement(this._follow) ? this._follow : null;
    this.setState({ mount: true, element: element });
  };

  Tooltip.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        visible = _state.visible,
        mount = _state.mount,
        element = _state.element;

    if (!mount) return _react2.default.createElement('span', { className: (0, _cname2.default)('hidden') });
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        theme = _props.theme,
        opts = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'theme']);

    var popoverClassName = ['tooltip-popover'];
    if (theme == 'light') popoverClassName.push('tooltip-popover-light');
    return _react2.default.createElement(
      'div',
      { className: (0, _cname2.default)('tooltip') },
      element,
      _react2.default.createElement(
        _Popover2.default,
        (0, _extends3.default)({
          visible: visible
        }, opts, {
          ref: function ref(_ref) {
            return _this2.panel = _ref;
          },
          overlay: false,
          follow: this.getFollow,
          className: (0, _cname2.default)(popoverClassName, className) }),
        _react2.default.createElement('div', { className: (0, _cname2.default)('tooltip-arrow') }),
        _react2.default.createElement(
          'div',
          { className: (0, _cname2.default)('tooltip-inner') },
          children
        )
      ),
      _react2.default.createElement(_Proxy2.default, { target: document,
        onClick: this.onDocumentClick,
        onMouseMove: this.onDocumentMouseMove })
    );
  };

  return Tooltip;
}(_ComBase3.default), _class.propTypes = {

  /** 弹层的类名 */
  className: _propTypes2.default.string,

  /** 是否显示 */
  visible: _propTypes2.default.bool,

  /** 触发元素 */
  trigger: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.string]),

  /** 触发类型 */
  triggerType: _propTypes2.default.oneOf(['hover', 'click']),

  /**
   * 单击事件
   */
  onClick: _propTypes2.default.func,

  /** 
   * 用于指定固定的弹出方向
   **/
  direction: _propTypes2.default.oneOf(DEFAULT_ALLOWED_DIRECTION),

  /** 
   * 用于指定固定的弹出的对刘方式 
   **/
  align: _propTypes2.default.oneOf([].concat(DEFAULT_ALLOWED_H_ALIGN, DEFAULT_ALLOWED_V_ALIGN))
}, _class.defaultProps = {}, _temp2);
exports.default = Tooltip;
module.exports = exports['default'];

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(30);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(22);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = __webpack_require__(4);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _list = __webpack_require__(283);

var _list2 = _interopRequireDefault(_list);

var _operation = __webpack_require__(285);

var _operation2 = _interopRequireDefault(_operation);

var _search = __webpack_require__(102);

var _search2 = _interopRequireDefault(_search);

__webpack_require__(286);

var _i18n = __webpack_require__(287);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function noop() {}

var Transfer = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Transfer, _ComBase);

  function Transfer(props) {
    (0, _classCallCheck3.default)(this, Transfer);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var _props$selectedKeys = props.selectedKeys,
        selectedKeys = _props$selectedKeys === undefined ? [] : _props$selectedKeys,
        _props$targetKeys = props.targetKeys,
        targetKeys = _props$targetKeys === undefined ? [] : _props$targetKeys;

    _this.state = {
      leftFilter: '',
      rightFilter: '',
      sourceSelectedKeys: selectedKeys.filter(function (key) {
        return !targetKeys.includes(key);
      }),
      targetSelectedKeys: selectedKeys.filter(function (key) {
        return targetKeys.includes(key);
      })
    };
    return _this;
  }

  Transfer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _state = this.state,
        sourceSelectedKeys = _state.sourceSelectedKeys,
        targetSelectedKeys = _state.targetSelectedKeys;


    if (nextProps.targetKeys !== this.props.targetKeys || nextProps.dataSource !== this.props.dataSource) {
      // clear cached separated dataSource
      this.separatedDataSource = null;

      if (!nextProps.selectedKeys) {
        // clear key no longer existed
        // clear checkedKeys according to targetKeys
        var dataSource = nextProps.dataSource,
            _nextProps$targetKeys = nextProps.targetKeys,
            targetKeys = _nextProps$targetKeys === undefined ? [] : _nextProps$targetKeys;


        var newSourceSelectedKeys = [];
        var newTargetSelectedKeys = [];
        dataSource.forEach(function (_ref) {
          var key = _ref.key;

          if (sourceSelectedKeys.includes(key) && !targetKeys.includes(key)) {
            newSourceSelectedKeys.push(key);
          }
          if (targetSelectedKeys.includes(key) && targetKeys.includes(key)) {
            newTargetSelectedKeys.push(key);
          }
        });
        this.setState({
          sourceSelectedKeys: newSourceSelectedKeys,
          targetSelectedKeys: newTargetSelectedKeys
        });
      }
    }

    if (nextProps.selectedKeys) {
      var _targetKeys = nextProps.targetKeys || [];
      this.setState({
        sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
          return !_targetKeys.includes(key);
        }),
        targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
          return _targetKeys.includes(key);
        })
      });
    }
  };

  Transfer.prototype.separateDataSource = function separateDataSource(props) {
    if (this.separatedDataSource) {
      return this.separatedDataSource;
    }

    var dataSource = props.dataSource,
        rowKey = props.rowKey,
        _props$targetKeys2 = props.targetKeys,
        targetKeys = _props$targetKeys2 === undefined ? [] : _props$targetKeys2;


    var leftDataSource = [];
    var rightDataSource = new Array(targetKeys.length);
    dataSource.forEach(function (record) {
      if (rowKey) {
        record.key = rowKey(record);
      }

      // rightDataSource should be ordered by targetKeys
      // leftDataSource should be ordered by dataSource
      var indexOfKey = targetKeys.indexOf(record.key);
      if (indexOfKey !== -1) {
        rightDataSource[indexOfKey] = record;
      } else {
        leftDataSource.push(record);
      }
    });

    this.separatedDataSource = {
      leftDataSource: leftDataSource,
      rightDataSource: rightDataSource
    };

    return this.separatedDataSource;
  };

  Transfer.prototype.handleSelectChange = function handleSelectChange(direction, holder) {
    var _state2 = this.state,
        sourceSelectedKeys = _state2.sourceSelectedKeys,
        targetSelectedKeys = _state2.targetSelectedKeys;

    var onSelectChange = this.props.onSelectChange;
    if (!onSelectChange) {
      return;
    }

    if (direction === 'left') {
      onSelectChange(new _common.EventArgs(this, { sourceSelectedKeys: holder, targetSelectedKeys: targetSelectedKeys }));
    } else {
      onSelectChange(new _common.EventArgs(this, { sourceSelectedKeys: sourceSelectedKeys, targetSelectedKeys: holder }));
    }
  };

  Transfer.prototype.getTitles = function getTitles(transferLocale) {
    if (this.props.titles) {
      return this.props.titles;
    }
    return transferLocale.titles;
  };

  Transfer.prototype.getSelectedKeysName = function getSelectedKeysName(direction) {
    return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
  };

  Transfer.prototype.render = function render() {
    return React.createElement(
      'div',
      null,
      this.renderTransfer({
        titles: ['', ''],
        itemUnit: _i18n2.default.current.itemUnit,
        itemsUnit: _i18n2.default.current.itemsUnit,
        searchPlaceholder: _i18n2.default.current.searchPlaceholder,
        notFoundContent: _i18n2.default.current.notFoundContent
      })
    );
  };

  return Transfer;
}(_common.ComBase), _class.List = _list2.default, _class.Operation = _operation2.default, _class.Search = _search2.default, _class.defaultProps = {
  dataSource: [],
  render: noop,
  showSearch: false
}, _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  dataSource: _propTypes2.default.array,
  render: _propTypes2.default.func,
  targetKeys: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  height: _propTypes2.default.number,
  style: _propTypes2.default.object,
  listStyle: _propTypes2.default.object,
  operationStyle: _propTypes2.default.object,
  className: _propTypes2.default.string,
  titles: _propTypes2.default.array,
  operations: _propTypes2.default.array,
  showSearch: _propTypes2.default.bool,
  filterOption: _propTypes2.default.func,
  searchPlaceholder: _propTypes2.default.string,
  notFoundContent: _propTypes2.default.node,
  body: _propTypes2.default.func,
  footer: _propTypes2.default.func,
  rowKey: _propTypes2.default.func
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.moveTo = function (direction) {
    var _this2$setState;

    var _props = _this2.props,
        _props$targetKeys3 = _props.targetKeys,
        targetKeys = _props$targetKeys3 === undefined ? [] : _props$targetKeys3,
        _props$dataSource = _props.dataSource,
        dataSource = _props$dataSource === undefined ? [] : _props$dataSource,
        onChange = _props.onChange;
    var _state3 = _this2.state,
        sourceSelectedKeys = _state3.sourceSelectedKeys,
        targetSelectedKeys = _state3.targetSelectedKeys;

    var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys;
    // filter the disabled options
    var newMoveKeys = moveKeys.filter(function (key) {
      return !dataSource.some(function (data) {
        return !!(key === data.key && data.disabled);
      });
    });
    // move items to target box
    var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
      return newMoveKeys.indexOf(targetKey) === -1;
    });

    // empty checked keys
    var oppositeDirection = direction === 'right' ? 'left' : 'right';
    _this2.setState((_this2$setState = {}, _this2$setState[_this2.getSelectedKeysName(oppositeDirection)] = [], _this2$setState));
    _this2.handleSelectChange(oppositeDirection, []);

    if (onChange) {
      onChange(new _common.EventArgs(_this2, { targetKeys: newTargetKeys, direction: direction, moveKeys: newMoveKeys }));
    }
  };

  this.moveToLeft = function () {
    return _this2.moveTo('left');
  };

  this.moveToRight = function () {
    return _this2.moveTo('right');
  };

  this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
    var originalSelectedKeys = _this2.state[_this2.getSelectedKeysName(direction)] || [];
    var currentKeys = filteredDataSource.map(function (item) {
      return item.key;
    });
    // Only operate current keys from original selected keys
    var newKeys1 = originalSelectedKeys.filter(function (key) {
      return currentKeys.indexOf(key) === -1;
    });
    var newKeys2 = [].concat(originalSelectedKeys);
    currentKeys.forEach(function (key) {
      if (newKeys2.indexOf(key) === -1) {
        newKeys2.push(key);
      }
    });
    var holder = checkAll ? newKeys1 : newKeys2;
    _this2.handleSelectChange(direction, holder);

    if (!_this2.props.selectedKeys) {
      var _this2$setState2;

      _this2.setState((_this2$setState2 = {}, _this2$setState2[_this2.getSelectedKeysName(direction)] = holder, _this2$setState2));
    }
  };

  this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
    _this2.handleSelectAll('left', filteredDataSource, checkAll);
  };

  this.handleRightSelectAll = function (filteredDataSource, checkAll) {
    _this2.handleSelectAll('right', filteredDataSource, checkAll);
  };

  this.handleFilter = function (direction, e) {
    var _this2$setState3;

    _this2.setState((_this2$setState3 = {}, _this2$setState3[direction + 'Filter'] = e.target.value, _this2$setState3));
    if (_this2.props.onSearchChange) {
      _this2.props.onSearchChange(new _common.EventArgs(_this2, { direction: direction, value: e.target.value }, e));
    }
  };

  this.handleLeftFilter = function (e) {
    return _this2.handleFilter('left', e);
  };

  this.handleRightFilter = function (e) {
    return _this2.handleFilter('right', e);
  };

  this.handleClear = function (direction) {
    var _this2$setState4;

    if (!(typeof direction === 'string')) {
      throw new TypeError('Value of argument "direction" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(direction));
    }

    _this2.setState((_this2$setState4 = {}, _this2$setState4[direction + 'Filter'] = '', _this2$setState4));
  };

  this.handleLeftClear = function () {
    return _this2.handleClear('left');
  };

  this.handleRightClear = function () {
    return _this2.handleClear('right');
  };

  this.handleSelect = function (direction, selectedItem, checked) {
    var _state4 = _this2.state,
        sourceSelectedKeys = _state4.sourceSelectedKeys,
        targetSelectedKeys = _state4.targetSelectedKeys;

    var holder = direction === 'left' ? [].concat(sourceSelectedKeys) : [].concat(targetSelectedKeys);
    var index = holder.indexOf(selectedItem.key);
    if (index > -1) {
      holder.splice(index, 1);
    }
    if (checked) {
      holder.push(selectedItem.key);
    }
    _this2.handleSelectChange(direction, holder);

    if (!_this2.props.selectedKeys) {
      var _this2$setState5;

      _this2.setState((_this2$setState5 = {}, _this2$setState5[_this2.getSelectedKeysName(direction)] = holder, _this2$setState5));
    }
  };

  this.handleLeftSelect = function (selectedItem, checked) {
    return _this2.handleSelect('left', selectedItem, checked);
  };

  this.handleRightSelect = function (selectedItem, checked) {
    return _this2.handleSelect('right', selectedItem, checked);
  };

  this.handleScroll = function (direction, e) {
    var onScroll = _this2.props.onScroll;

    if (onScroll) {
      //onScroll(direction, e);
      onScroll(new _common.EventArgs(_this2, { direction: direction, value: e.target.value }, e));
    }
  };

  this.handleLeftScroll = function (e) {
    return _this2.handleScroll('left', e);
  };

  this.handleRightScroll = function (e) {
    return _this2.handleScroll('right', e);
  };

  this.renderTransfer = function (locale) {
    var _props2 = _this2.props,
        _props2$prefixCls = _props2.prefixCls,
        prefixCls = _props2$prefixCls === undefined ? 'aps-transfer' : _props2$prefixCls,
        className = _props2.className,
        _props2$operations = _props2.operations,
        operations = _props2$operations === undefined ? [] : _props2$operations,
        showSearch = _props2.showSearch,
        notFoundContent = _props2.notFoundContent,
        searchPlaceholder = _props2.searchPlaceholder,
        body = _props2.body,
        footer = _props2.footer,
        style = _props2.style,
        listStyle = _props2.listStyle,
        operationStyle = _props2.operationStyle,
        filterOption = _props2.filterOption,
        render = _props2.render,
        dataSourceTotal = _props2.dataSourceTotal;
    var _state5 = _this2.state,
        leftFilter = _state5.leftFilter,
        rightFilter = _state5.rightFilter,
        sourceSelectedKeys = _state5.sourceSelectedKeys,
        targetSelectedKeys = _state5.targetSelectedKeys;

    var _separateDataSource = _this2.separateDataSource(_this2.props),
        leftDataSource = _separateDataSource.leftDataSource,
        rightDataSource = _separateDataSource.rightDataSource;

    var leftActive = targetSelectedKeys.length > 0;
    var rightActive = sourceSelectedKeys.length > 0;

    var cls = (0, _common.cname)(className + ' ' + prefixCls + ' widget');

    var titles = _this2.getTitles(locale);

    return React.createElement(
      'div',
      { className: cls, style: style },
      React.createElement(_list2.default, {
        prefixCls: prefixCls + '-list',
        titleText: titles[0],
        dataSource: leftDataSource,
        dataSourceTotal: dataSourceTotal,
        filter: leftFilter,
        filterOption: filterOption,
        style: listStyle,
        checkedKeys: sourceSelectedKeys,
        handleFilter: _this2.handleLeftFilter,
        handleClear: _this2.handleLeftClear,
        handleSelect: _this2.handleLeftSelect,
        handleSelectAll: _this2.handleLeftSelectAll,
        render: render,
        showSearch: showSearch,
        searchPlaceholder: searchPlaceholder || locale.searchPlaceholder,
        notFoundContent: notFoundContent || locale.notFoundContent,
        itemUnit: locale.itemUnit,
        itemsUnit: locale.itemsUnit,
        body: body,
        footer: footer,
        onScroll: _this2.handleLeftScroll
      }),
      React.createElement(_operation2.default, {
        className: prefixCls + '-operation',
        rightActive: rightActive,
        rightArrowText: operations[0],
        moveToRight: _this2.moveToRight,
        leftActive: leftActive,
        leftArrowText: operations[1],
        moveToLeft: _this2.moveToLeft,
        style: operationStyle
      }),
      React.createElement(_list2.default, {
        prefixCls: prefixCls + '-list',
        titleText: titles[1],
        dataSource: rightDataSource,
        filter: rightFilter,
        filterOption: filterOption,
        style: listStyle,
        checkedKeys: targetSelectedKeys,
        handleFilter: _this2.handleRightFilter,
        handleClear: _this2.handleRightClear,
        handleSelect: _this2.handleRightSelect,
        handleSelectAll: _this2.handleRightSelectAll,
        render: render,
        showSearch: showSearch,
        searchPlaceholder: searchPlaceholder || locale.searchPlaceholder,
        notFoundContent: notFoundContent || locale.notFoundContent,
        itemUnit: locale.itemUnit,
        itemsUnit: locale.itemsUnit,
        body: body,
        footer: footer,
        onScroll: _this2.handleRightScroll
      })
    );
  };
}, _temp);
exports.default = Transfer;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(40);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

var _search = __webpack_require__(102);

var _search2 = _interopRequireDefault(_search);

var _item = __webpack_require__(284);

var _item2 = _interopRequireDefault(_item);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function triggerEvent(el, type) {
  if ('createEvent' in document) {
    // modern browsers, IE9+
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  }
}

function noop() {}

function isRenderResultPlainObject(result) {
  return result && !React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
}

var TransferList = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(TransferList, _ComBase);

  function TransferList(props) {
    (0, _classCallCheck3.default)(this, TransferList);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.handleSelect = function (selectedItem) {
      var checkedKeys = _this.props.checkedKeys;

      var result = checkedKeys.some(function (key) {
        return key === selectedItem.key;
      });
      _this.props.handleSelect(selectedItem, !result);
    };

    _this.handleFilter = function (e) {
      _this.props.handleFilter(e);
      if (!e.target.value) {
        return;
      }
      // Manually trigger scroll event for lazy search bug
      _this.triggerScrollTimer = window.setTimeout(function () {
        var transferNode = ReactDOM.findDOMNode(_this);
        var listNode = transferNode.querySelectorAll('.ant-transfer-list-content')[0];
        if (listNode) {
          triggerEvent(listNode, 'scroll');
        }
      }, 0);
    };

    _this.handleClear = function () {
      _this.props.handleClear();
    };

    _this.matchFilter = function (text, item) {
      var _this$props = _this.props,
          filter = _this$props.filter,
          filterOption = _this$props.filterOption;

      if (filterOption) {
        return filterOption(filter, item);
      }
      return text.indexOf(filter) >= 0;
    };

    _this.renderItem = function (item) {
      var _this$props$render = _this.props.render,
          render = _this$props$render === undefined ? noop : _this$props$render;

      var renderResult = render(item);
      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
      return {
        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
        renderedEl: isRenderResultPlain ? renderResult.label : renderResult
      };
    };

    _this.state = {
      mounted: false
    };
    return _this;
  }

  TransferList.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.timer = window.setTimeout(function () {
      _this2.setState({
        mounted: true
      });
    }, 0);
  };

  TransferList.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.triggerScrollTimer);
  };

  TransferList.prototype.getCheckStatus = function getCheckStatus(filteredDataSource) {
    var checkedKeys = this.props.checkedKeys;

    if (checkedKeys.length === 0) {
      return 'none';
    } else if (filteredDataSource.every(function (item) {
      return checkedKeys.indexOf(item.key) >= 0;
    })) {
      return 'all';
    }
    return 'part';
  };

  TransferList.prototype.render = function render() {
    var _cname,
        _this3 = this;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        dataSource = _props.dataSource,
        dataSourceTotal = _props.dataSourceTotal,
        titleText = _props.titleText,
        checkedKeys = _props.checkedKeys,
        _props$body = _props.body,
        body = _props$body === undefined ? noop : _props$body,
        _props$footer = _props.footer,
        footer = _props$footer === undefined ? noop : _props$footer,
        showSearch = _props.showSearch,
        style = _props.style,
        filter = _props.filter,
        searchPlaceholder = _props.searchPlaceholder,
        notFoundContent = _props.notFoundContent,
        itemUnit = _props.itemUnit,
        itemsUnit = _props.itemsUnit,
        onScroll = _props.onScroll;

    // Custom Layout

    var footerDom = footer((0, _extends3.default)({}, this.props));
    var bodyDom = body((0, _extends3.default)({}, this.props));

    var listCls = (0, _common.cname)(prefixCls, (_cname = {}, _cname[prefixCls + '-with-footer'] = !!footerDom, _cname));
    var listThemeCls = (0, _common.cname)({
      widget: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true
    });

    var filteredDataSource = [];
    var totalDataSource = [];

    var showItems = dataSource.map(function (item) {
      var _renderItem = _this3.renderItem(item),
          renderedText = _renderItem.renderedText,
          renderedEl = _renderItem.renderedEl;

      if (filter && filter.trim() && !_this3.matchFilter(renderedText, item)) {
        return null;
      }

      // all show items
      totalDataSource.push(item);
      if (!item.disabled) {
        // response to checkAll items
        filteredDataSource.push(item);
      }

      var checked = checkedKeys.indexOf(item.key) >= 0;
      return React.createElement(_item2.default, {
        key: item.key,
        item: item,
        renderedText: renderedText,
        renderedEl: renderedEl,
        checked: checked,
        prefixCls: prefixCls,
        onClick: _this3.handleSelect
      });
    });

    var unit = dataSource.length > 1 ? itemsUnit : itemUnit;

    var search = showSearch ? React.createElement(
      'div',
      { className: prefixCls + '-body-search-wrapper' },
      React.createElement(_search2.default, {
        prefixCls: prefixCls + '-search',
        onChange: this.handleFilter,
        handleClear: this.handleClear,
        placeholder: searchPlaceholder,
        value: filter
      })
    ) : null;

    var listBody = bodyDom || React.createElement(
      'div',
      {
        className: showSearch ? prefixCls + '-body ' + prefixCls + '-body-with-search' : prefixCls + '-body'
      },
      search,
      React.createElement(
        'ul',
        { onScroll: onScroll, className: prefixCls + '-content' },
        showItems
      ),
      React.createElement(
        'div',
        { className: prefixCls + '-body-not-found' },
        notFoundContent
      )
    );

    var listFooter = footerDom ? React.createElement(
      'div',
      { className: prefixCls + '-footer' },
      footerDom
    ) : null;

    var checkStatus = this.getCheckStatus(filteredDataSource);
    var checkedAll = checkStatus === 'all';
    var checkAllCheckbox = React.createElement(_components.CheckBox, {
      ref: 'checkbox',
      checked: checkedAll,
      indeterminate: checkStatus === 'part',
      onChange: function onChange() {
        return _this3.props.handleSelectAll(filteredDataSource, checkedAll);
      }
    });

    return React.createElement(
      'div',
      { className: listCls + ' ' + listThemeCls, style: style },
      React.createElement(
        'div',
        { className: prefixCls + '-header' },
        checkAllCheckbox,
        React.createElement(
          'span',
          { className: prefixCls + '-header-selected' },
          React.createElement(
            'span',
            null,
            (checkedKeys.length > 0 ? checkedKeys.length + '/' : '') + (dataSourceTotal || totalDataSource.length),
            ' ',
            unit
          ),
          React.createElement(
            'span',
            { className: prefixCls + '-header-title' },
            titleText
          )
        )
      ),
      listBody,
      listFooter
    );
  };

  return TransferList;
}(_common.ComBase), _class.defaultProps = {
  dataSource: [],
  titleText: '',
  showSearch: false,
  render: noop
}, _temp);
exports.default = TransferList;
module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var React = _interopRequireWildcard(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_ComBase) {
  (0, _inherits3.default)(Item, _ComBase);

  function Item() {
    (0, _classCallCheck3.default)(this, Item);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Item.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        renderedText = _props.renderedText,
        renderedEl = _props.renderedEl,
        item = _props.item,
        checked = _props.checked,
        prefixCls = _props.prefixCls,
        onClick = _props.onClick;


    var className = (0, _common.cname)((_cname = {}, _cname[prefixCls + '-content-item'] = true, _cname[prefixCls + '-content-item-disabled'] = item.disabled, _cname));

    var listItem = React.createElement(
      'label',
      null,
      React.createElement(
        'li',
        { className: className, title: renderedText },
        React.createElement(_components.CheckBox, {
          checked: checked,
          disabled: item.disabled,
          onChange: item.disabled ? undefined : function () {
            return onClick(item);
          }
        }),
        React.createElement(
          'span',
          { className: prefixCls + '-content-item-text' },
          renderedEl
        )
      )
    );

    return listItem;
  };

  return Item;
}(_common.ComBase);

exports.default = Item;
module.exports = exports['default'];

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var React = _interopRequireWildcard(_react);

var _components = __webpack_require__(7);

var _common = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operation = function (_ComBase) {
  (0, _inherits3.default)(Operation, _ComBase);

  function Operation() {
    (0, _classCallCheck3.default)(this, Operation);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Operation.prototype.render = function render() {
    var _props = this.props,
        moveToLeft = _props.moveToLeft,
        moveToRight = _props.moveToRight,
        _props$leftArrowText = _props.leftArrowText,
        leftArrowText = _props$leftArrowText === undefined ? '' : _props$leftArrowText,
        _props$rightArrowText = _props.rightArrowText,
        rightArrowText = _props$rightArrowText === undefined ? '' : _props$rightArrowText,
        leftActive = _props.leftActive,
        rightActive = _props.rightActive,
        className = _props.className;

    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        _components.Button,
        { type: 'primary', size: 'small', disabled: !leftActive, onClick: moveToLeft },
        leftArrowText || React.createElement(_components.Icon, { type: 'arrow-left' })
      ),
      React.createElement(
        _components.Button,
        { type: 'primary', size: 'small', disabled: !rightActive, onClick: moveToRight },
        rightArrowText || React.createElement(_components.Icon, { type: 'arrow-right' })
      )
    );
  };

  return Operation;
}(_common.ComBase);

exports.default = Operation;
module.exports = exports['default'];

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    notFoundContent: '无匹配结果',
    searchPlaceholder: '请输入搜索内容',
    itemUnit: '项',
    itemsUnit: '项'
  },
  en: {
    notFoundContent: 'Not Found',
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  ja: {
    notFoundContent: '結果はありません',
    searchPlaceholder: 'ここを検索',
    itemUnit: 'アイテム',
    itemsUnit: 'アイテム'
  }
});
module.exports = exports['default'];

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _Tree = __webpack_require__(289);

var _Tree2 = _interopRequireDefault(_Tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tree2.default;
module.exports = exports['default'];

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _TreeNode = __webpack_require__(290);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

__webpack_require__(291);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tree = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Tree, _ComBase);

  function Tree() {
    (0, _classCallCheck3.default)(this, Tree);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Tree.prototype.render = function render() {
    var _props = this.props,
        _props$dataSource = _props.dataSource,
        dataSource = _props$dataSource === undefined ? [] : _props$dataSource,
        nodeLabel = _props.nodeLabel,
        nodeActions = _props.nodeActions,
        arrow = _props.arrow,
        className = _props.className;


    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('tree', className) },
      (dataSource || []).map(function (node) {
        return _react2.default.createElement(_TreeNode2.default, { key: _common.utils.newGuid(), data: node, nodeLabel: nodeLabel, nodeActions: nodeActions, arrow: arrow });
      })
    );
  };

  return Tree;
}(_common.ComBase), _class.propTypes = {
  className: _propTypes2.default.string,
  dataSource: _propTypes2.default.array,
  nodeLabel: _propTypes2.default.node,
  nodeActions: _propTypes2.default.node,
  arrow: _propTypes2.default.node
}, _temp);
exports.default = Tree;
module.exports = exports['default'];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Arrow = function Arrow(_ref) {
  var collapsed = _ref.collapsed,
      onClick = _ref.onClick;
  return _react2.default.createElement('div', {
    className: (0, _common.cname)({
      'tree-node-arrow': true,
      'tree-node-arrow-collapsed': collapsed
    }),
    onClick: onClick
  });
};

var TreeNode = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(TreeNode, _ComBase);

  function TreeNode() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TreeNode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      collapsed: _this.props.data.collapsed,
      actionsVisible: false,
      actions: null
    }, _this.handleTitleMouseEnter = function () {
      if (_this.state.actionsVisible || !_this.props.nodeActions) return;
      _this.setState({ actionsVisible: true });
    }, _this.handleTitleMouseLeave = function () {
      _this.state.actionsVisible && _this.setState({ actionsVisible: false });
    }, _this.handleArrowClick = function () {
      _this.setState({ collapsed: !_this.state.collapsed }, function () {
        _this.props.data.onCollapseChanged && _this.props.data.onCollapseChanged({ collapsed: _this.state.collapsed });
      });
    }, _this.renderArrow = function () {
      var collapsed = _this.state.collapsed;
      var _this$props = _this.props,
          arrow = _this$props.arrow,
          data = _this$props.data;

      if (arrow) return _react2.default.createElement(arrow, { collapsed: collapsed, onClick: _this.handleArrowClick, data: data });

      return _react2.default.createElement(Arrow, { collapsed: collapsed, onClick: _this.handleArrowClick });
    }, _this.renderLabel = function () {
      var actionsVisible = _this.state.actionsVisible;
      var _this$props2 = _this.props,
          nodeLabel = _this$props2.nodeLabel,
          data = _this$props2.data,
          nodeActions = _this$props2.nodeActions;
      var title = data.title;


      var element = nodeLabel ? _react2.default.createElement(nodeLabel, data) : title;
      var actions = nodeActions ? _react2.default.createElement(nodeActions, data) : null;

      return _react2.default.createElement(
        'div',
        {
          onMouseEnter: _this.handleTitleMouseEnter,
          onMouseLeave: _this.handleTitleMouseLeave
        },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('tree-node-title') },
          element
        ),
        actionsVisible && _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('tree-node-actions') },
          actions
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  TreeNode.prototype.render = function render() {
    var collapsed = this.state.collapsed;
    var _props = this.props,
        arrow = _props.arrow,
        nodeLabel = _props.nodeLabel,
        nodeActions = _props.nodeActions,
        childNodes = _props.data.children;


    var isLeaf = !(childNodes && childNodes.length > 0);

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('tree-node') },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('tree-node-inner') },
        !isLeaf && this.renderArrow(),
        this.renderLabel()
      ),
      !isLeaf && _react2.default.createElement(
        'div',
        { className: (0, _common.cname)({
            'tree-node-children': !collapsed,
            'tree-node-children-collapsed': collapsed
          }) },
        childNodes.map(function (n, i) {
          return _react2.default.createElement(TreeNode, {
            key: i,
            arrow: arrow,
            nodeLabel: nodeLabel,
            nodeActions: nodeActions,
            data: n
          });
        })
      )
    );
  };

  return TreeNode;
}(_common.ComBase), _class.propTypes = {
  arrow: _propTypes2.default.node,
  nodeLabel: _propTypes2.default.node,
  nodeActions: _propTypes2.default.node,
  data: _propTypes2.default.shape({
    title: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.node]),
    collapsed: _propTypes2.default.bool,
    onCollapseChanged: _propTypes2.default.func,
    children: _propTypes2.default.array
  })
}, _class.defaultProps = {
  data: {}
}, _temp2);
exports.default = TreeNode;
module.exports = exports['default'];

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

__webpack_require__(293);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {
  return false;
};

var Upload = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Upload, _ComBase);

  function Upload() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Upload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { files: [], status: 'normal', loaded: 0, total: 0 }, _this.onChange = function (event) {
      if (_this.xhr) {
        _this.xhr.abort();
        _this.xhr = null;
      }
      var files = [].slice.call(event.target.files);
      _this.setState({ files: files, status: 'ready', loaded: 0, total: 0 });
      var _this$props = _this.props,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? noop : _this$props$onChange,
          _this$props$auto = _this$props.auto,
          auto = _this$props$auto === undefined ? true : _this$props$auto,
          url = _this$props.url;

      onChange({ event: event, files: files });
      if (auto) _this.send(url);
    }, _this.send = function (url) {
      var formData = new FormData(_this.domNode);
      var xhr = _this.xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      if (xhr.upload && xhr.upload.addEventListener) {
        xhr.upload.addEventListener('progress', function (event) {
          return _this.onProgress(event);
        });
      }
      xhr.open('POST', url || _this.props.url, true);
      xhr.onload = function (event) {
        return _this.onUpload(event);
      };
      setTimeout(function () {
        return xhr.send(formData);
      }, 300);
    }, _this.onUpload = function (event) {
      if (!_this.xhr) return;
      var _this2 = _this,
          xhr = _this2.xhr;
      var files = _this.state.files;
      var _this$props2 = _this.props,
          _this$props2$onDone = _this$props2.onDone,
          onDone = _this$props2$onDone === undefined ? noop : _this$props2$onDone,
          _this$props2$checkSta = _this$props2.checkStatus,
          checkStatus = _this$props2$checkSta === undefined ? Upload.checkStatus : _this$props2$checkSta;

      onDone({ event: event, xhr: xhr, files: files });
      if (checkStatus({ event: event, xhr: xhr, files: files })) {
        _this.onSuccess(event);
      } else {
        _this.onError(event);
      }
    }, _this.onProgress = function (event) {
      if (!_this.xhr) return;
      var _this3 = _this,
          xhr = _this3.xhr;
      var files = _this.state.files;
      var _this$props$onProgres = _this.props.onProgress,
          onProgress = _this$props$onProgres === undefined ? noop : _this$props$onProgres;

      onProgress({ event: event, xhr: xhr, files: files });
      var loaded = event.loaded,
          total = event.total;

      _this.setState({ status: 'progress', loaded: loaded, total: total });
    }, _this.onSuccess = function (event) {
      if (!_this.xhr) return;
      var _this4 = _this,
          xhr = _this4.xhr;
      var files = _this.state.files;
      var _this$props$onSuccess = _this.props.onSuccess,
          onSuccess = _this$props$onSuccess === undefined ? noop : _this$props$onSuccess;

      onSuccess({ event: event, xhr: xhr, files: files });
      _this.setState({ status: 'success' });
    }, _this.onError = function (event) {
      if (!_this.xhr) return;
      var _this5 = _this,
          xhr = _this5.xhr;
      var files = _this.state.files;
      var _this$props$onError = _this.props.onError,
          onError = _this$props$onError === undefined ? noop : _this$props$onError;

      onError({ event: event, xhr: xhr, files: files });
      _this.setState({ status: 'error' });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Upload.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? true : _props$visible,
        _props$size = _props.size,
        size = _props$size === undefined ? 'medium' : _props$size,
        others = (0, _objectWithoutProperties3.default)(_props, ['className', 'visible', 'size']);

    var classNames = (0, _common.cname)((_cname = {
      upload: true,
      widget: true
    }, _cname['size-' + size] = size, _cname.aniTransition = true, _cname.stateHidden = !visible, _cname.stateVisible = visible, _cname), className);
    return _react2.default.createElement(
      'form',
      (0, _extends3.default)({}, (0, _common.transportProps)(others), {
        'data-status': this.state.status,
        className: classNames,
        encType: 'multipart/form-data' }),
      this.renderFilePicker(),
      this.renderContent(),
      this.renderProgress()
    );
  };

  Upload.prototype.renderFilePicker = function renderFilePicker() {
    var _props2 = this.props,
        className = _props2.className,
        style = _props2.style,
        others = (0, _objectWithoutProperties3.default)(_props2, ['className', 'style']); //eslint-disable-line

    return _react2.default.createElement('input', (0, _extends3.default)({}, (0, _common.transportProps)(others), {
      onChange: this.onChange,
      className: (0, _common.cname)('file'),
      type: 'file' }));
  };

  Upload.prototype.renderContent = function renderContent() {
    var _props3 = this.props,
        _props3$text = _props3.text,
        text = _props3$text === undefined ? '选择文件...' : _props3$text,
        children = _props3.children;
    var files = this.state.files;

    if (children) return children;
    var fileNames = files.map(function (file) {
      return file.name;
    }).join('/');
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('content') },
      fileNames && fileNames.length > 0 ? fileNames : text
    );
  };

  Upload.prototype.renderProgress = function renderProgress() {
    var _state = this.state,
        loaded = _state.loaded,
        total = _state.total;

    return _react2.default.createElement('div', { className: (0, _common.cname)('progress  aniTransition'),
      style: { width: loaded / total * 100 + '%' } });
  };

  return Upload;
}(_common.ComBase), _class.checkStatus = function (_ref) {
  var xhr = _ref.xhr;

  return xhr.status == 200;
}, _temp2);
exports.default = Upload;
module.exports = exports['default'];

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(25);

var _stringify2 = _interopRequireDefault(_stringify);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _rules = __webpack_require__(295);

var _rules2 = _interopRequireDefault(_rules);

__webpack_require__(296);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Verification = function () {
  Verification.fromElement = function fromElement(element) {
    var _element$props = element.props,
        children = _element$props.children,
        rule = _element$props.rule,
        others = (0, _objectWithoutProperties3.default)(_element$props, ['children', 'rule']);

    if (!rule) {
      var elements = _common.utils.findChildren(Validator, children);
      rule = elements.map(function (child) {
        return Verification.fromElement(child);
      });
    }
    return new Verification((0, _extends3.default)({}, others, { rule: rule }));
  };

  function Verification(props) {
    (0, _classCallCheck3.default)(this, Verification);
    var _props$logic = props.logic,
        logic = _props$logic === undefined ? 'and' : _props$logic,
        _props$rule = props.rule,
        rule = _props$rule === undefined ? [] : _props$rule,
        _props$fail = props.fail,
        fail = _props$fail === undefined ? '' : _props$fail,
        _props$success = props.success,
        success = _props$success === undefined ? '' : _props$success;

    this.logic = logic;
    this.rule = _common.utils.isArray(rule) ? rule : [rule];
    this.fail = fail;
    this.success = success;
  }

  Verification.prototype.exec = function exec(rule, value) {
    rule.test = rule.test || rule;
    var result = _common.utils.isFunction(rule.test) ? rule.test(value) : rule.test === value;
    return result === true || result && result.status === true;
  };

  Verification.prototype.test = function test(value) {
    var logic = this.logic;

    return this[logic](value);
  };

  Verification.prototype.and = function and(value) {
    var _this = this;

    var rule = this.rule,
        fail = this.fail,
        success = this.success;

    var item = rule.find(function (item) {
      return !_this.exec(item, value);
    });
    var status = !item;
    var message = status ? success : item.fail || fail;
    return { status: status, message: message };
  };

  Verification.prototype.or = function or(value) {
    var _this2 = this;

    var rule = this.rule,
        fail = this.fail,
        success = this.success;

    var item = rule.find(function (item) {
      return _this2.exec(item, value);
    });
    var status = !!item;
    var message = status ? item.success || success : fail;
    return { status: status, message: message };
  };

  return Verification;
}();

var Validator = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Validator, _ComBase);

  function Validator() {
    (0, _classCallCheck3.default)(this, Validator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this3 = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args)));

    _this3.verification = Verification.fromElement(_this3);
    _this3.times = 0;
    return _this3;
  }

  Validator.prototype.componentDidMount = function componentDidMount() {
    this.checkUpdate(this.props);
    this._mounted = true;
  };

  Validator.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.checkUpdate(nextProps);
  };

  Validator.prototype.checkUpdate = function checkUpdate(props) {
    var nextValue = props.value;
    if (_common.utils.isObject(nextValue)) nextValue = (0, _stringify2.default)(nextValue);
    var shouldUpdate = this.prevValue !== nextValue;
    this.prevValue = nextValue;
    return shouldUpdate;
  };

  Validator.prototype.updateContainer = function updateContainer(status) {
    if (!this._container) {
      this._container = this.domNode && this.domNode.parentNode;
    }
    if (!this._container) return;
    if (status) {
      this._container.classList.add((0, _common.cname)('success'));
      this._container.classList.remove((0, _common.cname)('fail'));
    } else {
      this._container.classList.add((0, _common.cname)('fail'));
      this._container.classList.remove((0, _common.cname)('success'));
    }
  };

  Validator.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        value = _props.value,
        ignoreInit = _props.ignoreInit,
        className = _props.className,
        onValidate = _props.onValidate,
        _props$should = _props.should,
        should = _props$should === undefined ? this._mounted || !ignoreInit : _props$should;

    var _verification$test = this.verification.test(value),
        status = _verification$test.status,
        message = _verification$test.message;

    var shouldValidate = _common.utils.isFunction(should) ? should() : should;
    var times = this.times++;
    setTimeout(function () {
      if (onValidate) onValidate({ status: status, message: message, times: times });
      if (shouldValidate) _this4.updateContainer(status);
    }, 0);
    var classNames = (0, _common.cname)({
      validator: true,
      success: status,
      fail: !status,
      stateVisible: shouldValidate,
      stateHidden: !shouldValidate
    }, className);
    return _react2.default.createElement(
      'div',
      { className: classNames },
      message
    );
  };

  return Validator;
}(_common.ComBase), _class.Verification = Verification, _class.rules = _rules2.default, _temp);
exports.default = Validator;
module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = {
  required: function required(value) {
    return value && /.+/.test(value);
  },
  array: function array(value) {
    return _common.utils.isArray(value);
  },
  email: /[a-z0-9\-\_\.]+\@[a-z0-9\-\_\.]+/,
  number: function number(num) {
    return !isNaN(num);
  },
  len: function len(min, max) {
    return function (arr) {
      return arr && arr.length >= min && arr.length <= max;
    };
  },
  range: function range(min, max) {
    return function (num) {
      return num >= min && num <= max;
    };
  },
  lt: function lt(num) {
    return function (value) {
      return value < num;
    };
  },
  gt: function gt(num) {
    return function (value) {
      return value > num;
    };
  },
  lte: function lte(num) {
    return function (value) {
      return value <= num;
    };
  },
  gte: function gte(num) {
    return function (value) {
      return value >= num;
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _alert = __webpack_require__(103);

var _alert2 = _interopRequireDefault(_alert);

var _confirm = __webpack_require__(299);

var _confirm2 = _interopRequireDefault(_confirm);

var _toast = __webpack_require__(104);

var _toast2 = _interopRequireDefault(_toast);

var _message = __webpack_require__(301);

var _message2 = _interopRequireDefault(_message);

var _i18n = __webpack_require__(70);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { alert: _alert2.default, confirm: _confirm2.default, toast: _toast2.default, message: _message2.default, i18n: _i18n2.default };
module.exports = exports['default'];

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

exports.default = confirm;

var _alert = __webpack_require__(103);

var _alert2 = _interopRequireDefault(_alert);

var _i18n = __webpack_require__(70);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function confirm(content, opts) {
  opts = opts || (0, _create2.default)(null);
  opts.title = opts.title || _i18n2.default.current.confirm;
  opts.type = opts.type || null;
  opts.buttons = opts.buttons || [{
    text: _i18n2.default.current.cancel,
    shape: 'ghost'
  }, {
    text: _i18n2.default.current.ok,
    type: 'primary'
  }];
  return (0, _alert2.default)(content, opts);
}
module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

var _create = __webpack_require__(28);

var _create2 = _interopRequireDefault(_create);

exports.default = message;

var _toast = __webpack_require__(104);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(302);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function message(content, opts) {
  opts = opts || (0, _create2.default)(null);
  var className = opts.className || '';
  className += ' aps-message';
  return (0, _toast2.default)(content, (0, _assign2.default)(opts, { align: 'center', className: className }));
}
// import i18n from './i18n';
module.exports = exports['default'];

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});
//# sourceMappingURL=aps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/aps/dist/js/aps.js
// module id = 65
// module chunks = 58 59 60